const SUBEEZ_PRODUCT_NAME = 'Subeez';

/**
 * JavaScript file containing main functions used by all pages.
 * DEPENDENCIES:
 * - jQuery
 * - jQuery UI
 *
 * @package 	simPRO
 * @subpackage  JavaScript
 * @category    JavaScript
 * @version 	2010-08-01 1.0
 * @author  	simPRO Software
 **/

String.prototype.htmlEscape = function () {
    return this
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
};

String.prototype.htmlUnescape = function () {
    return this
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&#039;/g, "'")
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');
};

String.prototype.cleanSpecialCharacters = function () {
    //This replaces everything but printable characters, which prevents hidden things from being added which break some API calls.
    return this.replace(/[^\x20-\x7E]+/g, '');
};

String.prototype.regexEscape = function () {
    return this.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

String.prototype.ucFirst = function () {
    return this.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
    });
};

Number.prototype.htmlUnescape = function () {
    return String(this);
};

Number.prototype.htmlEscape = function () {
    return String(this);
};

// Function to check whether an element exists
$.fn.exists = function(){
    return $(this).length>0;
};

/**
 * Function to check if the content of an element has overflowed the boundaries of the element.
 * https://stackoverflow.com/a/9541579
 * @returns {boolean}
 */
$.fn.overflown = function () {
    var e = this[0];
    return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
};

// Function to check if an element is displayed on screen {Hilton}
$.fn.isOnScreen = function(){
    var win = $(window);
    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};
$.fn.numberFormat = function(){
    return this.each(function() {
        $(this)
            .toNumber()
            .formatCurrency({
                roundToDecimalPlace: -1,
                symbol: '',
                decimalSymbol: simPRODefaults.data("number-format-decimal"),
                digitGroupSymbol: simPRODefaults.data("number-format-separator"),
                negativeFormat: simPRODefaults.data("number-format-negative")
            });
    });
};
$.fn.currencyFormat = function(currency) {
    if (typeof currency === 'undefined') {
        currency = simPRODefaults.data("currency-symbol");
    }
    return this.each(function() {
        $(this)
            .toNumber()
            .formatCurrency({
                roundToDecimalPlace: 2,
                symbol: currency,
                decimalSymbol: simPRODefaults.data("number-format-decimal"),
                digitGroupSymbol: simPRODefaults.data("number-format-separator"),
                negativeFormat: simPRODefaults.data("number-format-negative")
            });
    });
};
$.fn.parseNumber = function () {
    let value = $(this).val();
    if (value.length) {
        const lastCharacter = value.charAt(value.length - 1);
        if (lastCharacter === ')' || lastCharacter === '.' || (lastCharacter >= '0' && lastCharacter <= '9')) {
            try {
                // for european formatting
                if (simPRODefaults.data('number-format-separator') === '.') {
                    value = value
                        .replace(new RegExp('\\' + simPRODefaults.data('number-format-separator'), 'g'), '')
                        .replace(new RegExp('\\' + simPRODefaults.data('number-format-decimal'), 'g'), '.');
                }
                // for all other formatting
                value = value.replace(/,| /g, '');
                // perform calculations
                value = math.evaluate(value);

            } catch (err) {
                $(this).attr('title', gettext('Unable to calculate value, please check formula.'));
                createToolTip($(this), true);
            }
        }
    }
    return value;
};
$.fn.getNumber = function() {
    let $this = this[0];
    return $($this).asNumber({
        symbol: simPRODefaults.data('currency-symbol'),
        decimalSymbol: simPRODefaults.data('number-format-decimal'),
        digitGroupSymbol: simPRODefaults.data('number-format-separator'),
        negativeFormat: simPRODefaults.data('number-format-negative')
    });
};
$.fn.widthPercent = function(){
    if ($(this).attr("style") && $(this).attr("style").indexOf("width:") != -1){
        return $.trim($(this).attr("style").split("width:")[1].split(";")[0]);
    } else {
        return $(this).css("width");
    }
};


/**
 * @param {array} list The items to be parsed
 * @param {int} length max length of the string before further items are appended as a count only
 * @return {string} The concatenated array as a string with overflow appended as a "+ [number of items]"
 */
function formatAsStringWithRemaining(list, length) {
    if (typeof length === "undefined") {
        length = 50;
    }
    const toBeIncluded = [];
    const itemCount = list.length;
    let lengthCount = 0;

    for (let i in list) {
        const item = list[i];
        lengthCount += item.length;

        if (!toBeIncluded.length || lengthCount <= length) {
            toBeIncluded.push(item);
            continue;
        }

        break;
    }

    const includeCount = toBeIncluded.length;
    const diff = itemCount - includeCount;
    const result = toBeIncluded.join(', ');

    if (diff === 0) {
        return result;
    }

    const appendedText = sprintf(gettext('+ %d more'), diff);

    return sprintf('%1$s %2$s', result, appendedText);
}

function initTimePicker(item) {
    var $this = $(item),
        options = {};
    options.timeOnly = true;

    if ($this.attr('ignoreDefaultTimeFormat') === "true") {
        options.timeFormat = 'hh:mm TT';
        options.ampm = true;
    } else {
        options.timeFormat = simPRODefaults.data("time-format");

        if (options.timeFormat == 'h:mm TT' || options.timeFormat == 'hh:mm TT') {
            options.ampm = true;
        } else {
            options.ampm = false;
        }
    }


    if ($this.hasClass("hideMinutes")){
        options.showMinute = false;
        options.stepMinute = 60;
    }
    if (parseInt($this.attr("stepMinute"))){
        options.stepMinute = parseInt($this.attr("stepMinute")) || 1;
    } else if ($this.hasClass("step15")){
        options.stepMinute = 15;
    } else if ($this.hasClass("step30")){
        options.stepMinute = 30;
    }
    if ($this.prop('disabled') || $this.attr('readonly') === 'readonly'){
        options.disabled = true;
    }
    $(item).datetimepicker(options);
    // Set up icon next to time picker
    $(item).attr("autocomplete", "off").after("<button type='button' id='" + item.id + "TimePicker' class='btnImg'><span class='time'>&nbsp;</span></button>");
    // Allow manual input of time (12/24hr) without a colon(:) - ex:1115
    $(item).on("change", function() {
        var $val = $(this).val();
        if (!$val) {
            return;
        }
        if ($val.indexOf(":") === -1) {
            $val = $val.slice(0, $val.length-2) + ":" + $val.slice($val.length-2);

        }
        if ($val.length === 4 && simPRODefaults.data("time-format") != 'h:mm') {
            $val = '0' + $val;
        }
        if ($val !== $(this).val()) {
            $(this).timepicker("setTime", $val);
        }
    });

    $(document).on('click', "#" + item.id + "TimePicker", function(){
        $(item).timepicker("show");
    });
}

// additional page specific functions to call after prepareDocument has run
var preparePages = ['preparePage'];
// avoid recursive calls to preparePage
var preparingPage = false;
// hotkey prevention
let hotkeyTriggered = false;

/* DEFAULT FUNCTIONALITY */
function prepareDocument(context){
    showImagesOnScreen();
    //try {
    if (context == null) {
        var context = $("#page");
    }

    // Dialog Boxes
    $("#dialog, #sessionDialog, #outlineDialog, #errorDialog, .hiddenDialog-js", context).each(function(index, item) {
        const $item = $(item);
        const isHiddenDialog = $item.hasClass("hiddenDialog-js");
        const hasLightbox = $item.find(".lightbox").length > 0;

        if (!isHiddenDialog || !hasLightbox) {
            const $titleElement = $item.find(".title");
            const title = $titleElement.html();
            $titleElement.remove();

            const noClose = $item.hasClass("noClose");
            const hiddenDialog = isHiddenDialog ? $item.attr("id") : false;

            let size = {};
            if ($item.attr("frameWidth")) {
                size.width = $item.attr("frameWidth");
            }

            if ($item.attr("frameHeight")) {
                size.height = $item.attr("frameHeight");
            }

            const draggable = $item.data('draggable');
            const footer = $item.data('footer') ;
            const content = $item.html();
            const dialog = createDialog(
              "customSystem",
              content,
              title,
              "",
              noClose,
              hiddenDialog,
              size,
              false,
              false,
              draggable,
              footer
            );

            dialog.addClass($item.attr("class"));

            if (dialog.hasClass("closeAlone")) {
                dialog.find('.close-js').addClass('dialogClose').removeClass('close-js');
            }

            $item.replaceWith(dialog);
        }
    });

    if (window.tinymce && simPRODefaults.length) {
        /**
         * Initialise the tinymce editors.
         */

        // Configure is called here because prepareDocument() may be called before the document.ready is fired.
        configureTinyMCE();
        // Get the path to the document font css file.
        var tinyMCE_cssDirectory = '/versions/' + simPRODefaults.data("build-version") + '/public/css/tiny_mce/';
        var content_css = tinyMCE_cssDirectory + simPRODefaults.data('default-font').toLowerCase() + '.css';
        var osfont_css = tinyMCE_cssDirectory + 'osfont.css';
        $(".htmlEditor-js", context).each(function () {
            var $this = $(this);
            $this.removeClass('htmlEditor-js').addClass('tinyMCEEditor');

            // Add or remove the document font css
            // It seems silly to do this with global settings but it's the easiest way.
            tinymce.settings['content_css'] = [tinyMCE_cssDirectory + '_global.css'];
            if ($this.hasClass('htmlEditor-useOSFont')) {
                tinymce.settings['content_css'].push(osfont_css);
            } else {
                tinymce.settings['content_css'].push(content_css);
            }

            tinymce.execCommand('mceAddEditor', false, $(this).attr("id"));
        });
    }

    // Load content for div frames
    var iframeCounter = 0;
    $(".iframe", context).filter(":visible").each(function(index, item) {
		if ($(item).attr("src") != "" && ($(item).is(":empty") || $(item).html().trim() == "")) {
            var dialogContainer = $(item).closest(".dialogBox");
            if (dialogContainer.exists()) {
                var src = $(item).attr("src");
                if (src.indexOf("?") == -1) {
                    src += "?";
                }
                src += "&iframe=true";
                $("<iframe id='iframeID" + iframeCounter + "' class='iframe' src='" + src + "' sandbox='allow-same-origin allow-scripts allow-forms allow-top-navigation allow-popups allow-popups-to-escape-sandbox allow-modals allow-downloads'></iframe>").appendTo(item).load(function () {
                    if (typeof iframeLoaded === "function") {
                        iframeLoaded(this);
                    }
                    $(this).contents().find("#main").on("click", ".dialogClose, .closeWindow", function () {
                        if ($(this).hasClass("cleanSession-js")) {
                            var cleanSessionData = "cleanSession=" + $(this).val();
                            if (typeof ($(this).attr('openHash')) !== 'undefined') {
                                cleanSessionData += "&cleanHash=" + $(this).attr('openHash');
                            }
                            $.ajax({
                                type: "POST",
                                data: cleanSessionData,
                                url: "../common/ajax/cleanSession.php"
                            })
                        }
                        if ($(this).hasClass("dialogClose")) {
                            if (!$(this).closest(".dialogBox").exists()) {
                                $(dialogContainer).remove();
                            }
                        }
                    });
                });
                iframeCounter++;
            } else {
                var $this = $(this);
                var type = 'GET';
                if ($(this).hasClass("gadget")) {
                    addLoadingImage($(this));
                } else {
                    showLoadingImage();
                }
                data = "";
                if ($(this).attr("target")) {
                    data += $("#" + $(this).attr("target")).serialize();
                    if (data != "") {
                        data += "&";
                        type = 'POST';
                    }
                }
                data += "ajaxCall=true";
                $.ajax({
                    type: type,
                    data: data,
                    url: $(item).attr("src"),
                    success: function (responseText) {
                        if (responseText != "") {
                            if ($("#content", responseText).html()) {
                                $(item).html($("#content", responseText).html());
                                // If content contains a script tag, retrieve and run that script
                                var script = $("div.javascript", responseText).attr("src");
                                if (script != null) {
                                    $.ajax({
                                        type: "GET",
                                        url: script
                                    });
                                }
                                prepareDocument($(item));
                                if ($($this).attr("callback")) {
                                    window[$($this).attr("callback")]();
                                }
                            } else {
                                let $item = $(item);
                                $item.html(responseText);
                                prepareDocument($item);
                            }
                        } else {
                            // If blank content is returned, set HTML as &nbsp; to prevent iframe from trying to load again
                            $(item).html("&nbsp;");
                        }
                        hideLoadingImage();
                    },
                    // If request fails (external url), show content in an iframe
                    error: function(jqXHR, textStatus, errorThrown) {
                        $(item).html("<iframe class='iframe' src='" + $(item).attr("src") + "' sandbox='allow-same-origin allow-scripts allow-forms allow-top-navigation allow-popups allow-popups-to-escape-sandbox allow-modals'></iframe>");
                        hideLoadingImage();
                    },
                    complete: function(){
                        if ($(this).hasClass("gadget")) {
                            removeLoadingImage($(this));
                        }
                        if (simPRODefaults.data("scrollbar") !== '') {
                            $(window).scrollTop(simPRODefaults.data("scrollbar"));
                            simPRODefaults.data("scrollbar","");
                        }
                    }
                });
            }
        }
    });
    // code to fix iframe scroll on apple mobile products
    if (/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
        $('iframe').not(".hasAppleScrollFix, #downloadZipIframe").each(function() {
            let iframe = $(this);
            if (!iframe.closest(".mce-tinymce").exists()) {
                iframe.wrap(function () {
                    let $this = $(this);
                    $this.addClass('hasAppleScrollFix');
                    return $('<div/>').css({
                        width: $this.width(),
                        height: $this.height(),
                        overflow: 'auto',
                        '-webkit-overflow-scrolling': 'touch'
                    });
                });
            }
        });
    }
    $(".placesAutocomplete", context).each(function() {
        const $this = $(this);
        $this.autocomplete({
            delay: 300,
            minLength: 3,
            source: function( request, response ) {
                let showResults = function (results) {
                    let data = [];
                    let duplicates = [];
                    $.each(results, function () {
                        if (this.address) {
                            let addressData = this.address;
                            let parts = [];
                            if (addressData.name) {
                                if (!addressData.road || addressData.road !== addressData.name) {
                                    parts.push(addressData.name)
                                }
                            }
                            let address = '';
                            if (addressData.house_number) {
                                parts.push(addressData.house_number + " " + addressData.road);
                            } else if (addressData.road) {
                                parts.push(addressData.road);
                            }
                            if (addressData.suburb) {
                                parts.push(addressData.suburb);
                            } else if (addressData.city) {
                                parts.push(addressData.city);
                            }
                            if (addressData.state_code) {
                                let stateCode = addressData.state_code.toUpperCase();
                                if (simPRODefaults.data("build-country") === 'Australia') {
                                    if (stateCode === 'QL') {
                                        stateCode = 'QLD';
                                    } else if (stateCode === 'TS') {
                                        stateCode = 'TAS';
                                    }
                                }
                                parts.push(stateCode);
                            } else if (addressData.state) {
                                parts.push(addressData.state);
                            } else if (addressData.county) {
                                parts.push(addressData.county);
                            }
                            if (addressData.postcode && addressData.postcode !== 'UNDEFINED') {
                                parts.push(addressData.postcode);
                            }
                            if (addressData.country) {
                                parts.push(addressData.country);
                            }
                            this.label = parts.join(', ');
                            this.value = this.label;
                            if (duplicates.indexOf(this.label) === -1) {
                                duplicates.push(this.label);
                                data.push(this);
                            }
                        }
                    });
                    if (!data.length) {
                        data.push({
                            "label": gettext('No suggestions found...'),
                            "value": ''
                        });
                    }
                    response(data);
                }
                let options = {};
                let geocoder = getGeocoder();
                options.country = simPRODefaults.data("country");
                let statecodes = ["Australia", "United States"];
                if (statecodes.includes(simPRODefaults.data("build-country"))) {
                    options.statecode = 1;
                    options.v3 = 1;
                }
                geocoder.autoComplete(request.term, showResults,options);
            },
            select: function( event, ui ) {
                let data = $this.data();
                let addressData = ui.item.address;
                if (addressData) {
                    if (addressData.suburb) {
                        $(data.suburb).val(addressData.suburb);
                    } else if (addressData.city) {
                        $(data.suburb).val(addressData.city);
                    } else {
                        $(data.suburb).val(addressData.county);
                    }
                    if (addressData.postcode && addressData.postcode !== 'UNDEFINED') {
                        $(data.postcode).val(addressData.postcode);
                        if (data.postcode == '#locationPostcode') {
                            $(data.postcode).trigger("change");
                        }
                    }

                    let addressInput = $(data.address);
                    let address = "";
                    if (addressData.name) {
                        if (!addressData.road || addressData.road !== addressData.name) {
                            address = addressData.name;
                        }
                    }
                    if (addressData.house_number) {
                        if (address !== '') {
                            address += '\n';
                        }
                        address += addressData.house_number + " " + addressData.road;
                    } else if (addressData.road) {
                        if (address !== '') {
                            address += '\n';
                        }
                        address += addressData.road;
                    }
                    addressInput.val(address);
                    if (addressInput.hasClass("checkExists")) {
                        checkExists(addressInput);
                    }
                    let stateCode = null;
                    if (simPRODefaults.data("build-country") === 'Canada') {
                        stateCode = addressData.state;
                    } else if (addressData.state_code) {
                        stateCode = addressData.state_code.toUpperCase();
                        if (simPRODefaults.data("build-country") === 'Australia') {
                            if (stateCode === 'QL') {
                                stateCode = 'QLD';
                            } else if (stateCode === 'TS') {
                                stateCode = 'TAS';
                            }
                        }
                    }
                    let stateInputs = $(data.state);
                    if (stateCode !== null) {
                        let stateInput = stateInputs.first();
                        if (stateInput.hasClass('hide')) {
                            stateInput = stateInputs.last();
                            stateInput.val(stateCode);
                        } else {
                            if (!stateInput.find("option[value='" + stateCode + "']").exists()) {
                                stateInput
                                    .suggestselect("hide")
                                    .suggestselect("disable")
                                    .nextAll("input.otherState:first")
                                    .removeClass('hide')
                                    .val(stateCode)
                                    .prop("disabled", false)
                                    .removeClass("readonly");
                            } else {
                                stateInput.val(stateCode).suggestselect("refresh");
                            }
                        }
                    } else {
                        let stateInput = stateInputs.first();
                        stateInput.val(addressData.state);
                    }
                    $this.val("");
                    $this.blur();
                }
                return false;
            }
        });
    }).on('focus', function() {
        $(this).autocomplete("search");
    });
	// Autocompletes / select boxes
    autocompleteXHR = false;
    globalSearch = false;

    /**
     * 'item' is the form input which is to be converted to a suggest select.
     */
    $('input.autoComplete-js, select:not([data-enhance="false"])', context).each(function(index, item) {
        // Position of the suggestselect dropdown
        var position = {
            "my": "left top",
            "at": "left bottom",
            "using": function(){
                // If item can't fit downwards, show it upwards unless it will go off the top of the screen
                var offset = $(this).offset();
                if (offset.top + $(this).height() > $(window).height() + $(window).scrollTop()){
                    $(this).position({
                        "my": "left bottom",
                        "at": "left top",
                        "collision": "flip",
                        "of": $(item).data("suggestselect").suggestselect
                    });
                }
            }
        };

        if ($(item).is("select")){
            // Add suggestselect functionality to standard select inputs
            // Can be explicitly disabled by adding data-enhance="false"

            // Add a filter input to Select inputs with more than 10 options.
            // Can be explicitly enabled / disabled by adding data-filter="true" or data-filter="false"
            var filter = $(item).get(0).options.length > 10 || ($(item).data("filter") !== undefined ? $(item).data("filter") : false);
            var selectAllOption = $(item).data("selectalloption") !== undefined ? $(item).data("selectalloption") : true;
            var label = $(this).data("nothingselectedlabel") ? $(this).data("nothingselectedlabel") : "0 Selected";

            $(item).suggestselect({
                "position": position,
                "filter": filter,
                "nothingSelectedLabel": label,
                "selectAllOption": selectAllOption
            });
        } else {
            // Autocompletes

            var custom = $(item).hasClass("custom");

            // A list of classes to add to the results dropdown <ul>
            var resultsClasses = "";

            // How many characters must be typed before suggestions are shown?
            var minLength = $(item).attr("minlength") && !custom ? $(item).attr("minlength") : 0;

            if (custom){
                // Custom autocomplete.
                // This allows you to use lists of lists like a collection of "suggested text"
                // See /application/staff/segments/editEmployee/items/profile/licences.php for an example.

                var results = [];
                var list = $("ul#" + $(this).attr("href"));
                var categories = $(list).find("li[label]");
                $(categories).each(function(index, category) {
                    var categoryName = $(category).attr("label");
                    var listItems = $(category).find("li");
                    $(listItems).each(function(index, listItem) {
                        var description = $(listItem).attr("description") ? $(listItem).attr("description").replace("\n", "<br />") : "";
                        // Need to use getAttribute("value") as attr("value") returns an integer
                        var value = $(listItem).attr("value") ? listItem.getAttribute("value") : "";
                        results.push({
                            "category": categoryName,
                            "label": $(listItem).text(),
                            "subLabel": description,
                            "value": value
                        });
                    });
                });
            } else {
                // Standard autocomplete inputs

                resultsClasses += "autocomplete";

                // This is the function that gets called after typing something into a suggestselect input.
                // It makes an ajax request (to /common/autoComplete.php by default)
                // The returned json data is fed into suggestselect._showResults()
                var results = function(searchText, $this){
                    if (globalSearch) {
                        return;
                    }

                    // Cancel any running autocomplete ajax requests
                    if (autocompleteXHR){
                        autocompleteXHR.abort();
                    }

                    if($(item).attr('url')) {
                        var url = $(item).attr('url');
                    } else {
                        var url = '/common/autoComplete.php';
                    }

                    // Add /testing or /profiler to the url if preset
                    url = (document.URL.indexOf('/testing/') != -1) ? '/testing' + url : url;
                    url = (document.URL.indexOf('/profiler/') != -1) ? '/profiler' + url : url;

                    // Build the URL query string based on the html attributes of the input
                    var attributesValue = getItemSearchAttributesValue(item);
                    var data =
                        "searchText=" + encodeURIComponent(searchText)
                        + "&searchType=" + attributesValue['searchType']
                        + "&maxRows=" + attributesValue['maxRows']
                        + "&maxRowsType=" + attributesValue['maxRowsType']
                        + "&displayMode=" + attributesValue['displayMode']
                        + "&noResults=" + attributesValue['noResults']
                        + attributesValue['params'];

                    // Add custom filters (customerID, siteID etc.) if set
                    // Attributes can be hard coded values or jquery selectors.
                    // NOTE: jQuery selectors MUST start with a #, meaning whatever they are selecting must have an ID.
                    // The use of jQuery selectors as filter values is how the filter-by-type radio buttons work.
                    // See /application/staff/invoices.php for an example.
                    var attributes = $(item)[0].attributes;
                    for (var i = 0; i < attributes.length; i++){
                        attribute = attributes[i];
                        if (attribute.nodeName.indexOf("filter-") != -1){
                            var filterName = attribute.nodeName;
                            var filterValue = $(item).attr(filterName).split("&");
                            if (filterName == "filter-includeids" || filterName == "filter-excludeids" || filterName == "filter-searchcurrency"){
                                filterName += "[]";
                            }
                            $.each(filterValue, function(index, item) {
                                if (item.indexOf("#") != -1){
                                    if ($(item).exists() && $(item).val() != "" && $(item).val() != 0){
                                        data += "&" + filterName.replace("filter-", "") + "=" + $(item).val();
                                    }
                                } else {
                                    if (item != "" && item != 0){
                                        data += "&" + filterName.replace("filter-", "") + "=" + item;
                                    }
                                }
                            });
                        }
                    }

                    // Add result types (customers, jobs etc.) if set. If none are set, all result types will show.
                    var resultTypes = [
                        "customers",
                        "jobs",
                        "quotes",
                        "leads",
                        "invoices",
                        "contractor",
                        "suppliers",
                        "purchaseorders",
                        "catalogue",
                        "prebuilds",
                        "kits",
                        "sites",
                        "assets",
                        "plant",
                        "tasks",
                        "employees",
                        "contractors",
                        "clientcontacts",
                        "sitecontacts",
                        "contacts",
                        "zones",
                        "sectiondepartments",
                        "activities",
                        "manufacturers",
                        "storageLocations",
                        "originCountries",
                        "excludeMembership",
                        "assetTypes",
                        "failurepoints"
                    ];

                    var classes = $(item)[0].className.split(/\s+/);
                    for (var i = 0; i < classes.length; i++){
                        var className = classes[i];
                        if ($.inArray(className, resultTypes) != -1){
                            data += "&" + className + "=true";
                        }
                    }

                    // Actually start the ajax request
                    autocompleteXHR = $.ajax({
                        url: url,
                        dataType: "json",
                        type: "POST",
                        data: data,
                        success: function(data) {
                            var autocompleteResults = $.map(data, function(item) {
                                item.subLabel = item.description;
                            });
                            $this.suggestselect("_showResults", data);
                        }
                    });
                };
                // End of the standard autocomplete results function
            }

            // When doing client-side (ie not ajax) searching, how should matching be done?
            // Options are 'contains' or 'begins'.
            var ssMode = ($(item).data('suggestselectmode')) ? $(item).data('suggestselectmode') : 'contains';

            $(item).suggestselect({
                "resultsClasses": resultsClasses,
                "minLength": minLength,
                "results": results,
                "position": position,
                "mode": ssMode,

                "open": function(element){
                    // When the suggest select results dropdown opens
                    // Add radio buttons to filter the type(s) of results returned.
                    // See /application/staff/invoices.php for an example.
                    // The selected radio button is picked up by the results() function above
                    // when it processes the attributes of the input.
                    if ($(item).attr("data-filtercontrol")){
                        var filterPanel = $("<li class='filterPanel'></li>").prependTo(element);
                        var filterControls = $($(item).attr("data-filtercontrol"));
                        $.each(filterControls, function(index, filterControl) {
                            var label = $("<label class='halfMarginLeft'> " + $(filterControl).closest("label").text() + "</label>").appendTo(filterPanel);
                            if ($(filterControl).is(":checked")){
                                var checked = " checked='checked'";
                            } else {
                                var checked = "";
                            }
                            $("<input type='radio' name='filterControl' data-" + $(filterControl).attr("name") + " value='" + $(filterControl).val() + "'" + checked + " />").prependTo(label).click(function(){
                                var value = $(this).val();
                                $.each(filterControls, function(index, filterControl) {
                                    if ($(filterControl).val() == value) {
                                        $(this).prop("checked", true);
                                        if ($(filterControl).data('click-original')) {
                                            $(filterControl).click();
                                        } else  {
                                        $(this).trigger("filterclick");
                                            $(item).suggestselect("search", $(item).val(), true);
                                        }
                                    } else {
                                        $(this).prop("checked", false);
                                    }
                                });
                            });
                        });
                    }
                },

                "search": function(element){
                    // This callback is triggered after we have the search results but before the
                    // results dropdown has been displayed.
                    // We use it to show / hide category headings.

                    var options = $(element).find("li");

                    // Find category dividers in the results list.
                    var categories = [];
                    var categoryCount = 0;
                    $(options).each(function(index, item) {
                        if ($(item).hasClass("category") && index != options.length - 1){
                            categories.push(item);
                            if (custom){
                                categoryCount++;
                            }
                        }
                    });

                    if (!custom){
                        var resultTypes = [
                            "customers",
                            "jobs",
                            "quotes",
                            "leads",
                            "invoices",
                            "contractor",
                            "suppliers",
                            "purchaseorders",
                            "catalogue",
                            "prebuilds",
                            "kits",
                            "sites",
                            "assets",
                            "plant",
                            "tasks",
                            "employees",
                            "contractors",
                            "contacts",
                            "sitecontacts",
                            "clientcontacts",
                            "zones",
                            "sectiondepartments",
                            "activities",
                            "manufacturers",
                            "storageLocations",
                            "originCountries",
                            "quicksearch",
                            "assetTypes",
                            "failurepoints"
                        ];
                        var classes = $(item)[0].className.split(/\s+/);
                        for (var i = 0; i < classes.length; i++){
                            var className = classes[i];
                            if ($.inArray(className, resultTypes) != -1){
                                categoryCount++;
                            }
                        }
                        if (categoryCount == 0){
                            // Autocomplete with no classes (eg. global search) will check all result types
                            categoryCount = resultTypes.length;
                        }
                    }

                    // Hide category headings if less than 2 are found
                    if (categoryCount <= 1){
                        $.each(categories, function(index, item) {
                            $(item).hide();
                            categoryCount--;
                        });
                    }

                    // It used to be that categories were shown on the left and results on the right
                    // but it looks like these extra classes do nothing now as headings appear
                    // at the top of the list of options.
                    if (categoryCount > 0){
                        $.each(categories, function(index, item) {
                            $(item).addClass("categoryLeft").before($("<li class='clear'></li>"));
                        });
                        $(element).find(".option").addClass("optionRight");
                        $(item).suggestselect("refresh");
                    }
                },

                "select": function(element, event){
                    if ($(item).attr("id") == "globalSearch"){
                        // Open profile of clicked result
                        if (element.href.indexOf("taskDetails.php") != -1){
                            window.open(element.href, "", "width=1175,height=740,left=100,top=100,screenX=100,screenY=100,resizable=no,scrollbars=yes");
                        } else {
                            openLink(simPRODefaults.data('app-type') + element.href, event);
                        }
                    } else {
                        if (element.category == "No_Category"){
                            return false;
                        } else {
                            $(item).val(element.label.htmlUnescape());
                            var name = $(item).attr("name");
                            var category = name;
                            if (name.indexOf("[]") != -1){
                                name = name.replace("[]", "") + "Callback[]";
                                category = category.replace("[]", "") + "CallbackCategory[]";
                            } else {
                                name += "Callback";
                                category += "CallbackCategory";
                            }
                            var id = $(item).attr("id") + "Callback";
                            $("#" + id).remove();
                            var callback = $("<input type='hidden' name='" + name + "' id='" + id + "' value='" + element.value + "' />");
                            $(item).after(callback);
                            let categoryValue = '';
                            if (element.category) {
                                if (element.categoryValue) {
                                    categoryValue = element.categoryValue;
                                } else {
                                    categoryValue = element.category;
                                }
                                $("#" + id + "Category").remove();
                                var callbackCategory = $("<input type='hidden' name='" + category + "' id='" + id + "Category' value='" + categoryValue + "' />");
                                $(item).after(callbackCategory);
                            }
                            if ($(item).attr("callback")){
                                window[$(item).attr("callback")](element.value, categoryValue.toLowerCase(), $(event.target), $(item), element);
                            }
                            if ($(item).hasClass("ajaxSubmit")){
                                ajaxSubmit($(item), $(item).attr("params"));
                            }
                            $(item).css("background", "").blur();
                        }
                    }
                },
                "close": function(element){
                    var data = $(item).data("suggestselect");
                    if($(item).val() != "" && data.initialValue != null && $(item).val() != data.initialValue && $(item).hasClass("required")) {
                        // required field
                        if($(item).hasClass("mandatory")) {
                            $(item).addClass("invalidInput");
                        }
                        var title = $(item).data("title");
                        if (title) {
                            $(item).attr('title', title);
                            createToolTip($(item), true);
                        }
                    } else if($(item).val() == "" && data.initialValue != null && $(item).val() != data.initialValue) {
                        // cleared value
                        if(typeof($(item).data('default-value')) !== 'undefined') {
                            $("#" + $(item).attr("id") + "Callback, #" + $(item).attr("id") + "CallbackCategory").val($(item).data('default-value'));
                        } else {
                            $("#" + $(item).attr("id") + "Callback, #" + $(item).attr("id") + "CallbackCategory").remove();
                        }
                        if($(item).attr("callback")) {
                            //this parameter structure is related to 'setPrebuildData()' in 'customer.js', hoping it is standard structure because it is same in 'select' option above
                            window[$(item).attr("callback")](undefined, undefined, undefined, element);
                        } else if($(item).hasClass("ajaxSubmit")) {
                            ajaxSubmit($(item), $(item).attr("params"));
                        }
                    } else {
                        $(item).removeClass("invalidInput");
                    }
                    $(item).removeClass("autocomplesearching");
                }
            });
        }
    });

    $(context).find("input.selectAll[href]").each(function(){
        var href = $(this).attr("href");
        var classBased = true;
        if (href.charAt(0) != "."){
            href = "input[name='" + href + "']:not(:disabled)";
            classBased = false;
        }
        $(context).off('click.selectAll').on('click.selectAll', href, function(){

            var name = $(this).attr('name');
            if(classBased) {
                $("input.selectAll[href='" + href + "']").prop("checked", $(href).not(":checked").length == 0);
            } else {
                $("input.selectAll[href='" + name + "']").prop("checked", $("input[name='" + name + "']").not(":checked").length == 0);
            }
        });
    });

    // Table column sorter
    $(".tableSorter", context).filter(":visible").each(function() {
        $(this).tablesorter({
            dateFormat: simPRODefaults.data("tablesorter-date-format"),
            usThousandSeparator: simPRODefaults.data("number-format-separator"),
            widgets: ['zebra', 'staticRow'],
            emptyTo: 'none',
            selectorSort: 'th:not(.ajaxOrder, .noSort), td:not(.ajaxOrder, .noSort)'
        });
        $(this).on('click', 'th:not(.ajaxOrder, .noSort), td:not(.ajaxOrder, .noSort)', function() {
            $(this).closest('tr').find('.current').removeClass('current');
            $(this).addClass('current');
        })

        //Adding pagination
        if($(this).hasClass("jPaginate")){
            $(this).bind("sortStart",function() {
                showLoadingImage();
            }).bind("sortEnd",function() {
                $(this).jPaginate({
                    'max': $(this).data("row_per_page"),
                    'max_navigation_pages': $(this).data("max_navigation_pages")
                });
                hideLoadingImage();
            });
        }
    });

    $('.table-edit', context).jSetupDynamicTables({save_text: gettext('Save'), add_text: gettext('Create'), edit_text: gettext('Edit'), ignore_classes: ['sortableHandle','tblplaceholder', 'icon-minus', 'icon-question']});

    // Table row reordering
    $(".sortable", context).filter(":visible").sortable({
        tolerance: "touch",
        helper: function(event, ui) {
            ui.children().each(function() {
                $(this).width($(this).width());
            });
            return ui;
        },
        items: function() {
            // The sortableDisabled class only works for rows at the start / end of a table.
            // Rows in the middle can't be moved directly but can be 'sorted around'.
            return $(this).children().not(".sortableDisabled");
        },
        create: function(event, ui) {
            var $this = $(this);
            var axis = $(this).attr("axis");
            if (axis){
                $this.sortable("option", "axis", axis);
            }
            var connectWith = $(this).attr("connectWith");
            if (connectWith){
                $this.sortable("option", "connectWith", connectWith);
            }
            var delay = $(this).attr("delay");
            if (delay){
                $this.sortable("option", "delay", delay);
            }
            var handle = $(this).attr("handle");
            if (handle){
                $this.sortable("option", "handle", handle);
            } else {
                $this.sortable("option", "handle", ".sortableHandle");
            }

            //for reorder list for test readings
            if ($(this).data("numbered")) {
                if($(this).parent('#trTable').length > 0) {
                   refreshSortableList($(this));
                }
            }
        },
        start: function(event, ui) {
            $(".ui-sortable-placeholder").height($(ui.item).height());
            $(ui.item).addClass("halfTransparent").find(".hideOnSort").css("visibility", "hidden").find(".graphContainer").hide();
            var element = $(".sortable:visible:last", context);
            if(element.is("tbody")) { // add some extra margin to make it easier to drop item at bottom
                element.closest("table").css("margin-bottom", "+=50");
            }
        },
        stop: function(event, ui) {
            $(ui.item).removeClass("halfTransparent").find(".hideOnSort").css("visibility", "visible").find(".graphContainer").show();
            var element = $(".sortable:visible:last", context);
            if(element.is("tbody")) {
                element.closest("table").css("margin-bottom", "");
            }
        },
        update: function(event, ui) {
            if (this === ui.item.parent()[0]) { // connect with fires event twice need to only do this once.   Cannot use receive as not called for non connect withs
                if ($(this).hasClass("ajaxSubmit")){
                    if ($(this).attr("target")){
                        var closestForm = $(this).closest($(this).attr("target"));
                    } else {
                        var closestForm = $(this).closest("form");
                    }
                    var data = "";
                    if ($(this).attr("connectWith")){
                        $($(this).attr("connectWith")).each(function(index, item) {
                            if (index > 0){
                                data += "&";
                            }
                            data += $(this).sortable("serialize");
                        });
                    } else {
                        data += $(this).sortable("serialize");
                    }
                    data += "&" + $(closestForm).find("*").serialize() + "&ajaxCall=true" + checkTabs();
                    var currentPage = $("#currentPageNo").val();
                    if (typeof currentPage !== "undefined") {
                        data += "&pageNo=" + currentPage;
                    }
                    data += "&movedItem=" + ui.item.attr("id");
                    showLoadingImage();
                    $.ajax({
                        type: "POST",
                        url: $(closestForm).attr("action"),
                        data: data,
                        success: function(responseText) {
                            if ($(this).attr("callback")){
                                var callback = $(this).attr("callback");
                            } else {
                                var callback = null;
                            }
                            showResponse(responseText, callback, true);
                        },
                        complete: function(xhr,textStatus){
                            ajaxComplete(xhr,textStatus);
                        }
                    });
                } else {
                    if ($(this).sortable("toArray") != ""){
                        if ($(this).attr("target")){
                            var closestForm = $(this).attr("target");
                        } else {
                            var closestForm = $(this).closest("form");
                        }
                        var sortableResults = $(this).sortable("toArray");
                        var name = sortableResults[0].split("_");
                        var name = name[0] + "[]";
                        $("input[name='" + name + "']").remove();

                        var currentPage = $("#currentPageNo").val();
                        if (typeof currentPage !== "undefined") {
                            $(closestForm).append("<input type='hidden' name='pageNo' value='" + currentPage + "' />");
                        }

                        $.each(sortableResults, function(index, item) {
                            var value = this.split("_");
                            if (typeof value[1] !== "undefined") {
                                value = value[1];
                                $(closestForm).append("<input type='hidden' name='" + name + "' value='" + value + "' />");
                            }
                            //for reorder list for test readings
                            if ($(this).data("numbered")) {
                                $('#' + item).find('td.sortIndex').text(index + 1);
                            }
                        });

                    }
                    if ($(this).attr("callback")){
                        window[$(this).attr("callback")]($(this), ui);
                    }
                }
            }
        }
    });

    //Pagination
    $(".jPaginate", context).filter(":visible, .overrideVisibleFilter").each(function() {
        $(this).jPaginate({
            'max': $(this).data("row_per_page"),
            'max_navigation_pages': $(this).data("max_navigation_pages")
        });
        $(this).stickyTableHeaders();
    });

    //Sticky Headers
    $(".tblStickyHeader", context).filter(":visible").each(function() {
        $(this).stickyTableHeaders();
    });
    // Place Holders
    $(".listBox-js[placeholder]:not(:has(div:visible, h5))", context).filter(":visible").each(function() {
        $(this).append('<h5 class="none textGrey">' +$(this).attr("placeholder") +'</h5>');
    });

    $(".listBox-js:has(div:visible)", context).filter(":visible").find("h5").remove();
    $(".tblplaceholder", context).remove();

    $("table[placeholder]:visible > tbody:not(:has(tr:visible))", context).each(function() {
        var columns = 0;

        $(this).prev().find("th").each(function() {
            if($(this).attr("colspan") !== undefined) {
                columns += $(this).attr("colspan");
            } else {
                columns++;
            }
        });

        $(this).append('<tr class="tblplaceholder read-only"><td colspan="' + columns + '">' +$(this).parent().attr("placeholder").htmlEscape() +'</td></tr>');
    });
    // Date pickers
    $("input.datePicker", context).each(function(index, item) {
        var $item = $(item);
        if ($item.data("initialised") === true){
            return true;
        }
        $item.data("initialised", true);
        let setMaxDate = null;

        if (typeof $item.data('pastonly') !== "undefined"){
            setMaxDate = Date.parse("Today");
        }
        if (typeof $item.attr('maxDate') !== "undefined"){
            setMaxDate = $item.attr("maxDate");
        }

        $item.datepicker({
            dateFormat: simPRODefaults.data("date-format"),
            disabled: $item.prop('disabled') || $item.attr('readonly') === 'readonly',
            showOtherMonths: true,
            selectOtherMonths: true,
            changeMonth: true,
            changeYear: true,
            yearRange: "-100:+30",
            showButtonPanel: true,
            minDate: $item.attr("minDate") ? $item.attr("minDate") : null,
            maxDate: setMaxDate,
            onClose: function() {
                if ($item.hasClass("ajaxSubmit")){
                    ajaxSubmit($(item),$(item).attr('params'));
                }
            }
        });
        // Set up icon next to date picker
        $(item).attr("autocomplete", "off").after("<button type='button' id='" + item.id + "DatePicker' class='btnImg'><span class='date'>&nbsp;</span></button>");
        $(context).delegate("#" + item.id + "DatePicker", "click", function(){
            $(this).datepicker("show");
        });
    });
    try {
        $("input.dateRangePicker", context).each(function(index, item) {
            if ($(item).data("initialised") === true){
                return true;
            }
            var workday = simPRODefaults.data("work-week");
            var today = Date.parse("today").getDay();
            var setMaxDate = null;
            var setMinDate = null;
            var setShowOtherMonths = true;
            var setSelectOtherMonths = true;
            var setChangeMonth = true;
            var setChangeYear = true;
            var setYearRange = "1930:2030";
            var setShowButtonPanel = true;
            var disableDays = [], disableRecurringDays = [];
            var setDateFormat = simPRODefaults.data("date-format");

            /*
				 *  Possible date range picker options:
				 *    data-presetranges [Disables the ability to select future dates]
				 *    data-disabledays = '29-02-2012, 25-12-2012' [Disable a specifc date (only disables specific dates)]
				 *    data-disablerecurringdays = '29-2' [Disable a date (same day will be disabled each year)]
				 *    maxDate = 'next month' [Specify the max date allowed]
				 *    minDate = 'next month' [Specify the max date allowed]
				 *    data-dateformat = 'd MM' [Do change the date of the returned format]
				 *    data-yearrange = '1930:2030' [To specify year range to show]
				 */

            // all presets as standard
            var presets = {
                specificDate: gettext("Specific Date"),
                allDatesBefore: gettext("All Dates Before"),
                allDatesAfter: gettext("All Dates After"),
                dateRange: gettext("Date Range")
            }


            //set up date ranges to use
            var possibleRanges = {
                "Today": {
                    text: gettext("Today"),
                    dateStart: "today",
                    dateEnd: "today"
                },
                "Tomorrow": {
                    text: gettext("Tomorrow"),
                    dateStart: function(){
                        return Date.parse("today").addDays(1);
                    },
                    dateEnd: function(){
                        return Date.parse("today").addDays(1);
                    }
                },
                "Yesterday": {
                    text: gettext("Yesterday"),
                    dateStart: function(){
                        return Date.parse("today").addDays(-1);
                    },
                    dateEnd: function(){
                        return Date.parse("today").addDays(-1);
                    }
                },
                "This week": {
                    text: gettext("This week"),
                    dateStart: function(){
                        return today != workday ? Date.parse("today").moveToDayOfWeek(workday, -1) : Date.parse("today");
                    },
                    dateEnd: function(){
                        return today != workday ? Date.parse("today").moveToDayOfWeek(workday, -1).addDays(6) : Date.parse("today").addDays(6);
                    }
                },
                "Last week": {
                    text: gettext("Last week"),
                    dateStart: function(){
                        return today != workday ? Date.parse("today").moveToDayOfWeek(workday, -1).addWeeks(-1) : Date.parse("today").moveToDayOfWeek(workday, -1);
                    },
                    dateEnd: function(){
                        return today != workday ? Date.parse("today").moveToDayOfWeek(workday, -1).addWeeks(-1).addDays(6) : Date.parse("today").moveToDayOfWeek(workday, -1).addDays(6);
                    }
                },
                "Next week": {
                    text: gettext("Next week"),
                    dateStart: function(){
                        return today != workday ? Date.parse("today").moveToDayOfWeek(workday, -1).addWeeks(1) : Date.parse("today").addWeeks(1);
                    },
                    dateEnd: function(){
                        return today != workday ? Date.parse("today").moveToDayOfWeek(workday, -1).addWeeks(1).addDays(6) : Date.parse("today").addWeeks(1).addDays(6);
                    }
                },
                "Week to date":	{
                    text: gettext("Week to date"),
                    dateStart: function(){
                        return today != workday ? Date.parse("today").moveToDayOfWeek(workday, -1) : Date.parse("today");
                    },
                    dateEnd: "today"
                },
                "This month": {
                    text: gettext("This month"),
                    dateStart: function(){
                        return Date.parse("today").moveToFirstDayOfMonth();
                    },
                    dateEnd: function(){
                        return Date.parse("today").moveToLastDayOfMonth();
                    }
                },
                "Last month": {
                    text: gettext("Last month"),
                    dateStart: function(){
                        return Date.parse("1 month ago").moveToFirstDayOfMonth();
                    },
                    dateEnd: function(){
                        return Date.parse("1 month ago").moveToLastDayOfMonth();
                    }
                },
                "Next month": {
                    text: gettext("Next month"),
                    dateStart: function(){
                        return Date.parse("next month").moveToFirstDayOfMonth();
                    },
                    dateEnd: function(){
                        return Date.parse("next month").moveToLastDayOfMonth();
                    }
                },
                "Month to date": {
                    text: gettext("Month to date"),
                    dateStart: function(){
                        return Date.parse("today").moveToFirstDayOfMonth();
                    },
                    dateEnd: "today"
                },
                "This Year": {
                    text: gettext("This Year"),
                    dateStart: function(){
                        var x = Date.parse('today');
                        x.setMonth(0);
                        x.setDate(1);
                        return x;
                    },
                    dateEnd: function(){
                        return Date.parse('today').moveToMonth("11").moveToLastDayOfMonth();
                    }
                },
                "Last Year": {
                    text: gettext("Last Year"),
                    dateStart: function(){
                        var x = Date.parse('today');
                        x.setMonth(0);
                        x.setDate(1);
                        return x;
                    },
                    dateEnd: function(){
                        return Date.parse('1 year ago').moveToMonth("11").moveToLastDayOfMonth();
                    }
                },
                "Year to date": {
                    text: gettext("Year to date"),
                    dateStart: function(){
                        var x = Date.parse('today');
                        x.setMonth(0);
                        x.setDate(1);
                        return x;
                    },
                    dateEnd: "today"
                },
                "Financial Year to date": {
                    text: gettext("Financial Year to date"),
                    dateStart: function(){
                        return Date.parse("today").moveToMonth(parseInt(simPRODefaults.data("financial-year-start"))-1).moveToFirstDayOfMonth().addYears("-1")
                    },
                    dateEnd: "today"
                },
                "This Financial Year": {
                    text: gettext("This Financial Year"),
                    dateStart: function(){
                        return Date.parse("today").moveToMonth(parseInt(simPRODefaults.data("financial-year-start"))-1).moveToFirstDayOfMonth().addYears("-1")
                    },
                    dateEnd: function(){
                        return Date.parse("today").moveToMonth(parseInt(simPRODefaults.data("financial-year-start"))-1).moveToFirstDayOfMonth().addYears("-1").addYears(1).addDays(-1)
                    }
                },
                "Last Financial Year": {
                    text: gettext("Last Financial Year"),
                    dateStart: function(){
                        return Date.parse("today").moveToMonth(parseInt(simPRODefaults.data("financial-year-start"))-1).moveToFirstDayOfMonth().addYears("-1").addYears("-1")
                    },
                    dateEnd: function(){
                        return Date.parse("today").moveToMonth(parseInt(simPRODefaults.data("financial-year-start"))-1).moveToFirstDayOfMonth().addYears("-1").addDays(-1)
                    }
                },
                "To date": {
                    text: gettext("To date"),
                    dateStart: function(){
                        return Date.parse("today").moveToFirstDayOfMonth().addYears("-30")
                    },
                    dateEnd: "today"
                }
            };
            var ranges, presetRanges =[];
            if (typeof $(item).data('presetranges') !== "undefined"){
                ranges = $(item).data('presetranges');
            } else if (typeof $(item).data('pastonly') !== "undefined"){
                ranges = [
                    'Today',
                    'Last week',
                    'Week to date',
                    'Last month',
                    'Month to date',
                    'Year to date',
                    'Financial Year to date',
                    'Last Financial Year'
                ];
                setMaxDate = Date.parse("Today");
                presets = {
                    specificDate: gettext("Specific Date"),
                    allDatesBefore: gettext("All Dates Before"),
                    dateRange: gettext("Date Range")
                }
            } else {
                ranges = [
                    'Today',
                    'Tomorrow',
                    'Yesterday',
                    'This week',
                    'Last week',
                    'This month',
                    'Last month',
                    'Next month',
                    'Month to date',
                    'Year to date',
                    'Financial Year to date',
                    'This Financial Year',
                    'Last Financial Year'
                ];
            }
            for(var i = 0, I=ranges.length; i < I; i++){
                if (possibleRanges.hasOwnProperty(ranges[i])){
                    presetRanges.push(possibleRanges[ranges[i]]);
                }
            }

            if (typeof $(item).attr('showOtherMonths') !== "undefined"){
                setShowOtherMonths = $(item).attr('showOtherMonths') === 'true';
            }
            if (typeof $(item).attr('selectOtherMonths') !== "undefined"){
                setSelectOtherMonths = $(item).attr('selectOtherMonths') === 'true';
            }
            if (typeof $(item).attr('changeMonth') !== "undefined"){
                setChangeMonth = $(item).attr('changeMonth') === 'true';
            }
            if (typeof $(item).attr('changeYear') !== "undefined"){
                setChangeYear = $(item).attr('changeYear') === 'true';
            }
            if (typeof $(item).attr('showButtonPanel') !== "undefined"){
                setShowButtonPanel = $(item).attr('showButtonPanel') === 'true';
            }
            if (typeof $(item).attr('maxDate') !== "undefined"){
                setMaxDate = Date.parse($(item).attr('maxDate'));
            }
            if (typeof $(item).attr('minDate') !== "undefined"){
                setMinDate = Date.parse($(item).attr('minDate'));
            }

            // data attributes
            if (typeof $(item).data('disabledays') !== "undefined"){
                disableDays = $(item).data('disabledays');
            }
            if (typeof $(item).data('disablerecurringdays') !== "undefined"){
                disableRecurringDays = $(item).data('disablerecurringdays');
            }
            if (typeof $(item).data('dateformat') !== "undefined"){
                setDateFormat = $(item).data('dateformat');
            }
            if (typeof $(item).data('yearrange') !== "undefined"){
                setYearRange = $(item).data('yearrange');
            }

            $(item).data("initialised", true);
            $(item).daterangepicker({
                dateFormat: setDateFormat,
                disabled: $(item).prop('disabled') || $(item).attr('readonly') === 'readonly',
                datepickerOptions: {
                    showOtherMonths: setShowOtherMonths,
                    selectOtherMonths: setSelectOtherMonths,
                    changeMonth: setChangeMonth,
                    changeYear: setChangeYear,
                    yearRange: setYearRange,
                    showButtonPanel: setShowButtonPanel,
                    maxDate: setMaxDate,
                    minDate: setMinDate,
                    beforeShowDay: function(input, inst) {
                        // Functon to call before showing days
                        var m = null;
                        var d = null;
                        var y = null;
                        if(disableDays.length) { // disable specific dates
                            var disabledDays = disableDays.split(',');
                            m = input.getMonth();
                            d = input.getDate();
                            y = input.getFullYear();
                            for (i = 0; i < disabledDays.length; i++) {
                                if($.inArray(d + '-' + (m+1) + '-' + y,disabledDays) != -1) {
                                    return [false];
                                }
                            }
                        }
                        if(disableRecurringDays.length) { // disable specific dates
                            var disabledRecurringDays = disableRecurringDays.split(',');
                            m = input.getMonth();
                            d = input.getDate();
                            for (i = 0; i < disabledRecurringDays.length; i++) {
                                if($.inArray(d + '-' + (m+1), disabledRecurringDays) != -1) {
                                    return [false];
                                }
                            }
                        }
                        return [true];
                    }
                },
                "presetRanges": presetRanges,
                "presets": presets,
                onClose: function() {
                    window.setTimeout( function() {
                        if ($(item)
                            .hasClass("ajaxSubmit")) {
                            ajaxSubmit($(item), $(item)
                                .attr('params'));
                        }
                    },50);
                }
            });
            // When the date range picker is opened, reposition the div to its correct position
            $(item).click(function() {
                $(".ui-daterangepicker").position({
                    my: "left top",
                    at: "left bottom",
                    of: $(item)
                })
            });
            // Set up icon next to date range picker
            $(item).attr("autocomplete", "off").after("<button type='button' id='" + item.id + "DateRangePicker' class='btnImg'><span class='date'>&nbsp;</span></button>");
            $(context).delegate("#" + item.id + "DateRangePicker", "click", function(){
                $(item).click().focus();
                return false;
            });
        });

        // Day, Month Selected
        $("input.dayMonthPicker", context).each(function(index, item) {
            if (!$("#" + item.id + "DatePicker").exists()) {
                var $item = $(item);
                var disableDays = [], disableRecurringDays = [];
                // data attributes
                if (typeof $(item).data('disabledays') !== "undefined"){
                    disableDays = $(item).data('disabledays');
                }
                if (typeof $(item).data('disablerecurringdays') !== "undefined"){
                    disableRecurringDays = $(item).data('disablerecurringdays');
                }
                $item.datepicker({
                    dateFormat: 'd MM',
                    disabled: $item.prop('disabled') || $item.attr('readonly') === 'readonly',
                    changeMonth: true,
                    changeYear: false,
                    showButtonPanel: false,
                    showMonthAfterYear: false,
                    minDate: $item.attr("minDate") ? $item.attr("minDate") : null,
                    beforeShow: function (input, inst) {
                        inst.dpDiv.addClass('NoYearDatePicker');
                    },

                    beforeShowDay: function(input, inst) {
                        // Functon to call before showing days
                        var m = null;
                        var d = null;
                        var y = null;
                        if(disableDays.length) { // disable specific dates
                            var disabledDays = disableDays.split(',');
                            m = input.getMonth();
                            d = input.getDate();
                            y = input.getFullYear();
                            for (i = 0; i < disabledDays.length; i++) {
                                if($.inArray(d + '-' + (m+1) + '-' + y,disabledDays) != -1) {
                                    return [false];
                                }
                            }
                        }
                        if(disableRecurringDays.length) { // disable specific dates
                            var disabledRecurringDays = disableRecurringDays.split(',');
                            m = input.getMonth();
                            d = input.getDate();
                            for (i = 0; i < disabledRecurringDays.length; i++) {
                                if($.inArray(d + '-' + (m+1), disabledRecurringDays) != -1) {
                                    return [false];
                                }
                            }
                        }
                        return [true];
                    },
                    onClose: function(input, inst) {
                        inst.dpDiv.removeClass('NoYearDatePicker');
                        if ($(item).hasClass("ajaxSubmit")){
                            ajaxSubmit($(item),$(item).attr('params'));
                        }
                    }
                });
                // Set up icon next to date picker
                $(item).attr("autocomplete", "off").after("<button type='button' id='" + item.id + "DatePicker' class='btnImg' style='position: absolute;'><span class='date'>&nbsp;</span></button>");
                $(context).delegate("#" + item.id + "DatePicker", "click", function(){
                    $(item).datepicker("show");
                });
            }
        });

        // Time picker
        $("input.timePicker", context).each(function(index, item) {
            if ($(item).data("initialised") === true){
                return true;
            }
            $(item).data("initialised", true);
            initTimePicker(item);
        });
    } catch (e) {
        // date and time pickers seem to fail sometimes
        console.log(e)
    }
    // Radio checks
    $("input:radio.radioCheck", context).each(function(){
        if (!$(this).siblings(".linkImgTick").length > 0){
            $(this).hide();
            $(this).after('<a href="javascript: void(0);" class="linkImgTick"><span class="icon-tick"></span></a>');
            $(this).parent("td").addClass("halfTransparent");
            if($(this).is(":checked")){
                $(this).parent("td").removeClass("halfTransparent");
            }
        }
    });

    // Graphs
    $(".graphContainer", context).filter(":visible").each(function() {
        createGraph($(this));
    });

    // Add readonly class to readonly elements
    $("input[readonly], textarea[readonly],input[disabled], textarea[disabled]").addClass("readonly");

    // set up magic suggest
    $(".multiTag").filter(":visible").each( function() {
         setupMultiSelect($(this));
    });

    // Clear all tags
    $(".clearTags-js").on("click", function() {
        var ms = $($(this).data('target')).magicSuggest();
        ms.clear();
    });

    // Clear all email tags
    $(".clearTags-js").on("click", function() {
        $("#to").magicSuggest().clear();
        let $ccTarget = $("#cc");
        let $bccTarget = $("#bcc");
        //check cc div is display then clear data
        if ($ccTarget.is("div")) {
            $ccTarget.magicSuggest().clear();
        }
        //check bcc div is display then clear data
        if ($bccTarget.is("div")) {
            $bccTarget.magicSuggest().clear();
        }
    });

    // Clear all tags when there is multiple tag input at the same time
    $(".clearTagsMulti-js").on("click", function() {
        var ms = $($(this).data('target')).magicSuggest();
        ms.clear();
    });

    // show any tooltips that need to be shown
    $(".tooltip").each(function() {
        if(typeof($($(this).data("element"))) != "undefined" && $($(this).data("element")).is(":visible")) {
            $(this).show();
        }
    });

    // Prevent icons from taking focus when tab key is used
    $("button:not(.suggestselectButton), input:checkbox, input:radio, input[readonly], input[disabled]", context).filter(':not(.inputTabbable)').attr("tabindex", 10000);

    // Setup SearchText fields
    $(".searchText:not(.searchTextTransformed)", context).each(function() {
        let $this = $(this);
        $this.addClass("searchTextTransformed");
        //if the input box doesn't have a placeholder, add a search icon at the start
        if (!$this.attr("placeholder")) {
            $this.before('<span class="iconMagnify icon-search"></span>');
        }
        var target = '.divForm:visible';
        if ($this.attr('target')){
            target = $this.attr('target');
        }
        $this.after('<span target="' + target + '" class="iconEraseFilter"></span>');
        if ($this.val() == ""){
            $this.prev().removeClass("hide")
            $this.next().addClass("hide")
        } else {
            $this.next().removeClass("hide")
            $this.prev().addClass("hide")
        }
    });

    // If page has a scrollbar, show vertical navigation
    if ($(document).height() > $(window).height()) {
        $("#verticalNav").show();
    }
    checkMandatoryMarker();
    // Only allow digits in field
    $("input.allowDigits", context)
        .off('keypress.allowdigits').on('keypress.allowdigits', function (e) {
        let charCode = (e.keyCode ? e.keyCode : e.which);
        let allowed = [];
        if (!$(this).hasClass('calculationsOff-js')) {
            // (46 => '.', 45 => '-', 44 => ',', 43 => '+', 42 => '*', 41 => ')', 40 => '(', 47 => '/')
            allowed = [46, 45, 44, 43, 42, 41, 40, 47];
        } else if ($(this).hasClass('allowFloat-js')) {
            allowed = [45];
            // Allow one decimal
            if ($(this).val().indexOf(simPRODefaults.data("number-format-decimal")) === -1) {
                allowed.push(simPRODefaults.data('number-format-decimal').charCodeAt(0));
            }
        }
        if (charCode > 31 && (charCode < 48 || charCode > 57) && allowed.indexOf(charCode) === -1) {
            return false;
        }
        return true;
    }).off('focus.allowdigits').on('focus.allowdigits', function() {
        if (simPRODefaults.data('number-format-negative') === '(%s%n)') {
            let value = $(this).val();
            let firstCharacter = value.charAt(0);
            let lastCharacter = value.charAt(value.length - 1);
            if (firstCharacter === '(' && lastCharacter === ')') {
                $(this).val('-' + value.substring(1, value.length - 1));
            }
        }
    }).off('paste.allowdigits').on('paste.allowdigits', function() {
        var $this = $(this);
        setTimeout(function () {
            //copy-paste allow only numbers
            let pasteDigit = $this.val().replace(/[^0-9\.]/g, "");
            if (pasteDigit.split('.').length > 2) {
                pasteDigit = pasteDigit.replace(/(\.)+/g, '');
            }
            $this.val(pasteDigit);
            $this.trigger('change');
        }, 4);
    }).off('blur.allowdigits').on('blur.allowdigits',  function() {
        var changedDigit = $(this).data('changedDigit');
        if(changedDigit) {
            $(this).trigger('change');
        }
    }).off('change.allowdigits').on("change.allowdigits", function() {
                let $this = $(this),
                    thisValue = $(this)
                        .parseNumber(),
                    maxValue = $this.attr('maxValue'),
                    minValue = $this.attr('minValue'),
                    fixedDecimals = $this.attr('fixedDecimals');
                $this.data('changedDigit', false);
            let offscreenOfInvoice = $this.hasClass('calculationsOff-js');
                if ((typeof offscreen !== "undefined") && offscreen) {
                    offscreenOfInvoice = true;
                }
                if ($.isNumeric(thisValue)) {
                    offscreenOfInvoice ? $this.val(thisValue) : $this.val(thisValue).numberFormat();
                    if (typeof maxValue !== "undefined") {
                        if (maxValue < 0 && thisValue < maxValue) { // using maxValue as minValue when negative
                            offscreenOfInvoice ? $this.val(maxValue) : $this.val(maxValue).numberFormat();
                            // Use formatted value in title/tooltip
                            $this.attr("title", sprintf(gettext("Value cannot be less than %s."), $this.val()));
                            createToolTip($this, true);
                        } else if (maxValue >= 0 && thisValue > maxValue) {
                            offscreenOfInvoice ? $this.val(maxValue) : $this.val(maxValue).numberFormat();
                            // Use formatted value in title/tooltip
                            $this.attr("title", sprintf(gettext("Value cannot be more than %s."), $this.val()));
                            createToolTip($this, true);
                        }
                    } else if (thisValue > 1000000000000000 || thisValue < -1000000000000000) {
                        $this.val(0);
                        $this.attr("title", gettext("Value entered has too many digits"));
                        createToolTip($this, true);
                    }

                    if (typeof minValue !== "undefined") {
                        if (thisValue < minValue) {
                            offscreenOfInvoice ? $this.val(minValue) : $this.val(minValue).numberFormat();
                            // Use formatted value in title/tooltip
                            $this.attr("title", sprintf(gettext("Value cannot be less than %s."), $this.val()));
                            createToolTip($this, true);
                        }
                    }

                    if (typeof fixedDecimals !== "undefined" && $this.val() != '') {
                        let precision = parseInt(fixedDecimals);
                        offscreenOfInvoice ?
                            $this.val(toFixed($this.asNumber(), precision))
                            : $this.val(toFixed($this.asNumber({ decimalSymbol: simPRODefaults.data('number-format-decimal') }), precision)).numberFormat();
                    }
                } else {
                    $this.select().focus();
                }
            }
    );
    // Google Maps
    $(".googleMap", context).filter(":visible").each(function() {
        //TODO - temporarily fix - re-referencing simproMapManager and simproMap to target one by ID from global mapsHolder when triggered
        //TODO - refactoring mapsFunctions.js
        if (mapsHolder[this.id] && mapsHolder[this.id].map){
            simproMapManager = mapsHolder[this.id];
            simproMap = mapsHolder[this.id].map
        }

        if (typeof simproMapManager === "undefined" || !simproMapManager.isInitialized){
            prepareMaps(this);
        }

    });

    // candy-switch toggle functionailty
    $(".toggleSwitch-js", context).hammer({domEvents: true});
    prepareAttachments(context);
    disableAutoFill(context);
    if (!preparingPage) {
        preparingPage = true;
        for (var i=0; i < preparePages.length; i++) {
            if (typeof window[preparePages[i]] === 'function') {
                window[preparePages[i]](context);
            }
        }
    }
    preparingPage = false;
}

function updateDisplaySaveButton()
{
    let toggleSwitch = $('#autosaveToggle');
    let autosave =  $('#autosave');
    let toggleSwitchValue = toggleSwitch.filter(':checked').length;
    let openHash = $("#openHash").val();
    $('#autosaveLastUpdated').show();

    if (toggleSwitch.length) {
        autosave.attr('data-autosave-toggle', toggleSwitchValue);
        $.ajax({
            type: "POST",
            url: "../common/ajax/autosaveStatus.php",
            data: "toggleSwitchValue=" + toggleSwitchValue + "&openHash=" + openHash,
            dataType: "json",
            success: function(response) {
                if (response.isDueForAutosave){
                    autoSave();
                } else {
                    let $quickLinkButton = $("#quicklinks-js");
                    if ($quickLinkButton.exists()) {
                        $quickLinkButton.trigger("click");
                    }
                }
            }
        });
    }
}

function startTwoFactorReset(iframeId) {
    var $iframe = $('#' + iframeId);
    //clicking the close button in that iframe
    $iframe.closest('.lightbox').find('.close-js').trigger('click');
    //show refactor confirm dialog
    createDialog("confirm", gettext("You will be redirected to reset you Two-Factor Authentication method. Are you sure you want to continue?"));
    $(document).on("click", ".dialogContinue", function() {
        //close the dialogBox
        $('.dialogClose').trigger('click');
        //redirect to twoFactor page
        window.location = '/common/twoFactorLogin.php?delete=true';
    });
}

function prepareMaps(el, markersReload) {
    var mapContainer = $(el);
    if (markersReload === true) {
        //Refresh only new markers
        markersData = mapContainer.data('markers');
        reloadMapMarkers();
    } else {
    // Handle the map being reloaded when saving without a full page refresh.
        var mapsAPI = $("#mapsAPI");
    mapsOnload(mapContainer, mapsAPI);
    }

}

function mapsOnload(mapContainer, mapsAPI) {
    //Map Settings
    mapContainerID = mapContainer.attr("id");
    if(mapContainer.data("options") != ""){
        customMapOptions = mapContainer.data("options");
    }

    if(mapContainer.data("circles") != ""){
        circlesData = mapContainer.data("circles");
    }

    //Additional check to replace markers if map is reloaded with new data
    if (
        mapContainer.data('markers') !== ''
        || (typeof (markersData) !== 'undefined'
            && mapContainer.data('markers') !== markersData
        )
    ) {
        markersData = mapContainer.data('markers');
    }

    if(mapContainer.data("vehicles") != ""){
        vehiclesData = mapContainer.data("vehicles");
    }

    if(typeof mapContainer.data("mousescroll") !== 'undefined'){
        mapScroll = (mapContainer.data("mousescroll") === false) ? false : true;
    }
    //Rendering map
    if (mapsAPI.size() == 0) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        if (mapContainer.hasClass('distanceMap')) {
            matrixInitialize();
        } else {
            renderMap();
        }
        script.id = "mapsAPI";
        document.body.appendChild(script);
    } else {
        if (mapContainer.hasClass('distanceMap')) {
            matrixInitialize();
        } else {
            renderMap();
        }
    }
}

/* EVENTS */

function prepareEvents(){
    //console.profile("prepare events");
    var context = $("#page");
    var minorContext = $("#main");

    // candy-switch toggle functionailty
    var panelement = null;
    $(minorContext).on("pan", ".toggleSwitch-js", function(e) {
        if (panelement === null) {
            panelement = $(this).closest(".toggleSwitch-js");
        }
        if (typeof e.gesture !== "undefined") {
            var elem = document.elementFromPoint(e.gesture.pointers["0"].clientX, e.gesture.pointers["0"].clientY);
            if ($(elem).closest(".toggleSwitch-js").is(panelement)) {
                $(elem).click();
            }
        }
    }).on("panend", ".toggleSwitch-js", function() {
        panelement = null;
    }).on("change", "#autoStatus", function () {
        let isChecked = this.checked ? 1 : 0;
        let activityType = $(this).data('activitytype');

        if (activityType !== undefined) {
            $.ajax({
                type: "POST",
                data: "activityType=" + activityType + "&autoAdjust=" + isChecked + "&openHash=" + $("#openHash").val(),
                dataType: 'json',
                url: "../common/ajax/setAutoAdjust.php"
            });
        }
    });

    // Split buttons
    $(minorContext).on('click', '.splitButton .dropButton, .splitButton .dropButtonMenu', function(e) {
        let $this = $(this);
        let splitBtn = $this.closest(".splitButton");
        splitBtn.toggleClass('open');
        if ($this.hasClass('dropButton')) {
            $this.next().width(splitBtn.width()-1).position({
                my: "right top",
                at: "right bottom",
                of: $this,
                collision: "flip"
            });
            e.preventDefault();
            setTimeout(function () {
                $(document).one("mousedown", function (e) {
                    let $target = $(e.target);
                    if (!$target.hasClass('dropButton') && !$target.closest('.dropButton').exists() && !$target.closest('.dropButtonMenu').exists()) {
                        splitBtn.removeClass('open');
                    }
                })
            }, 100);
        }
    });

    //Pendo
    $("#walkmeLaunch").on("click", function() {
        window.pendo.BuildingBlocks.BuildingBlockResourceCenter.getResourceCenter().show();
    });

    $("#logoutLink").on("click", function(e) {
        let logoutDialog = $("#logoutDialog");
        if (logoutDialog.exists()) {
            logoutDialog.show();
            return false;
        } else {
            //Clear firebaseTokenUpdated in session with new update
            e.preventDefault();
            sessionStorage.removeItem("firebaseTokenUpdated");
            return true;
        }
    });

    //when a checkbox in the table is checked, highlight the row using class activeRow sim-10222
    $(minorContext).on('click', '.tblGrid:not(.noActiveRows) tr td:first-child input:checkbox, .tblGrid:not(.noActiveRows) tr td:first-child + td input:checkbox', function () {
        $(this).closest('tr').toggleClass('activeRow');
    });

    var savedVersionsTransitionPlaying = false;

    //Forms template
    $(minorContext).on("change", ".bindToMultiTag", function() {
        /*
			bind a select on a multi tag select
			data-id and data-name have to be on options of the source select and correspond to id / name of the multi tag
			select
			.prevSelect on options allows to keep the current selection and only remove / add "valid item"
     	*/
        var $this = $(this);
        var ms = $($this.data('target')).magicSuggest();
        var $selected = $this.find('option:selected');
        var $prevSelected = $this.find('.prevSelected');
        if ($prevSelected.data('id') !== '' && $prevSelected.data('name') != '') {
            ms.removeFromSelection({id: $prevSelected.data('id'), name: $prevSelected.data('name')});
        }
        if ($selected.data('id') !== '' && $selected.data('name') != '') {
            ms.addToSelection({id: $selected.data('id'), name: $selected.data('name')})
        }
        $prevSelected.removeClass('prevSelected');
        $selected.addClass('prevSelected');
    }).delegate("#formContact", "change",function() {
        $(".primaryContact").click();
        var $contact = $("#contact" + $(this).val());
        if(!$contact.hasClass("current")) {
            $contact.click();
        }
        $contact.addClass("primaryContact");
    }).on("focus click", "#FormsContainer :input, #formContacts", function(e) {
        var target = $(e.target);
        //this checks if the formSelection is hidden(in the new forms page)
        var formSection = $("#formSelection").css("display") == 'block' ? true : false;
        //the first condition checks if the event is coming from the switch inside Forms tab
        //the second condition checks if the event is coming from "Send without form" switch
        if ((target.attr('id') !== 'formDiv' && target.attr('id') !== 'templateDiv') &&
            target.attr('id') !== 'attachFormEmail' &&
            !(formSection) &&
            !(target.hasClass("suggestselectButton") && target.prev().is("#formID")) &&
            !target.hasClass("dialogCloseCallback")) {
            checkFormPopup(target);
        }
    }).on('change', '#FormsFormContainer.new-js #formContact', function() {
        var selected = $(this).find("option:selected");
        var selectedContact = selected.text();
        $('#templateAttn').text(sprintf(gettext("[attn. %s]"), selectedContact));
    }).on("click", ".viewForm, .viewFormDocx, .openTemplate", function() {
        var $formID = $("#formID");
        var $selected = $formID.find("option:selected");
        if ($formID.val() == "forms/emailOnly/emailOnly.php") {
            createDialog("alert", gettext("Please select a printable form."));
            return false;
        } else {
            openTemplateForm($selected, $(this));
        }
        return false;
    }).on("click", ".openSavedForm", function() {
        openTemplateForm($("#editForm"), $(this));
    }).on("click", ".savedForms-js", function() {
        var $this = $(this);
        $("#formName").text($this.find(".formName-js").text());
        $("#formedited").text($this.find(".edited-js").text());
        $("#formAttn").text($this.find(".attention-js").text());
        $("#epa").text($this.find(".epa-js").text());
        $("#formTotal").text($this.find(".formTotal-js").text());
        $('#editForm').data('tmpname', $this.data('tmpname'));
        $('#editForm').data('outdated', $this.data('outdated'));
        if ($this.find(".status-js").length) {
            $('.displayFormStatus-js').show();
        } else {
            $('.displayFormStatus-js').hide();
        }
        $("#dropdown-content").find(".activeElement").removeClass("activeElement");
        $this.addClass("activeElement");

    }).on("change","#attachFormEmail", function(e) {
        let attachFormEmailCheck = $("#attachFormEmail").val();
        $("#templateSelectContainer").toggle("blind", 800);
        if (attachFormEmailCheck == '0') {
            $("#attachFormEmail").val('1');
        } else {
            $("#attachFormEmail").val('0');
        }
        //update the email button data attribute attachmentcheck
        $(".emailForm").data("attachmentcheck", ($(".emailForm").data("attachmentcheck") == true ? false : true));
    }).on("click",".emailForm", function(e) {
        if (!$(this).hasClass("dialogConfirm")) {
            $(this).addClass("attSizeChk");
        } else if ($(this).hasClass("attSizeChk")) {
            $(this).removeClass("attSizeChk");
        }
        if ($("#formID").val() == "forms/emailOnly/emailOnly.php" && ($("#formDescription").val() == '' || $("#formSubject").val() == '')) {
            //prompt error
            createDialog("alert", gettext("Please enter email subject and message."));
            return false;
        } else {
            //this section is in new forms page
            var templateSection = $("#templateSelection").css("display") == 'block' ? true : false;
            if (($(this).data("attachmentcheck") == false) && (attachCalculateSize(false) > 20971520) && (!$(this).hasClass("attSizeChk"))) {
                var $this = $(this);
                $this.addClass("dialogConfirm attSizeChk");
                if (!templateSection && $('#editForm').data('outdated')) {
                    $(this).data('confirmmessage', gettext("Attachment size is greater than 20MB!<br/>The form you are sending may be out of date.<br/>  Are you sure you want to send this email?"));
                } else {
                    $(this).data('confirmmessage', $(this).data("attachmentmessage"));
                }
                $this.data("attachmentcheck", true);
                $(document).one("click", function() {
                    $this.data("attachmentcheck", false);
                });
                return true;
            } else {
                tinymce.triggerSave();
                var container = $("#FormsFormContainer");
                var selected = container.find("#formID option:selected");
                if (selected.data("popup") && !$(this).data("attachmentcheck") && templateSection) {
                    openFormPopup(selected);
                } else if (selected.data("type") == "docx" && $('#attachFormEmail').val() == '0' && templateSection) {
                    createDialog("alert", gettext("Unable to email a DOCX form."));
                } else if ($(this).hasClass("dialogConfirm")) {
                    if (!templateSection && $('#editForm').data('outdated')) {
                        $(this).data('confirmmessage', gettext("The form you are sending may be out of date. Are you sure you wish to send this email?"));
                    } else {
                        $(this).data('confirmmessage', $(this).data("confirmemail"));
                    }
                    return true;
                } else {
                    params = "formLoad=1";
                    if (container.attr("target")) {
                        if ($(container).closest(container.attr("target")).length == 0) {// forms container not within form
                            params += "&" + container.find("input, textarea, select").serialize();
                        }
                    }
                    let symbol ='&';
                    if (typeof selected !== 'undefined' && selected.length) {
                        if (selected.val().indexOf('?') === -1) {
                            symbol = '?';
                        }
                    }
                    params += ($('#openHash').exists() ? (symbol + 'openHash=' + $('#openHash').val()) : '');
                    var $attachFormEmail = $('#attachFormEmail');
                    if (container.attr("target") && ($attachFormEmail.length === 0 || $attachFormEmail.val() == '1')) {
                        showLoadingImage();
                        ajaxSubmit($(container.attr("target")), params,'emailForm', false);
                    } else {
                        emailForm();
                    }
                }
            }
        }
        return false;
    }).delegate(".attachForm", "click", function() {
        if ($("#formID").val() == "forms/emailOnly/emailOnly.php") {
            createDialog("alert", gettext("Please select a printable form."));
            return false;
        } else {
            let csv = $(this).data('csv');
            var container = $("#FormsFormContainer");
            var selected = container.find("#formID option:selected");
            if (selected.data("popup")) {
                openFormPopup(selected);
            } else if (selected.data("type") == "docx") {
                createDialog("alert", gettext("Unable to attach a DOCX form."));
            } else {
                let param = '';
                if (typeof(csv) !== "undefined") {
                    param = "&attachCsvForm=" + csv;
                }
                if(typeof($(this).data("public")) !== "undefined"){
                    param += "&public=" + $(this).data("public");
                } else {
                    param += "&public=1";
                }
                attachForm(container, selected, param);
            }
        }
        return false;
    }).on("click", "#attachSavedForm", function() {
        attachForm($("#FormsFormContainer"), $("#editForm"), '&attachSavedForm=true');
    }).on("change", "#formID", function () {
        var selected = $(this).find("option:selected");
        if (selected.data("popup")) {
            //url += selected.val().indexOf("?") == -1 ? "?" : "&";
            openFormPopup(selected);
            $(this).suggestselect("setValue", $(this).find("option:first").val());
        } else {
            if ($(this).hasClass("new-js")) {
                $('#templateName').text(selected.text());
                $('#formTmpName').remove();
                if (selected.data('type') === "document") {
                    $("#isEstimateLabel").hide();
                } else {
                    $("#isEstimateLabel").show();
                }
            } else {
                var multiViewForm = $("#multiViewForm");
                if (multiViewForm.exists()) {
                    if (selected.data("docx")) {
                        $("#singleViewForm").hide();
                        multiViewForm.show();
                        $(".attachForm").show();
                        $("#multiAttachForm").hide();
                    } else if (selected.data("csv")) {
                        // update to handle multi attach
                        $("#singleViewForm").show();
                        multiViewForm.hide();
                        $(".attachForm").show();
                        $("#multiAttachForm").show();
                        $("#singleAttachForm").hide();
                    } else if (selected.data("name")) {
                        $("#singleViewForm").show();
                        multiViewForm.hide();
                        $(".attachForm").show();
                        $("#multiAttachForm").hide();
                    } else {
                        $("#singleViewForm").hide();
                        multiViewForm.hide();
                        $(".attachForm").hide();
                        $("#multiAttachForm").hide();
                    }
                }
                if (selected.data("emailsubject")) {
                    var subject = selected.data("emailsubject");
                    $('#formSubject').val(subject);
                }
                if (selected.data("emailbody")) {
                    var body = selected.data("emailbody");
                    var editor = tinymce.get('formDescription');
                    $('#formDescription').text(body);
                    editor.setContent(body);
                }
            }
        }
    }).on("click", "#formDiv", function() {
        if (!savedVersionsTransitionPlaying) {
            savedVersionsTransitionPlaying = true;
            $('#templateSelection').animate({left: '-100%'}, 1000, function() {
                $('#templateSelection').hide();
                savedVersionsTransitionPlaying = false;
            });
            $('#formSelection').show().animate({left: '0%'}, 1000);
        } else {
            // Stop toggle pill slider from changing state
            return false;
        }
    }).on("click", "#templateDiv", function() {
        if (!savedVersionsTransitionPlaying) {
            savedVersionsTransitionPlaying = true;
            $('#templateSelection').show().animate({left: '0%'}, 1000);
            $('#formSelection').animate({left: '100%'}, 1000, function() {
                $('#formSelection').hide();
                savedVersionsTransitionPlaying = false;
            });
        } else {
            // Stop toggle pill slider from changing state
            return false;
        }
    }).on('click', ".dropbtn", function(e) {
        var $dropdown = $('#dropdown-content');
        if (!$dropdown.is(':visible')) {
            var $editFormContainer = $('#editFormContainer');
            var editFormOffset = $editFormContainer.offset();

            var mainOffset = $('#main').offset();

            $dropdown.show().css({
                top: editFormOffset.top - mainOffset.top + $editFormContainer.outerHeight(),
                left: editFormOffset.left - mainOffset.left,
                width: $('#editForm').outerWidth()
            });
            //setting timer because the event is getting assigned too soon
            setTimeout(function() {
                $(document).one('click', function(e) {
                    $('#dropdown-content').hide();
                });
            }, 100);
        }
    });

    $(document).on("click", '.readOnly-js:checkbox[readonly]', function() {
        return false;
    }).on("focus", ".searchText", function(){
        $(this).prev().addClass("hide")
    }).on("blur", ".searchText", function(){
        if ($(this).val() == ""){
            $(this).prev().removeClass("hide")
            $(this).next().addClass("hide")
        } else {
            $(this).next().removeClass("hide")
            $(this).prev().addClass("hide")
        }
    }).on("blur", ".searchText", function(){
        if ($(this).val() == ""){
            $(this).prev().removeClass("hide")
            $(this).next().addClass("hide")
        } else {
            $(this).next().removeClass("hide")
            $(this).prev().addClass("hide")
        }
    }).on("mouseenter","[title]:not(.noToolTip, .dialogAlert, .dialogConfirm, iframe)", function(e) {
        // Delay before showing tooltip
        if($(this).attr("title") != "" && !$(this).hasClass("titleDisabled")) {
            var element = $(this);
            var title = element.attr("title");

            element.attr("title","");
            var titleTimeout = setTimeout(function () {
                $(".tooltip").remove();
                //Don't parse HTML if title is plain text.
                if (element.data('plaintexttitle')) {
                    element.attr("title", $('<div/>').text(title).html());
                } else {
                    element.attr("title", title);
                }
                let temporary = element.data('title-temporary') ? true : false;
                var tooltip = createToolTip(element, temporary);
                if (typeof tooltip !== 'undefined') {
                    tooltip.hide().fadeIn('slow');
                    if (!temporary) {
                        tooltip.one("mouseover", function () {
                            tooltip.stop();
                            tooltip.css('opacity', '1.0');
                            tooltip.one("mouseleave", function () {
                                tooltip.fadeOut('fast', function () {
                                    tooltip.remove();
                                });
                            });
                        });
                    }
                    element.attr("title", "");
                    element.one("mouseleave click", function () {
                        var fadeout = 1;
                        if (typeof (element.data("title-show")) !== "undefined") {
                            fadeout = element.data("title-show");
                        }
                        setTimeout(function () {
                            tooltip.fadeOut('fast', function () {
                                $(this).remove();
                            });
                        }, fadeout);
                    });
                }
            }, 400);
            element.one("mouseleave click", function(){
                if (titleTimeout) {
                    clearTimeout(titleTimeout);
                    if (element.attr("title") === '') {
                        element.attr("title", title);
                    }
                }
            });
        }
    }).on("scroll", function() {
        // Show images in table views as they come into view
        showImagesOnScreen();
    });
    // Save back link so cancel will return to the last page
    $(context).delegate(".saveBackLink", "click", function(){
        if(window.location == window.parent.location) { // not in iframe
            var $this = $(this);
            var url = getBackLinkURL(true, $this);
            document.cookie = "backLink=" + url + (document.location.protocol == 'https:' ? '; secure' : '');
        }
    }).on("click",".backLink", function(){
        var backLink = simPRODefaults.data("backlink");
        var href = backLink.split("&formContent[]=");

        var form = $("<form id='backLinkForm' method='post' action='" + href[0] + "'></form>");
        href.shift();
        $.each(href, function(index, item) {
            var input = item.split("=");
            $("<input type='hidden' name='" + input[0] + "' value='" + input[1] + "' />")
                .appendTo(form);
        });
        if ($(this).hasClass('cleanSession-js')) {
            if ($(this).attr('value')){
                $("<input type='hidden' name='cleanSession' value='" + $(this).val() + "' />")
                    .appendTo(form);
            }
            if ($(this).attr('openHash')) {
                $("<input"
                    + " type='hidden'"
                    + " name='cleanHash'"
                    + " value='" + $(this).attr('openHash') + "'"
                    + " />"
                )
                    .appendTo(form);
            }
        }
        $(form).appendTo("body").submit();
        $("#backLinkForm").remove();
        return false;
    }).on("click", ".closeQuickLink", function(e) {
        // Display close Quicklink modal
        let openHashToClose = $(e.target).attr('openhash');
        let quicklinkNode = $('#quickLink_' + openHashToClose);
        let tabUrlToClose = $(quicklinkNode).data('url');
        let readOnly = $(quicklinkNode).data('read-only') == 1;
        if (!readOnly) {
            let tabTitle = $(quicklinkNode).prop('title');
            tabTitle = tabTitle.replace(/<br>.*$/, '');

            let closeQuicklinkBtnTemplate = '<button type="button" id="%s" class="%s" tabindex="%d" data-open-hash-close="%s" data-tab-url-close="%s">%s</button>';
            let saveAndCloseBtn = sprintf(
                closeQuicklinkBtnTemplate,
                'closeQuickLinkAndSaveBtn',
                'btnGreen dialogClose noESC',
                10000,
                openHashToClose,
                tabUrlToClose,
                gettext('Save & Close')
            );
            let closeWithoutSaveBtn = sprintf(
                closeQuicklinkBtnTemplate,
                'closeQuicklinkBtn',
                'btnGrey dialogClose marginLeft noESC',
                10000,
                openHashToClose,
                tabUrlToClose,
                gettext('Close Without Saving')
            );
            let dialogContent = sprintf(
                '<p>%s</p><div class="textCenter doubleMarginTop">%s %s</div>',
                sprintf(
                    gettext('Are you sure you want to close %s?'),
                    '<span id="createCloseQuicklinkTitle">' + tabTitle + '</span>'
                ),
                saveAndCloseBtn,
                closeWithoutSaveBtn
            );
            createDialog('custom', dialogContent, gettext('Confirmation'));
        } else {
            closeQuicklink(openHashToClose, tabUrlToClose, false);
        }
    }).on("click", "#closeQuicklinkErrorBtn", function(e) {
        var target = $(this).attr("target");
        window.location = target;
        return false;
    }).on("click",".closeWindow", function(){
        closeWindow();
    }).on("input change", "input, textarea, select", function() {
        quickLinkUpdate = true;
    }).on("click","#quickLinkFooter li[data-url]", function(e){ // old ui
        var quickLinkUrl = $(this).data('url');
        openLink(quickLinkUrl, e);
        return false;
    }).on("click",".quickLinkItem:not(.activeQuickLink)", function(e){ // new ui
        if (e.target.className.indexOf('closeQuickLink') === -1) {
        var quickLinkUrl = $(this).data('url');
        openLink(quickLinkUrl, e);
        }
        return false;
    }).on("click","#main-navigation .menuContent a, .navigationLink-js, #topBarItems-ui2 a, #leftMenu-ui2 a, .quickLinkHref-js", function(e) {
        let $this = $(this);
        if ($this.hasClass('dialogLink')) {
            return true;
        }
        let linkTarget = $this.attr("target");
        if (linkTarget != "window" && linkTarget != "_blank") { // ie creating tasks
            var quickLinkUrl = $(this).attr('href');
            openLink(quickLinkUrl, e);
            return false;
        }
    }).on("click", ".quickLinkToggle-js", function(){
        //save state of quicklink bar (collapsed/expanded)
        if ($(this).data("collapse") == "#quickLinkFooter") {
            document.cookie = "qm=c" + (document.location.protocol == 'https:' ? '; secure' : '');
        } else {
            document.cookie = "qm=e" + (document.location.protocol == 'https:' ? '; secure' : '');
        }
        var quickLinkFooter = $("#quickLinkFooter");
        if (quickLinkFooter.hasClass('quickLinkFooterHover')) {
            quickLinkFooter.removeClass('quickLinkFooterHover').addClass('quickLinkFooterClick');
            quickLinkFooter.children("li:last").removeClass('hide');
        } else {
            quickLinkFooter.addClass('quickLinkFooterHover');
        }
        var quickLinkCount = $("#quickLinkCount");
        quickLinkCount.addClass("quickLinkToggled");
        quickLinkCount.one("mouseleave", function() {
            quickLinkCount.removeClass("quickLinkToggled");
            window.clearTimeout(quickLinkToggledIntval);
        });
        quickLinkToggledIntval = window.setTimeout(function() {
            if (quickLinkCount.hasClass("quickLinkToggled")) {
                quickLinkCount.removeClass("quickLinkToggled");
                quickLinkCount.trigger("showQuickLinkFooter");
            }
        }, 2000);
    }).on("mouseenter showQuickLinkFooter", "#quickLinkCount", function() {
        if (typeof quicklinkIntval !== 'undefined') {
            window.clearTimeout(quicklinkIntval);
        }
        var quickLinkFooter = $("#quickLinkFooter");
        if (!$(this).hasClass("quickLinkToggled") && quickLinkFooter.hasClass("quickLinkFooterHover")) {
            quickLinkFooter.removeClass('quickLinkFooterClick');
            quickLinkFooter.children("li:last").addClass('hide');
            quickLinkFooter.fadeIn();
        }
    }).on("mouseleave", '#quickLinkCount, #quickLinkFooter', function(e) {
        var quickLinkFooter = $("#quickLinkFooter");
        var quickLinkCount = $("#quickLinkCount");
        if (quickLinkFooter.hasClass("quickLinkFooterHover")) {
            if (!$(e.toElement).is(quickLinkCount)) {
                var timeout = 1;
                if ($(this).is(quickLinkCount)) {
                    timeout = 300;
                }
                quicklinkIntval = window.setTimeout(function() {
                    quickLinkFooter.children("li:last").removeClass('hide');
                    quickLinkFooter.hide();
                }, timeout);
            }
        }
    }).on("mouseenter", '#quickLinkFooter li div.span12', function() {
        if (typeof quicklinkIntval !== 'undefined') {
            window.clearTimeout(quicklinkIntval);
        }
        if ($('#quickLinkFooter').hasClass('quickLinkFooterHover')) {
            $(this).addClass('titleDisabled');
        }
    }).on("mouseleave", '#quickLinkFooter li div.span12', function() {
        $(this).removeClass('titleDisabled');
    });
    // Handy Functions
    $(context).on("click",".noPropagation", function(e) {
        e.stopPropagation();
    }).on("keydown",".noEnter", function(e) {
        if((e.keyCode ? e.keyCode : e.which) === 13) {
            e.preventDefault();
        }
    });
    // Ajax submit
    $(context).on("blur",".ajaxBlur", function(e){
        ajaxSubmit($(this));
        return false;
    }).on("change",".ajaxChange", function(e){
        if ($(this).hasClass("dialogConfirm")){
            // Show confirm screen handled by dialogConfirm event
        } else {
            if(!$(this).data('keyEnter')) { // gets fired twice with below function except in ie
                ajaxSubmit($(this), $(this).attr("params"), $(this).attr("callback"));
                return false;
            }
            $(this).data('keyEnter', false);
        }
    }).on("keydown",".ajaxChange,.ajaxBlur", function(e){
        if((e.keyCode ? e.keyCode : e.which) === 13) {
            $(this).data('keyEnter', true);
            $(this).trigger('blur');
            return false;
        }
    }).on("change","select[data-child]",function(){
        var $this = $(this),
            $child = $($this.data('child')),
            $items = $($this.data('source')).children('option[data-parentvalue="' + $this.val() +  '"]');
        $child.children('option[data-parentvalue]').remove();
        $child.append($items.clone());
        $child.suggestselect('refresh');
        var callback = $this.data('callback');
        if (typeof callback !== 'undefined') {
            //call callback
            window[callback]();
        }
    }).on("click",".ajaxClick", function(e) {
        if ($(this).hasClass("dialogConfirm")) {
            if ($(this).hasClass("deleteAccrual")) {
                //refresh income tab
                modifiedProjected = true;
            }
            // Show confirm screen handled by dialogConfirm event
        } else {
            var target = $(e.target);
            ignoreClick = target.data('ignoreclick');
            if ($(this).data('oldLabel') == undefined && !ignoreClick) {
                ajaxSubmit($(this), $(this).attr("params"), $(this).attr("callback"));
            }
        }
        $(".tooltip").hide();
        return false;
        // request data is submitted via PostRequest
    }).on("click", ".linkPost[href]", function(e) {
        e.preventDefault();
        let searchData = $(this).attr('href');
        let linkElements = searchData.split("?");
        let data = linkElements.pop();
        let action = linkElements.pop();
        let form = $('<form method="POST" action="' + action + '"></form>');
        $.each(data.split('&'), function (index, elem) {
            let vals = elem.split('=');
            $("<input type='hidden' name='" + decodeURIComponent(vals[0]) + "' value='" + decodeURIComponent(vals[1]).replace(/\+/g, ' ') + "' />").appendTo(form);
        });
        form.appendTo("body");
        form.submit();
    }).on("click",".ajaxOrder", function() {
        const $this = $(this);
        let params = "";
        let parent = $this.closest("form");
        if (!$(parent).exists()) {
            parent = $this.closest(".divForm").filter(":visible");
        }
        if (!parent) {
            parent = context;
        }
        if ($this.attr("params")) {
            params += "&" + $this.attr("params");
        }
        const ajaxOrder = $(".ajaxOrder", parent);
        const selectedColumns = ajaxOrder.filter("[order='" + $this.attr("order") + "']");
        const aTag = $this.find("a");
        if (aTag.hasClass("desc")) {
            selectedColumns.find("a").removeClass("desc");
        } else {
            selectedColumns.find("a").addClass("desc");
        }
        ajaxOrder.removeClass("current");
        selectedColumns.addClass("current");
        ajaxSubmit($this, params);
        return false;
    }).on("keydown",".ajaxEnter", function(e){
        if((e.keyCode ? e.keyCode : e.which) === 13) {
            $(this).change();
            if($(this).attr("target")) {
                $($(this).attr("target")).click();
            } else {
                ajaxSubmit($(this), $(this).attr("params"));
            }
            $(this).blur();
            return false;
        }
    }).on("click",".ajaxMainButtons", function(){
        showLoadingImage();
        var params = "?" + this.name + "='" + this.value + "'&" + $("form").serialize() + "&ajaxCall=true" + checkTabs();
        $.ajax({
            type: "GET",
            url: params,
            success: function(data){
                showResponse(data);
            },
            complete: function(xhr,textStatus){
                ajaxComplete(xhr,textStatus);
            }
        });
        // Dialog boxes
    }).on("click",".dialogAlert", function(){
        var $this = $(this),
            message = "",
            title = "";
        let isFixedBtnPos = $this.hasClass("dialogAlertFixedBtns-js");

        if ( typeof $this.data('title') !== "undefined"){
            title = $this.data('confirmtitle');
        } else if ( typeof $this.attr('title') !== "undefined"){
            title = $this.attr("title");
        }

        if ( typeof $this.data('message') !== "undefined"){
            message = $this.data('message');
        } else if ( typeof $this.attr('value') !== "undefined"){
            message = $this.attr("value");
        }
        var alertDialog = createDialog("alert", message, title, null, null, null, null, null, isFixedBtnPos);
        if($(this).is("input[type='text']")) {
            alertDialog.on("click", ".dialogClose", function(){
                $this.focus();
                $this.removeClass("dialogAlert");
            });
        }
        return false;
    }).on("click change",".dialogConfirm", function(e) {
        closeContextMenu();
        createDialogConfirm($(this), false);
        e.preventDefault();
        $(document).click(); // As we are returning false the click won't propogate further, however items such as suggestselect still need to close so click the document instead.
        return false;
    }).on("click",".dialogLink[href]", function(e) {
        $(".tooltip").remove();
        var size = {};
        if ($(this).attr("frameWidth")) {
            size.width = $(this).attr("frameWidth");
        }
        if ($(this).attr("frameHeight")) {
            size.height = $(this).attr("frameHeight");
        }
        $(".suggestSelect").suggestselect("close");
        createDialog("link", $(this).attr("href"), $(this).attr("dialogTitle"), null, $(this).hasClass("noClose"), false, size);
        e.preventDefault();
        if (quickLinkUpdate) {
            let $quickLinkButton = $("#quicklinks-js");
            if ($quickLinkButton.exists()) {
                $quickLinkButton.trigger("click");
                quickLinkUpdate = false;
            }
        }
    });

    //Set sync buttons buttons
    $(document).on("click",".postClick", function() {
        if ($(this).hasClass("dialogConfirm")){
            // Show confirm screen handled by dialogConfirm event
        } else {
            showLoadingImage();
            var  form;
            if ($(this).attr("target")) {
                target = $(this).attr("target")
                if (target.indexOf(".") != -1 || target.indexOf("#") != -1){
                    form = $($(this).attr("target"));
                } else {
                    form = $('#' + $(this).attr("target"));
                }
            } else {
                form = ('<form method="post" action="' + simPRODefaults.data("page-url") + '" id="submitCreatedForm"></form>').appendTo("body");
            }
            $("<input type='hidden' name='keepBackLink' value='1' />").appendTo(form);
            if (!$(this).is('.checkMandatory') || checkMandatory(form)){
                $("<input type='hidden' name='" + $(this).attr('name') + "' value='" + $(this).val() + "' />").appendTo(form);
                form.submit();
            }
            setTimeout(function(){
                hideLoadingImage();
            }, 300);
        }
    }).on("click", ".showLoadingImage", function() {
        showLoadingImage();
    });

    $(document).on('click', '#closeQuicklinkBtn', function(){
        closeQuicklink(
            $(this).data('open-hash-close'),
            $(this).data('tab-url-close'),
            false
        );
    }).on('click', '#closeQuickLinkAndSaveBtn', function(){
        closeQuicklink(
            $(this).data('open-hash-close'),
            $(this).data('tab-url-close'),
            true
        );
    });

    // When form is submitted, check whether mandatory fields are filled in
    $(document).delegate("form:not(.ajaxForm)", "submit", function() {
        var chkMandatory = checkMandatory(this);
        if (!chkMandatory) {
            // in case loading image was shown
            hideLoadingImage();
        }
        return chkMandatory;
    }).delegate(".dialogBox button:not(.dialogClose, .suggestselectButton, .btnImg, .btnMultiPage)", "click", function() {
        return checkMandatory($(this).closest(".dialogBox"));
    });

    // Reset form
    $(context).delegate("button[type='reset'], .resetSearch-js, .iconEraseFilter", "click", function(e){
        e.preventDefault();
        let form;
        if ($(this).attr('resetTarget')) {
            form = $($(this).attr("resetTarget"));
        } else if ($(this).attr("target")){
            let target = $(this).attr("target");
            if (target.indexOf(".") != -1){
                form = $(target);
            } else {
                form = $("#" + target);
            }
        } else {
            form = $(this).closest("form");
        }
        form.find("#letter").val("");
        form.find("#pageNo").val(1);
        form.find("input:visible:not(:checkbox):not(:radio)").each(function(index, item) {
            if ($(item).attr("default")){
                $(item).val($(item).attr("default"));
            } else {
                $(item).val("");
            }
        });
        form.find("input:checkbox").removeProp("checked");
        form.find("input[default]").click();
        form.find("input.autoComplete-js").each(function(index, item) {
            var name = $(item).attr("name");
            if (name.indexOf("[]") != -1){
                name = name.replace("[]", "") + "Callback[]";
            } else {
                name += "Callback";
            }
            var id = $(item).attr("id") + "Callback";
            $("#" + id).remove();
            $("#" + id + "Category").remove();
        });
        form.find("select").each(function(index, item) {
            $(item).children().removeAttr("selected");
            if ($(item).children("[default]").exists()){
                $(item).children("[default]").attr("selected", "selected");
            } else {
                $(item).children(":first-child").attr("selected", "selected");
            }
        });
        var params = "resetForm=1";
        if($(this).attr("params")) {
            params += "&" + $(this).attr("params");
        }
        ajaxSubmit($(this), params);
        return false;
    }).on("click", ".clearFormEmail-js", function() {
        $('#formSubject').val('');
        $('#formDescription').text('');
        var editor = tinymce.get('formDescription');
        editor.setContent('');
    });

    // Remove saved search
    $("#savedSearchesCont").on("click", ".removeSavedSearch", function() {
        let $this = $(this);

        let confirmationDialog = createDialogConfirm($this, false);
        confirmationDialog.undelegate(".dialogContinue", "click").delegate(".dialogContinue", "click", function() {
            var data = "removeSavedSearch=true&savedSearchID=" + $this.attr("id");
            // remove all hotkeys as order may have changed
            $(document).unbind("keydown");
            $.ajax({
                type: "POST",
                data: data,
                dataType: "json",
                url: "/common/ajax/searchPages.php",
                success: function () {
                    updateSavedSearches();
                }
            });
            confirmationDialog.remove();
        });
        return false;
    });

    // Tabs content change
    $(context).on("click",".mainTab, .subTab", function(){
        if(!$(this).hasClass("current")) {
            var $this = $(this);
            if ($this.data('disabled') != true && $this.data('disabled') != 'true') {
                var	$container = $("#" + $this.data('container') + "Container"),
                    $subTab = $container.find("ul.subTabs[data-selecteditem='']").first().find('a.subTab').first(),
                    $ul = $this.closest('ul'),
                    $currentTab = $ul.find('.current');
                var $currentContainer = $('#' + $currentTab.data('container') + 'Container');
                $(".ms-ctn", $currentContainer).removeClass('ms-ctn-bootstrap-focus1');
                // Remove "current" class and hide content
                $currentContainer.hide();
                $currentTab.removeClass('current');
                $this.addClass('current');
                // hide any tooltips that maybe visible
                $(".tooltip").hide();
                // Update selectedItem field with the text name of the selected tab
                $ul.data('selecteditem',$this.data('container'));
                $("#" + $ul.attr("id") + "SelectedItem").val($this.data('container'));
                if ($this.hasClass("ajaxTabs")){
                    // Submit form with selected tab
                    ajaxSubmit($this);
                } else {
                    // Show content for selected tab and if tab content has sub tabs, click first sub tab
                    $container.show();
                    if($subTab.exists()) {
                        $subTab.click();
                    } else {
                        prepareDocument($container);
                        showTabs($container);
                        autoFocus();
                    }
                }
                return true;
            }
        }
        return false;
    }).on("click",".verticalTabs nav a", function() {
        // vertical navs
        var tabsContainer = $(this).closest(".verticalTabs");

        // Hide the current tab
        var tabSelected = tabsContainer.find(".selected");
        tabSelected.removeClass("selected");
        $('#' + $(tabSelected).data("container")).removeClass("visible");
        // Show the selected tab
        $(this).addClass("selected");
        $('#' + $(this).data("container")).addClass("visible");
    });
    // Rows, cells, buttons or context menu options with a link
    $(document).delegate("th[href]:not(.dialogLink),tr[href]:not(.dialogLink), td[href]:not(.dialogLink), button[href]:not(.dialogLink), a[href][target='window'], .href-js", "click", function () {
        if ($(this).hasClass("dialogConfirm")) {
            // Show confirm screen handled by dialogConfirm event
        } else {
            var href = $(this).attr("href");
            if ($(this).attr("target")) {
                var target = $(this).attr("target");
            } else {
                var target = "";
            }
            if (href.indexOf(".php") != -1 || href.indexOf("http") != -1 || (href.indexOf("javascript:") != -1 && href.indexOf("void(0)") == -1)) {
                if (target == "window") {
                    window.open(href, "", "width=1175,height=740,left=100,top=100,screenX=100,screenY=100,resizable=no,scrollbars=yes");
                } else if (target == "_blank") {
                    window.open(href);
                } else if (target == "_top") {
                    window.top.location = href;
                } else {
                    window.location = href;
                }
                return false;
            }
        }
    });

    // Context menus
    $(context).delegate(".menuContainer", "contextmenu", function(e){
        // Right click menu
        e.preventDefault();
        closeContextMenu();
        var target = $(e.target);
        if (
            $(target).is("td")
            && $(target).find('.btnRow').exists()
            || $(target).parentsUntil($(this),"td").find('.btnRow').exists()
            || $(target).hasClass('.disabled, .disableRightClickMenu-js')
        ) {
            return false;
        }
        menuContainer = $(this);
        openContextMenu(menuContainer.find(".contextMenu").filter(function () {
            return $(this).parentsUntil(menuContainer,".menuContainer").length == 0 && $(this).parentsUntil(menuContainer,".contextMenu").length == 0;
        }), "right bottom", e);
    }).delegate(".menuContainer .btnRow:not(:has(.dot)),.exportBtn,.scheduleDropDown-js,.contextDropDown-js", "click", function(e) {
        let target;
        if (typeof($(this).attr("target")) != "undefined") {
            target = $($(this).attr("target"));
        } else {
            target = $(this).siblings(".contextMenu");
        }
        // Left click menu
        e.preventDefault();
        closeContextMenu();
        openContextMenu(target, "left bottom", $(this));
    });

    $(context).delegate("input[readonly]", "click", function(e){
        $(this).blur();
    });

    $(context).delegate(".linkImgTick", "click", function(){
        $(this).closest("table").find("input:radio:checked.radioCheck").removeProp("checked").parents("td").addClass("halfTransparent");
        $(this).closest("td").removeClass("halfTransparent").children("input:radio.radioCheck").prop("checked", true);
    });

    // Print preview &SubMenu repositioning at lower resolutions
    $("#utility-menu").delegate(".print", "click", function(){
        printPreview();
    });

    // Enlarge image to its original size and show in centre of page
    $(context).delegate(".enlargeImage", "click", function(){
        // Get size and position
        var windowWidth = $(window).width();
        var windowHeight = $(window).height();
        var width = $(this).width();
        var height = $(this).height();
        var originalWidth = this.naturalWidth;
        var originalHeight = this.naturalHeight;
        if (originalWidth > windowWidth) {
            var newWidth = windowWidth - 100;
            originalHeight = originalHeight * (newWidth/originalWidth);
            originalWidth = newWidth;
        }
        if (originalHeight > windowHeight) {
            var newHeight = windowHeight - 100;
            originalWidth = originalWidth * (newHeight/originalHeight);
            originalHeight = newHeight;
        }
        var offset = $(this).offset();
        // Container with dark background
        var container = $("<div class='dialogBox'></div>").appendTo("body").show();
        // Clone, resize and position image in centre of page
        var image = $(this).clone().appendTo("body");
        $(image).css("zIndex", 100000).css("position", "fixed").css("top", offset.top - $(window).scrollTop()).css("left", offset.left - $(window).scrollLeft()).animate({
            width: originalWidth,
            height: originalHeight,
            top: ((windowHeight - originalHeight) / 2) + "px",
            left: ((windowWidth - originalWidth) / 2) + "px"
        }, {
            duration: 375,
            complete: function(){
                // Remove container and image on click
                $(document).delegate("body", "click", function(){
                    $(image).animate({
                        width: width,
                        height: height,
                        top: offset.top - $(window).scrollTop() + "px",
                        left: offset.left - $(window).scrollLeft() + "px"
                    }, {
                        duration: 375,
                        complete: function(){
                            $(image).remove();
                            $(container).remove();
                        }
                    });
                    $(document).undelegate("body", "click");
                });
            }
        });
        return false;
    });

    $(context).delegate(".assignOptions div.item:not(.readonly)", "click", function(){
        var parent = $(this).parent();
        var target = $("#" + parent.attr("href"));
        var $this = $(this).clone();
        $(this).remove();
        target.append($this);
        target.removeClass('error');
        var aClass = $this.find('a').attr('class');

        if(aClass == "linkImgAdd"){
            $this.find('a').attr('class', 'linkImgMinus');
        }else if(aClass == 'linkImgMinus'){
            $this.find('a').attr('class', 'linkImgAdd');
        }
        if ($this.parent().hasClass("assigned")){
            $this.parent().children().each(function() {
                if (!$("input#" + $(this).attr("id")).exists()) {
                    $(this).append("<input type='hidden' name='" + $(this).attr("name") + "' id='" + $(this).attr("id") + "' value='" + $(this).attr("value") + "' />");
                }
            });
        } else {
            $this.find("input").remove();
        }
        prepareDocument($this.parents(":has(.listBox-js#" + parent.attr("id") + "):first"));
        if (parent.attr("callback")){
            window[parent.attr("callback")]();
        }
        return false;
    }).delegate(".assignOptionsAll", "click", function() {
        var optionsList = $("#" + $(this).attr("href"));
        var parent = $("#" + $(optionsList).attr("href"));
        var href = "#" + $(this).attr("href");
        const removeArray = new Array();
        const addArray = new Array();

        if ($(optionsList).hasClass("assigned")) {
            $(optionsList).children().each(function() {
                if (!$(this).hasClass('readonly')) {
                    //add plus icons
                    $(href + " a").attr("class", "linkImgAdd");
                    let $thisClone = $(this).clone();
                    $thisClone.find('input#' + $(this).attr('id')).remove();
                    addArray.push($thisClone);
                    removeArray.push('div#' + $(this).attr('id'));
                }
            });
        } else {
            //add minus icons
            $(href + " a").attr("class", "linkImgMinus");
            $(optionsList).children().each(function() {
                let $thisClone = $(this).clone();
                if (!$("input#" + $(this).attr("id")).exists()) {
                    let $newInput = $('<input>').attr({
                        type: 'hidden',
                        id: $(this).attr('id'),
                        name: $(this).attr('name'),
                        value: $(this).attr('value')
                    });
                    $thisClone.append($newInput);
                }
                addArray.push($thisClone);
                removeArray.push('div#' + $(this).attr('id'));
            });
        }
        $(removeArray.join()).remove();
        parent.append(addArray);
        parent.removeClass("error");
        prepareDocument($(this).parents(":has(.listBox-js#" + parent.attr("id") + "):first"));
        if ($(optionsList).attr("callback")){
            window[optionsList.attr("callback")]();
        }
        return false;
    }).delegate(".showArchivedCC-js", "click", function() {
        let bgID = $(this).data('bgid');
        let params = 'page=Business_Groups';
        if (bgID != '') {
            params = params + '&bgID=' + bgID;
        } else {
            params = params + '&addGroup=true';
        }
        let showArchivedCC = $(this).is(':checked');
        $(this).attr('params', params + '&showArchivedCostCentres=' + showArchivedCC);
    });

    $(context).delegate(".appendOptions div.item", "click", function(){
        var $this = $(this);
        var parent = $this.parent();
        var target = $("#" + $this.parent().attr("href"));
        var currentValue = target.val();
        var value = $this.attr("value");
        var action = "add";
        if(!parent.hasClass("multiple")) { // if multiple then don't highlight don't change between add and remove
            if($this.hasClass("current")) {
                $this.removeClass("current").find("a").removeClass("linkImgMinus").addClass("linkImgAdd");
                action = "remove";
            } else {
                $this.addClass("current").find("a").removeClass("linkImgAdd").addClass("linkImgMinus");
            }
        }

        if(action == "add") {
            if(parent.attr("separator") && target.val() != "") {
                value = parent.attr("separator") + value;
            }
            target.val(currentValue + value);
        } else {
            //removes the primaryContact class from contacts, otherwise they will populate again when switching primary contact
            $this.removeClass("primaryContact");
            var separatorValue = RegExp(parent.attr("separator") + '*\\s*' + value, 'g');
            currentValue = currentValue.replace(separatorValue, "");
            // check here if first char is a comma. If it is, skip (remove) the comma.
            if (currentValue[0] === parent.attr("separator")) {
                currentValue = currentValue.substring(1).trimStart();
            }
            target.val(currentValue);
        }
    }).delegate(".deleteOptions[href]", "keyup paste mouseenter", function(){
        var target = $("#" + $(this).attr("href"));
        var contents = $(this).val();
        $(".item", target).each(function(index, item) {
            if (contents.indexOf($(item).attr("value")) != -1){
                $(item).addClass("current").find("a").removeClass("linkImgAdd").addClass("linkImgMinus");
            } else {
                $(item).removeClass("current").find("a").removeClass("linkImgMinus").addClass("linkImgAdd");
            }
        });
    }).delegate(".showCc-js", 'click', function (){
        $('#ccDiv').removeClass('hide');
        let $cc = $("#cc");
        if ($cc.is('input:text')) {
            setupMultiSelect($cc);
        }
        $(this).addClass('hide')
    }).delegate(".showBcc-js", 'click', function (){
        $('#bccDiv').removeClass('hide');
        let $bcc = $("#bcc");
        if ($bcc.is('input:text')) {
            setupMultiSelect($bcc);
        }
        $(this).addClass('hide');
    });

    // Select all checkboxes
    $(context).delegate(".selectAll[href]", "click", function(){
        let $this = $(this);
        let href = $this.attr("href");
        if (href.charAt(0) !== ".") {
            href = "input[name='" + href + "']:not(:disabled)";
        }
        let $href = $(href);
        let checked = $this.prop("checked");
        $href.prop("checked", checked).trigger('change');
        let paginationAllButton = $(".button-show-all.jPaginate-link-button");
        if (paginationAllButton.length) {
            // If pagination, then show all records
            paginationAllButton.trigger('click');
            this.scrollIntoView();
        }

        if (checked) {
            $href.closest('tr').addClass('activeRow');
        } else {
            $href.closest('tr').removeClass('activeRow');
        }
    });

    // Export table as .CSV
    $(context).delegate(".exportCSV", "click", function(){
        var href = $(this).attr("href");
        if (href.charAt(0) != "."){
            href = "#" + href;
        }
        var hiddenTableIDs = [];
        $.each($(href), function(i, v) {
            if(!$(this).is(":visible")) {
                $(this).show();
                hiddenTableIDs[i] = $(this).attr("id");
            }
        });
        var title = "";
        if($(".reportCriteria").exists() && !$(".reportCriteria").attr('data-notitle') == true) {
            title = $(".reportCriteria").text();
        }
        $(href).table2CSV({
            filename: $(this).attr("filename") ? $(this).attr("filename") : "export.csv",
            title: title,
            linebreak: $(this).attr("linebreak") ? $(this).attr("linebreak") : "unix",
            auditdata: $(this).attr('auditdata'),
        });
        $.each(hiddenTableIDs, function(i, v) {
            $("#"+v).hide();
        });
        // refresh the target tab
        if ($(this).attr('refreshlogtab')) {
            let refreshlogtab = $(this).attr('refreshlogtab');
            setTimeout(function(){
                $(refreshlogtab).click();
            }, 1000);
        }
        return false;
    });

    $(context).delegate("input[type='text'][match]", "change, blur", function(event){
        var $this 		= 	$(this),
            myVal		=	$this.val(),
            regex 		= 	new RegExp($this.attr('match'),$this.attr('modifiers') || '');
        if (regex.exec(myVal)===null){
            $this.val($this.attr('default') || "");
        }
        $(this).trigger('afterRegex');
    });

    $(context).delegate("input[type='text'][replace]", "change, blur", function(event){
        var $this 		= 	$(this),
            myVal		=	$this.val(),
            regex 		= 	new RegExp($this.attr('replace'),$this.attr('modifiers') || ''),
            replaceWith =	$this.attr('with') || '';
        $this.val(myVal.replace(regex,replaceWith));
        $(this).trigger('afterRegex');
    });


    $(context).delegate(".numberstep .up,.numberstep .down", "mousedown", function() {
        var target = $($(this).closest(".numberstep").attr("href"));
        var step = parseFloat(target.attr("step"));
        if($(this).hasClass("down")) {
            var direction = "down";
        } else {
            var direction = "up";
        }
        // trigger initial step
        numberStep(target, step,direction);

        // trigger interval step
        numberIntervalID = window.setInterval(function() {
            numberStep(target, step, direction);
        }, 200);

        // bind cancel of inerval step
        $(this).one("mouseleave mouseup", function() {
            window.clearInterval(numberIntervalID);
        });
    })

    // Scripts
    $(context).delegate("select.scripts", "change", function() {
        $this = $(this);
        let target = $("#" + $this.attr("href"));
        let value = decodeURIComponent($this.find("option:selected").val().replace(/\+/g, " "));
        let datascript = $this.attr("data-script-replace");
        // do javascript replacement if applicable
        if (typeof datascript !== "undefined") {
            let scriptReplaceData = jQuery.parseJSON(datascript);
            let vars = [];
            $.each(scriptReplaceData, function(key, value) {
                vars[key] = value;
            });
            for (key in vars) {
                let element = $("#" + vars[key]);
                if (typeof element !== "undefined" && typeof element.val() !== "undefined") {
                    vars[key] = element.val();
                } else if (typeof element.val() == "undefined" ) {
                    vars[key] = '';
                } else {
                    delete vars[key];
                }
            }
            for (key in vars) {
                value = value.replace('[' + key + ']', vars[key]);
            }
        }
        if(target.hasClass("tinyMCEEditor")) {
            let editor = tinymce.get(target.attr("id"));
            let selection = editor.selection.getSel();
            if (selection.type !== 'None') {
                editor.execCommand('mceInsertContent', false, value);
            }
            else {
                editor.setContent(editor.getContent() + " " + value);
            }
        } else {
            let caret = $(target).caret();
            if (caret.start != caret.end) {
                $(target).val(caret.replace(value));
            }
            else {
                $(target).val($(target).val().substring(0, caret.start) + value + $(target).val().substring(caret.start));
            }
        }
        $(this).suggestselect("setIndex", 0).blur();
    });

    $(context).delegate(".updatePostcode", "change", function(){
        if(simPRODefaults.data("build-country") == "Australia") {
            var postcodeField = $("#" + $(this).attr("href"));
            var suburb = $("#" + $(postcodeField).attr("suburb")).val();
            var state = $("#" + $(postcodeField).attr("state")).val();
            if (suburb != '' && state != '') {
                var data = "getPostcode=true&suburb=" + suburb + "&state=" + state;
                $.ajax({
                    type: "GET",
                    url: "/common/ajax/common.php",
                    data: data,
                    dataType: "json",
                    success: function (responseText) {
                        if (responseText.status && responseText.postcode != "") {
                            $(postcodeField).val(responseText.postcode).change();
                        }
                    }
                });
            }
        }

        if ($(this).is("select") && $(this).val() == "Other"){
            $(this).suggestselect("hide").suggestselect("disable").addClass("hide").nextAll("input.otherState:first").val("").removeClass('hide').prop("disabled", false).removeClass("readonly").focus();
        }
    }).delegate(".updateUKPostcode", "change", function(){
        if(simPRODefaults.data("build-country") == "United Kingdom" && $(this).val() != '') {
            var data = "getPostcode=true&postcode=" + $(this).val();
            var $this = $(this);
            $.ajax({
                type: "GET",
                url: "/common/ajax/common.php",
                data: data,
                dataType: "json",
                success: function (responseText) {
                    if (responseText.status && responseText.addresses.Address) {
                        if(responseText.addresses.Address.length > 1){
                            addresses = "<table class='tblGrid'><tbody class='highlight'>";
                            for (i = 0; i < responseText.addresses.Address.length; i++) {
                                details = responseText.addresses.Address[i];
                                name=""
                                address="";
                                firstline = false;
                                newline = false;
                                if(typeof(details.Organisation) == "string") {
                                    name = details.Organisation;
                                    firstline = true;
                                }
                                if(typeof(details.Department) == "string") {
                                    address += details.Department;
                                    newline = true;
                                }
                                if(typeof(details.POBox) == "string") {
                                    if(firstline) {
                                        if(newline) {
                                            address += ' ';
                                        }
                                        address += details.POBox;
                                        newline = true;
                                    } else {
                                        name = details.POBox;
                                        firstline = true;
                                    }
                                }
                                if(typeof(details.Building) == "string") {
                                    if(firstline) {
                                        if(newline) {
                                            address += ' ';
                                        }
                                        address += details.Building;
                                        newline = true;
                                    } else {
                                        name = details.Building;
                                        firstline = true;
                                    }
                                }
                                if(typeof(details.SubBuilding) == "string") {
                                    if(firstline) {
                                        if(newline) {
                                            address += ' ';
                                        }
                                        address += details.SubBuilding;
                                        newline = true;
                                    } else {
                                        name = details.SubBuilding;
                                        firstline = true;
                                    }
                                }
                                if(typeof(details.BuildingNo) == "string" && details.BuildingNo != '0') {
                                    if(firstline) {
                                        if(newline) {
                                            address += ' ';
                                        }
                                        address += details.BuildingNo + ' ';
                                    } else {
                                        name = details.BuildingNo + ' ';
                                    }
                                }
                                if(typeof(details.Thoroughfare) == "string") {
                                    if(firstline) {
                                        if(newline) {
                                            address += ' ';
                                        }
                                        address += details.Thoroughfare;
                                        newline = true;
                                    } else {
                                        name += details.Thoroughfare;
                                        firstline = true;
                                    }
                                }
                                if(typeof(details.Street) == "string") {
                                    if(firstline) {
                                        if(newline) {
                                            address += ' ';
                                        }
                                        address += details.Street;
                                        newline = true;
                                    } else {
                                        name += details.Street;
                                        firstline = true;
                                    }
                                }
                                if(typeof(details.DoubleDependant) == "string") {
                                    if(firstline) {
                                        if(newline) {
                                            address += ' ';
                                        }
                                        address += details.DoubleDependant;
                                        newline = true;
                                    } else {
                                        name += details.DoubleDependant;
                                        firstline = true;
                                    }
                                }
                                if(typeof(details.Dependant) == "string") {
                                    if(firstline) {
                                        if(newline) {
                                            address += ' ';
                                        }
                                        address += details.Dependant;
                                        newline = true;
                                    } else {
                                        name += details.Dependant;
                                        firstline = true;
                                    }
                                }
                                if(typeof(details.PostTown) == "string") {
                                    if(firstline) {
                                        if(newline) {
                                            address += ' ';
                                        }
                                        address += details.PostTown;
                                        newline = true;
                                    } else {
                                        name += details.PostTown;
                                        firstline = true;
                                    }
                                }
                                addresses += '<tr><td class="selectAddress" data-addressnum="' + i + '"><strong>' + name + '</strong><br />' + address + '</td></tr>';
                            }
                            addresses += '</tbody></table>';
                            var addressDialog = createDialog("custom",addresses, "Select Address");
                            $(addressDialog).on("click", ".selectAddress", function() {
                                selectUKAddress($this, responseText.addresses.Address[$(this).data("addressnum")]);
                                addressDialog.remove();
                            });
                        } else {
                            selectUKAddress($this, responseText.addresses.Address);
                        }
                    }
                }
            });
        }
    }).delegate(".otherState", "blur", function() {
        if ($(this).val() == "" && $(this).prevAll("select:first").exists()){
            $(this).addClass('hide readonly').prop("disabled", true).prevAll("select:first").prop("selectedIndex", 0).suggestselect("show").suggestselect("enable").removeClass('hide');
        }
    }).on("change", ".selectOther-js", function() {
        if ($(this).val() === "-1") {
            $(this).suggestselect("hide").suggestselect("disable").nextAll(".inputOther-js:first").val("").show().prop("disabled", false).removeClass("readonly").focus();
        }
    }).on("blur", ".inputOther-js", function() {
        if ($(this).val() == "" && $(this).prevAll(".selectOther-js:first").exists()){
            $(this).hide().prop("disabled", true).addClass("readonly").prevAll(".selectOther-js:first").prop("selectedIndex", 0).suggestselect("show").suggestselect("enable");
        }
    }).delegate(".copyAddress", "click", function(){
        if ($(this).prop("checked")){
            $("#" + $(this).attr("targetCountry")).val($("#" + $(this).attr("country")).val());
            $("#" + $(this).attr("targetAddress")).val($("#" + $(this).attr("address")).val());
            $("#" + $(this).attr("targetSuburb")).val($("#" + $(this).attr("suburb")).val());

            var state = $("#" + $(this).attr("targetState"));
            var sourceState = $("#" + $(this).attr("state"));
            var stateInput = $("input#" + $(this).attr("targetState"));
            var sourceStateInput = $("input#" + $(this).attr("state"));
            if (sourceState.is("select")) {
                if (!sourceStateInput.hasClass('hide')) {
                    state
                        .suggestselect("hide")
                        .suggestselect("disable");
                    stateInput
                        .val(sourceStateInput.val())
                        .removeClass('hide')
                        .prop("disabled", false)
                        .removeClass("readonly");
                } else {
                    state
                        .suggestselect("show")
                        .suggestselect("enable")
                        .suggestselect("setValue", sourceState.val());
                    stateInput
                        .val("")
                        .addClass('hide')
                        .prop("disabled", true)
                        .addClass("readonly");
                }
            } else {
                stateInput.val(sourceStateInput.val());
            }
            $("#" + $(this).attr("targetPostcode")).val($("#" + $(this).attr("postcode")).val());
        }
    });

    $(context).delegate(".mapAddress", "click", function(e){
        // Check if mapping from existing data on page or need to query for it.
        if ($(this).attr("addressText")){
            var data = {
                "addresses" :
                    [
                        {
                            "names" : $(this).attr("addressName") ? $(this).attr("addressName") : $(this).attr("addressText"),
                            "address" : $(this).attr("addressText")
                        }
                    ]
            };
            mapAddress(data);
        }
        else if ($(this).attr("addressName")){
            var addressName = $("#" + $(this).attr("addressName")).val();
            var address = $("#" + $(this).attr("address")).val();
            var suburb = $("#" + $(this).attr("suburb")).val();
            var state = $("#" + $(this).attr("state") + ":enabled").val();
            var postcode = $("#" + $(this).attr("postcode")).val();
            var country = $("#" + $(this).attr("country")).val();
            if (state == -1){
                state = "";
            }

            //create formatted address
            var formattedAddress;
            formattedAddress = address;
            const coordinatesRegex = /^((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)$/gi;
            //If address is not coordinates, format address
            if (!coordinatesRegex.test(address)) {
                if (suburb) {
                    formattedAddress += ", " + suburb
                }
                if (state) {
                    formattedAddress += ", " + state
                }
                if (postcode) {
                    formattedAddress += ", " + postcode
                }
                if (country) {
                    formattedAddress += ", " + country
                }
            }
            var data = {
                "addresses" :
                    [
                        {
                            "names" : addressName,
                            "address" : formattedAddress
                        }
                    ]
            };
            mapAddress(data);
        } else {
            var data = $(this).data('maptype') + "[]=" + $(this).attr("id");
            map(data);
        }

    }).delegate(".mapMultipleAddress", "click", function(){
        closeContextMenu();
        var mapdata;
        if($(this).data('maptype')) {
            mapdata = $("input[name='" + $(this).attr("href") + "']").clone().attr("name", $(this).data('maptype') + '[]');
        } else {
            mapdata =  $("input[name='" + $(this).attr("href") + "']");
        }
        var formData = mapdata.serialize();
        map(formData);
        return false;
    });

    $(context).delegate(".searchPhoneBook", "click", function(){
        searchPhoneBook(simPRODefaults.data("build-country"), $("#" + $(this).attr("addressName")).val(), $("#" + $(this).attr("suburb")).val(), $("#" + $(this).attr("state")).val(), $("#" + $(this).attr("postcode")).val());
        return false;
    }).delegate(".searchTaxNumber", "click", function(){
        var searchValue = $("#" + $(this).attr("taxName")).val();
        var abn = $(this).prev();
        if(abn){
            var abnValue = abn.val().replace(/[^\d.-]/g, '');
            if(abnValue != "" && !isNaN(abnValue) && Math.round(abnValue) == abnValue){
                searchValue = abnValue;
            }
        }
        searchTaxNumber(simPRODefaults.data("country"), searchValue);
        return false;
    }).delegate(".searchCompanyNumber", "click", function() {
        var searchType = "name";
        var searchValue = $("#" + $(this).attr("taxName")).val();
        var acn = $(this).prev();
        if (acn) {
            var acnValue = acn.val();
            if (acnValue != "") {
                searchType = "acn";
                searchValue = acnValue;
            }
        }
        searchCompanyNumber(simPRODefaults.data("build-country"), searchValue, searchType);
        return false;
    }).delegate(".openURL", "click", function(){
        openURL($("#" + $(this).attr("url")).val());
        return false;
    }).delegate(".openEmail", "click", function(){
        var email = $($(this).attr("email")).val();
        if (email != ""){
            window.open("mailto:" + email);
        } else {
            createDialog("alert", gettext("Enter an email address."));
        }
        return false;
    });

    // Show content on click
    $(context).delegate(".showOnClick", "click", function(e){
        if ($(this).is("a")){
            e.preventDefault();
        }
        var href = $(this).attr("href");
        if (href.charAt(0) != "." && href.charAt(0) != "#"){
            href = "#" + href;
        }
        var options = {
            button: $(this)
        };
        if ($(this).attr("duration")){
            options.duration = parseInt($(this).attr("duration"));
        }
        if ($(this).hasClass("alwaysShow")){
            options.showHide = "show";
        } else if ($(this).hasClass("alwaysHide")){
            options.showHide = "hide";
        }
        if ($(href).is(":visible") && $(this).attr("showText")){
            options.text = $(this).attr("showText");
            if ($(this).attr("showClass") && $(this).attr("hideClass")){
                options.showClass = $(this).attr("showClass");
                options.hideClass = $(this).attr("hideClass");
            }
        } else if ($(href).is(":hidden") && $(this).attr("hideText")){
            options.text = $(this).attr("hideText");
            if ($(this).attr("showClass") && $(this).attr("hideClass")){
                options.showClass = $(this).attr("hideClass");
                options.hideClass = $(this).attr("showClass");
            }
        }

        if($(this).children('span[class*=icon-]').length > 0 && !$(this).hasClass('linkImgCollapseAll') && !$(this).hasClass('linkImgExpandAll')) {
            $(this).children('span[class*=icon-]').toggleClass('icon-down-arrow').toggleClass('icon-up-arrow');
        }

        showOnClick(href, options);

        if($(this).hasClass('linkImgCollapseAll') || $(this).hasClass('linkImgExpandAll')) {
            var arrows = $('.linkImgExpand span[class*=icon-]');
            if ($(href).is(":hidden")) {
                arrows.removeClass('icon-up-arrow').addClass('icon-down-arrow');
            } else {
                arrows.removeClass('icon-down-arrow').addClass('icon-up-arrow');
            }
        }
        prepareDocument($(href));
    }).on("click", ".expand-js", function(){
        expandJS(this);
    });

    $(context).delegate(".toggleNode", "click", function(){
        if ($(this).closest(".warning").exists()) {
            $(this).toggleClass("expanded icon-down-arrow icon-up-arrow");
        } else {
            $(this).toggleClass("expanded icon-down-arrow icon-right-arrow");
        }
        showOnClick($(this).attr("href"));
        return false;
    });

    $(context).on("mouseenter", ".attachmentViewBreadcrumb",function(){
        if(this.offsetWidth < this.scrollWidth){
            $(this).addClass("expandBreadCrumb");
        } else {
            $(this).removeClass("expandBreadCrumb");
        }
    });

    //filters the target table/s given the search word
    $(context).on("keyup", ".filterTextBox-js", function() {
        var filterTable = $(this).data('target-table');

        //get tables that contains the text from data-target-table - there can be more than one target table
        var filterTableList = $(filterTable);
        var keyword = $(this).val().toLowerCase();
        $.each(filterTableList, function() {
            var filterTable = $(this);
            if (keyword != "") {
                filterTable.attr("placeholder", filterTable.data("search-text"));
            } else {
                filterTable.attr("placeholder", filterTable.data("placeholder"));
            }
            filterTable.find("tr:has(td)").each(function() {
                if ($(this).text().toLowerCase().indexOf(keyword) >=0) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        });
    });



    // Left sidebar
    $(context).delegate(".toggleBtn", "click", function(){
        if($("#companySelector").hasClass("closed")){
            $("#companySelector").animate({
                left:0
            }, "fast", function(){
                $(this).removeClass("closed").addClass("opened");
                $("a#toggleLink").removeClass("toggleBtn").addClass("toggleBtnHighlight");
            });
        }
        return false;
    }).delegate(".toggleBtnHighlight", "click", function(){
        if($("#companySelector").hasClass("opened")){
            $("#companySelector").animate({
                left:-212
            }, "fast", function(){
                $(this).removeClass("opened").addClass("closed");
                $("a#toggleLink").removeClass("toggleBtnHighlight").addClass("toggleBtn");
            });
        }
        return false;
    });

    // Right sidebar
    $("#verticalNav").delegate(".top", "click", function(){
        $("html, body").animate({
            scrollTop:0
        }, "800");
        return false;
    }).delegate(".content", "click", function(){
        $("html, body").animate({
            scrollTop:$("#main").offset().top
        }, "800");
        return false;
    }).delegate(".bottom", "click", function(){
        $("html, body").animate({
            scrollTop:$(document).height()
        }, "800");
        return false;
    });

    // If mandatory field is empty, show red colour
    $(document).delegate(".mandatory.error", "keyup change paste", function(){
        var $this = $(this);
        $this.removeClass('error');
        if ($this.hasClass('suggestSelect')) {
            $this.next().removeClass('mandatoryFail error');
        }
    });

    // Check if name exists
    var checkExistsIntval;
    $(context).delegate(".checkExists", "keyup", function(){
        var $this = $(this);
        window.clearTimeout(checkExistsIntval);
        checkExistsIntval = window.setTimeout(function() {
            checkExists($this);
        }, 500);
    });

    // Re-enable any input fields under the sortable list which were disabled when sortable was initialised
    $(context).delegate(".sortable input, .sortable textarea", "click.sortable mousedown.sortable", function(e){
        e.target.focus();
    });

    // Hotkeys
    $(document).on("keypress", function(e) {
        if (hotkeyTriggered) {
            e.preventDefault();
            return false;
            }
        });
    configureHotKeys();
    // Grid header sort states styling
    $(".tableSorter thead th:not(.ajaxOrder)").bind("click", function() {
        if ($(this).children().hasClass("desc")){
            $(this).children().removeClass("desc");
        } else {
            $(this).children().addClass("desc");
        }
    });

    $(document).on("mouseenter", "#cNav .mainMenu .levelOne", function() {
        var screenX = $(document).width();
        var menuHover = $(this).children('.menuHover');
        var menuTopArrow = $(this).find('.topArrow');
        menuHover.show();
        var menuWidth = menuHover.width();
        var location = menuHover.offset();
        if (location != null) {
            var locationX = location.left;
            if (locationX + menuWidth > screenX) {
                menuTopArrow.addClass('topArrowRight')
                menuTopArrow.removeClass('topArrowLeft')
                menuHover.addClass('rightItem')
            }
        }
    }).on("mouseleave", "#cNav .mainMenu .levelOne", function() {
        $(this).children('.menuHover').hide();
    }).delegate(".companyChange", "click", function(){
        var companyID = $(this).data("companyid");
        var url = simPRODefaults.data("page-url");
        url += url.indexOf("?") == -1 ? "?" : "&";
        url += "companySelection=" + companyID;
        url += checkTabs();
        window.location.href=url;
    }).on("click", ".gSearch .iconErase", function() {
        if ($("#globalSearch").val() != "") {
            $("#globalSearch").val("");
        }
    }).on("submit","#globalSearchForm", function() {
        // Prevent suggestselect ajax / dropdown functionality if the user has 'submitted' the global search
        // because the results will be loaded on a new page. (globalSearch.php)
      globalSearch = true;
      if (autocompleteXHR) {
          autocompleteXHR.abort();
      }
      $("#globalSearch").blur();
      showLoadingImage();
	}).on("click", ".btnFilter",function() {
		$(".filterDetail").toggle();
	}).on("blur", "#globalSearch", function() {
		if ($(this).val() == ""){
			$(this).prev().removeClass('hide');
		} else {
			$(this).prev().addClass('hide');
		}
	}).on("focus", "#globalSearch", function() {
		$(this).prev().addClass('hide')
	});

    let savedSearchesMenuTimeout = null;
    $(context).delegate("#toggleSavedSearches", "mouseenter", function() {
        // show saved searches menu WITH delay on hover
        savedSearchesMenuTimeout = setTimeout(function() {
            $("#savedSearchesMenu").show();
        }, 250);
    }).delegate("#savedSearchesMenu", "mouseenter ", function() {
        // keep showing saved searched menu when hovering over items
        clearTimeout(savedSearchesMenuTimeout);
        $("#savedSearchesMenu").show();
    }).delegate("#toggleSavedSearches, #savedSearchesMenu", "mouseleave", function() {
        // hide saved searches menu WITHOUT delay on hover away
        clearTimeout(savedSearchesMenuTimeout);
        $("#savedSearchesMenu").hide();
    }).delegate(".dropDownParent", "click",function() {
        $(this).next().toggle();
    }).on("keydown", "textarea", function (e) {
        textarea_timestamp($(this), e);
    }).on('blur', 'input.email', function() {
        var allowEmpty = true;
        if ($(this).hasClass("mandatory")) {
            allowEmpty = false;
        }
        if ($(this).data("email-multiple")) {
            var emailAddresses = $(this).val().split(",");
            var emailTooltipTxt = gettext("Invalid email addresses");
        } else {
            var emailAddresses = [$(this).val()];
            var emailTooltipTxt = gettext("Invalid email address");
        }
        for (i = 0; i < emailAddresses.length; i++) {
            var email = emailAddresses[i].trim();
            if (!validateEmail(email, allowEmpty)) {
                var tooltipHTML = "<span id='emailTooltip'><span class='icon-exclamation'></span> " + emailTooltipTxt + "</span>";
                $(this).attr("title", tooltipHTML);
                $(this).addClass('error invalidInput');
                $(this).one('input', function() {
                    $(this).removeClass("error invalidInput");
                });
                createToolTip($(this), true);
                return false;
            }
        }
    }).on('focus keyup change paste', "input[type=url]", function() {
        //the tooltip and validation for URL
        if ($(this).val().match(new RegExp("(^http:\/\/|^https:\/\/)", "i"))) {
            $(this).removeClass("wrongInput");
        } else {
            $(this).addClass("wrongInput");
        }
    }).on('blur', 'input[type=url]', function() {
        //url validation
        // wrap a div around the input and add a span after the input for validation display
        if ($.trim($(this).val()) !== "") {
            if ($(this).parent().hasClass('validGroupedInput')) {
                var validationSpan = $(this).next('span');
                validationSpan.removeClass();
            } else {
                $(this).wrap("<div class='validGroupedInput'></div>").after("<span class=''></span>");
                var validationSpan = $(this).next('span');
            }
            var valid = !$(this).hasClass("wrongInput");
            //add/remove tooltip
            if (valid) {
                validationSpan.addClass("urlTipTasks icon-check-alt textGreen");
                $('.tooltip').remove();
            } else {
                var tooltipHTML =
                    "<span id='urlTooltip'><span class='icon-exclamation'></span> " +
                    gettext("This URL does not follow required syntax:</br> <strong>Must start with http:// or https://</strong>") +
                    "</span>";
                validationSpan.addClass("urlTipClose-js icon-close textRed").attr("title", tooltipHTML);
                createToolTip(validationSpan, true);
            }
        }
    });

    //Add the csrf token as hidden input if it is not in the form (i.e. for dialog forms)
    $(document).on('submit', 'form', function (e) {
        var csrfElement = $(this).find('#' + csrfParamName());
        if (csrfElement.length <= 0) {
            $(this).append("<input type='hidden' id='" + csrfParamName() + "' name='" + csrfParamName() + "' value='" + csrfParamValue() + "' />");
        }
    });

    // Anchor links with the popupLink class should be opened in a new popup window.
    $(document).on('click', 'a.popupLink', function(e) {
        e.preventDefault();
        window.open($(this).attr('href'), "", "width=1175,height=740,left=100,top=100,screenX=100,screenY=100,resizable=no,scrollbars=yes");
    });

    $(document).on("click", "#bulkOverridePrerequisiteTask", function (e) {
        e.preventDefault();
        let url = $('#tasksFrame .divForm').attr('action');
        if (typeof url === "undefined") {
            url ="tasks.php?";
        }
        url += "&ajaxCall=true";
        $.ajax({
            type: "POST",
            url: url,
            data: $(this).data('form-data'),
            success: function(data) {
                showResponse(data);
            }
        });
    });


    // toggle switch
    $(minorContext).on('click', 'label.switch', function(e) {
        const $hiddenInput = $(this).find('input[type=hidden]');
        if (!$hiddenInput.length) {
            return;
        }

        if ($hiddenInput.hasClass('checked')) {
            $hiddenInput
                .removeClass('checked')
                .val(0);
        } else {
            $hiddenInput
                .addClass('checked')
                .val(1);
        }
        // triggering a change on the hidden input because we want devs to still listen to change
        // event on a toggle click
        $(this).blur();
        $hiddenInput.trigger('change');
    }).on('keydown', '.slider', function(e) {
        if (e.which==13 || e.which==32) {
            $(this).click();
        }
    })

    // Autosave - display
    $(minorContext).on('click', '#autosaveToggle', function(e) {
        updateDisplaySaveButton();
    });
}

function getBackLinkURL(deleteBackLink, $this) {
    deleteBackLink = (typeof(deleteBackLink) === "undefined" ? "true": "false");
    let $backLinkURL = $('#backLinkURL');
    let url = $backLinkURL.exists() ? $backLinkURL.val() : document.URL;
    url += url.indexOf("?") == -1 ? "?" : "";
    var backlinkExists = url.indexOf("&backLinkStart");
    if(backlinkExists != -1) {
        url = url.substring(0, backlinkExists);
    }
    url += "&backLinkStart=1";
    if((typeof $this !== "undefined") && (typeof $this.attr("params") !== "undefined")) {
        if($this.attr("params").charAt(0) != "&") {
            url += "&";
        }
        url += $this.attr("params");
    }
    let currentPage = $("#currentPageNo");
    if (!currentPage.exists()) {
        currentPage = $("#jpPage");
    }
    if (currentPage.exists()) {
        url += "&formContent[]=" + "pageNo=" + currentPage.val();
    }

    // Get inputs, selects
    var searchForm = $(".divForm,.reportForm");
    var order = searchForm.find(".ajaxOrder.current");
    if(order.exists()) {
        url += "&formContent[]=order=" + order.attr("order");
        if(order.find(".desc").exists()) {
            url += "&formContent[]=orderDirection=DESC";
        } else {
            url += "&formContent[]=orderDirection=ASC";
        }
    }
    var elements = searchForm.find("input, select, textarea").filter(":not(.saveBackLinkExclude)").serializeArray();
    var iframe = false;
    if(typeof $this !== "undefined" && $this.closest(".iframe")) {
        iframe = true;
    }
    $.each(elements, function(index, item) {
        if(item.name == "iframe" && iframe) {
            return true;
        }
        url += "&formContent[]=" + item.name + "=" + encodeURIComponent(item.value);
    });
    // Get tabs
    var tabs = checkTabs(true);
    $.each(tabs, function(index, item) {
        url += "&formContent[]=" + index + "=" + encodeURIComponent(item);
    });

    url += "&formContent[]=deleteBackLink=" + deleteBackLink;
    url += "&formContent[]=scrollbar=" + $(window).scrollTop();
    //move #(fragment identifier) in url to end so it wont breaks the flow
    var hashIndex = url.indexOf("#");
    if (hashIndex != -1) {
        var nextAmpersandIndex = url.indexOf("&", hashIndex);
        if (nextAmpersandIndex != -1) {
            var fragment = url.substring(hashIndex, nextAmpersandIndex);
            var urlWithoutFragment = url.substring(0, hashIndex) + url.substring(nextAmpersandIndex);
            url = urlWithoutFragment + fragment;
        }
    }
    return url;
}

function validateEmail(email, allowEmpty) {
    if (allowEmpty && email == '') {
        return true;
    } else {
        return isRFC822ValidEmail(email);
    }
}

function attachCalculateSize (format) {
    var bytes = 0;
    $("input[name='formAttachment[]']:checked").each(function () {
        bytes += $(this).data("filesize");
    });
    if (format) {
        $("#formFilesize").html(filesizeFormat(bytes));
    } else {
        return bytes;
    }
}

//Returns data in the format csrfToken=22f...
function csrfParamString() {
    var name = csrfParamName();
    if (name != undefined && name !== "") {
        return name + "=" + csrfParamValue();
    } else {
        return "";
    }
}

//Just the csrf variable name.
function csrfParamName() {
    return $("meta[name='csrf-param']").attr('content');
}

//Just the csrf data.
function csrfParamValue() {
    return $("meta[name='csrf-token']").attr('content');
}

$.ajaxPrefilter(function(options, origOptions, jqXHR){
    if (options.type.toLowerCase() === "post") {
        // initialize `data` to empty string if it does not exist
        options.data = options.data || "";

        // add leading ampersand if `data` is non-empty
        options.data += options.data?"&":"";

        // add token entry
        options.data += csrfParamString();
    }
});

var quickLinkUpdate = false;
let autoSaveTriggered = false;

// Ajax submit. If the element has a target, it will submit the target form. Otherwise it will submit the parent form or the nearest form.
function ajaxSubmit(element, params, callback, loadingImage) {
    quickLinkUpdate = false;
    var target, targetElement, logMessage;
    // Get form to submit
   if(loadingImage == null) {
        loadingImage = true;
    }
    if(element == null) {
        logMessage = 'ajaxSubmit via element == null';
        $("#main").append('<form method="post" action="' + simPRODefaults.data("page-url") + '" id="ajaxCreatedForm"></form>');
        targetElement = $("#ajaxCreatedForm");
    } else if ($(element).is("form")){
        logMessage = 'ajaxSubmit via element.is(form)';
        targetElement = $(element);
    } else if ($(element).attr("target")){
        logMessage = 'ajaxSubmit via element.attr(target)';
        target = $(element).attr("target");
        if (target.indexOf(".") != -1 || target.indexOf("#") != -1) {
            targetElement = $(target);
        } else {
            targetElement = $("#" + target);
        }
    } else if ($(element).closest(".divForm, form").exists()) {
        logMessage = 'ajaxSubmit via element.closest(.divForm, form)';
        targetElement = $(element).closest(".divForm, form").first();
    } else{
        var $firstDivForm = $('#main .divForm:first');
        if ($firstDivForm.exists() && !$firstDivForm.parents('form').exists()){
            logMessage = 'ajaxSubmit via #main .divForm:first';
            targetElement = $firstDivForm;
        } else {
            logMessage = 'ajaxSubmit via #main form:first';
            targetElement = $("#main form:first");
        }
    }
    if ($(element).is('button')) {
        // if a dialogue is shown we want the enter key to not trigger again on the button that did the ajax call
        $(element).blur();
    }

    // Check for mandatory fields if required
    if ($(element).hasClass("checkMandatory")){
        var mandatoryTarget = targetElement;
        if(typeof($(element).data("mandatory-target")) != 'undefined') {
            mandatoryTarget = $(element).data("mandatory-target");
        }
        var success = checkMandatory(mandatoryTarget);
        if (!success){
            return false;
        }
    }

    // Loading Image
    if (loadingImage) {
        showLoadingImage();
    }
    if (tinymce.activeEditor && tinymce.activeEditor.id == 'mcePagewidthTextarea') {
        let sourceEditorID = $(tinymce.activeEditor.getElement()).data('sourceEditor');
        let editor = tinymce.activeEditor;
        let sourceEditor = tinymce.get(sourceEditorID);
        let content = editor.getContent();
        sourceEditor.setContent(content);
        sourceEditor.windowManager.close();
        editor.destroy();
    }
    tinymce.triggerSave();


    // Check if form has an order by element
    var orderBy = $("th.current[order]:first", targetElement);
    if (!$(orderBy).exists()){
        orderBy = $("th.current[order]:first");
    }
    if ($(orderBy).exists() && $(orderBy).attr("order")){
        params += "&order=" + $(orderBy).attr("order");
        if($(orderBy).find("a").hasClass("desc")) {
            params += "&orderDirection=DESC";
        } else {
            params += "&orderDirection=ASC";
        }
    }
    // Close any open select boxes
    if (autocompleteXHR){
        autocompleteXHR.abort();
    }
    $(".suggestSelect").suggestselect("close");
    // Disable any input elements in divFrames or dialogs that could conflict with main page

    disableElements(targetElement);

    // Hide any hidden dialogs
    $(".hiddenDialog-js").hide();

    let url = "";
    // Support the clicked element being able to override the forms action with "formaction"
    if (typeof $(element).attr("formaction") !== "undefined") {
        url = $(element).attr("formaction");
    } else if (typeof $(targetElement).attr("action") !== "undefined") {
        url = $(targetElement).attr("action");
    }
    url += url.indexOf("?") === -1 ? "?" : "&";
    url += "ajaxCall=true" + checkTabs();

    if ($(targetElement).is(".singleInput")){
        // Setup parameters
        if (params && params != ""){
            params = params.split("&");
            var string = "";
            $.each(params, function(index, item) {
                var splitItem = item.split("=");
                var name = splitItem[0];
                var value = decodeURIComponent(splitItem[1]); // decode in case already encoded by serialize
                string += "<input type='hidden' name='" + name + "' value='" + value + "' class='ajaxFormParams' />";
            });
            $(string).appendTo(targetElement);
        }
        $(targetElement).addClass("ajaxForm").ajaxForm({
            url: url + '&' + csrfParamString(),
            success: function(responseText, statusText, xhr, $form) {
                enableElements(targetElement);
                if ($(element).attr("callback")){
                    callback = $(element).attr("callback");
                } else if ($(element).data("callback")){
                    callback = $(element).data("callback");
                }
                showResponse(responseText, callback, loadingImage);
            },
            complete: function(xhr,textStatus){
                ajaxComplete(xhr,textStatus,loadingImage);
            }
        }).submit().removeClass("ajaxForm").ajaxFormUnbind();
        $(".ajaxFormParams").remove();
    } else {
        var data = getFormData(targetElement);
        if(params) {
            if(data && params.charAt(0) != "&") {
                data += "&";
            }
            data += params;
        }
        var doComplete = null;
        $.ajax({
            type: "POST",
            data: data,
            url: url,
            success: function(responseText, statusText, xhr, $form) {
                enableElements(targetElement);
                if ($(element).attr("callback")) {
                    callback = $(element).attr("callback");
                } else if ($(element).data("callback")){
                    callback = $(element).data("callback");
                }
                showResponse(responseText,callback, loadingImage);

            },
            error: function(xhr,textStatus,errorThrown) {
                var errorCallback = $(element).data("errorcallback");
                if (typeof window[errorCallback] === 'function') {
                    doComplete = window[errorCallback].call(this, xhr,textStatus,errorThrown);
                }
            },
            complete: function(xhr,textStatus){
                if (false!==doComplete) {
                    ajaxComplete(xhr, textStatus, loadingImage);
                }
            }
        });
    }
    if(element == null) {
        $(targetElement).remove();
    }
}

function getFormArrayData(targetElement) {
    let $targetElement = $(targetElement);
    // getting serialize data without array parameters
    let parametersNames = $targetElement.data('json_array_parameters').split(",");
    parametersNames = $.map(parametersNames, $.trim);
    const parametersSelect = ':not([name*="' + parametersNames.join('["]):not([name*="') + '["])';
    let data = $targetElement.find('input' + parametersSelect + ', select' + parametersSelect + ', textarea' + parametersSelect).serialize();

    // getting array parameters for converting to Json
    const inputSelect = 'input[name*="' + parametersNames.join('["], input[name*="') + '["]';
    const selectSelect = 'select[name*="' + parametersNames.join('["], select[name*="') + '["]';
    const textAreaSelect = 'textarea[name*="' + parametersNames.join('["], textarea[name*="') + '["]';
    const serializeData = $(targetElement).find(inputSelect + ', ' + selectSelect + ', ' + textAreaSelect).serializeArray();

    // converting to json
    const jsonData = {};
    let previousObject;
    let previousKey;
    let reference;
    let keys;
    let firstKey;
    let foundFirstKey;
    serializeData.forEach(function (param) {
        if(param) {
            keys = param.name.match(/(\[(?:\[??[^\[]*?\]))/g);
            foundFirstKey = param.name.match(/^(.+?)\[/);
            if(foundFirstKey && keys) {
                firstKey = foundFirstKey[1];
                reference = jsonData;
                if (!reference[firstKey]) {
                    reference[firstKey] = {};
                }
                reference = reference[firstKey];
                keys.forEach( function (key) {
                    let trimmedKey = key.substring(1,key.length-1);
                    if (!reference[trimmedKey]) {
                        reference[trimmedKey] = {};
                    }
                    previousKey = trimmedKey;
                    previousObject = reference;
                    reference = reference[trimmedKey];
                });
                previousObject[previousKey] = param.value;
            }
        }
    });
    // Adding json data to the serialize data
    for (let key in jsonData) {
        data += '&' + key + '=' + encodeURIComponent(JSON.stringify(jsonData[key]));
    }
    return data;
}

function getFormData(targetElement) {
    if ($(targetElement).data('json_array_parameters')) {
        return getFormArrayData(targetElement);
    } else {
        return $(targetElement).find("input, select, textarea").serialize();
    }
}

function disableElements(target) {
    $(target).find(".iframe").find("input, select, textarea").filter(":not(:disabled)").prop("disabled", true).addClass("formSubmitDisabled");
    $(target).find(".dialogBox").filter(":not(:visible)").find("input, select, textarea").filter(":not(:disabled)").prop("disabled",true).addClass("formSubmitDisabled");
}

function enableElements(target) {
    $(target).find(".formSubmitDisabled").prop("disabled", false).removeClass("formSubmitDisabled");
}

// Graphs
function createGraph(item){
    if (!$(item).find(".highcharts-container").exists()){
        graphCounter++;
        var presetColours = {
            blue: "#3D96AE",
            darkblue: "#4572A7",
            lightgreen: "#8BD831",
            green: "#5BA801",
            lightolive: "#B5CA92",
            olive: "#89A54E",
            red: "#CD1212",
            maroon: "#AA4643",
            orange: "#DB843D",
            lightpurple: "#92A8CD",
            purple: "#80699B",
            grey: "#CCCCCC",
            darkgrey: "#999999"
        };
        if ($(item).attr("href")){
            var table = $("#" + $(item).attr("href"));
        } else {
            var table = $(item).find("table:first");
        }
        if ($(item).attr("currency")) {
            var currencySign = $(item).attr("currency");
        } else if ($(item).data("tooltipformat") === "number") {
            var currencySign = "";
        } else {
            var currencySign = simPRODefaults.data("currency-symbol");
        }
        if ($(item).attr("legend") && ($(item).attr("legend") == false || $(item).attr("legend") == "false")){
            var legend = false;
        } else {
            var legend = true;
        }
        if ($(item).attr("dataLabels") && ($(item).attr("dataLabels") == true || $(item).attr("dataLabels") == "true")){
            var dataLabels = true;
        } else {
            var dataLabels = false;
        }
        if ($(item).attr("stacked")){
            var stacked = $(item).attr("stacked");
        } else {
            var stacked = null;
        }
        if ($(item).attr("columnCursor")){
            var columnCursor= $(item).attr("columnCursor");
        } else {
            var columnCursor = '';
        }
        if ($(item).attr("graphType")){
            var graphType = $(item).attr("graphType");
        } else {
            var graphType = 'column';
        }
        if ($(item).attr("graphTitle")) {
            var graphTitle = $(item).attr("graphTitle");
        } else {
            var graphTitle = '';
        }
        if ($(item).attr("columnWidth")){
            var columnWidth = parseInt($(item).attr("columnWidth"));
        } else {
            var columnWidth = null;
        }
        if ($(item).attr("xAxisRotation")){
            var xAxisRotation = $(item).attr("xAxisRotation");
        } else {
            var xAxisRotation = 0;
        }
        if ($(item).attr("legendLocation")){
            var legendLocation = $(item).attr("legendLocation");
        } else {
            var legendLocation = 'top';
        }

        var showXLabels = !($(item).attr("hideXLabels") && ($(item).attr("hideXLabels") == true || $(item).attr("hideXLabels") == "true"));
        var showYLabels = !($(item).attr("hideYLabels") && ($(item).attr("hideYLabels") == true || $(item).attr("hideYLabels") == "true"));

        var categories = [];
        $("tbody td.axisTitle", table).each(function (i) {
            categories.push(this.innerHTML);
        });
        var colours = [];
        $(table).find("th[colour]").each(function () {
            colours.push(presetColours[$(this).attr("colour")]);
        });
        var series = [];
        if (graphType == "pie"){
            series.push({
                "type": "pie",
                "name": $(item).attr("graphName"),
                "cursor": "pointer",
                "data": [],
                "animation": false,
                "tooltipdecimals": (typeof $(item).data("tooltipdecimals") !== 'undefined' ? $(item).data("tooltipdecimals") : 0)
            });
            $("tr:not(tfoot tr)", table).each(function (i) {
                var tr = this;
                let tempInput = $('<input>');
                $("td", tr).each(function (j) {
                    if (j == 0) {
                        series[0].data[i] = [];
                    }
                    //let value = tempInput.val(this.innerHTML.replace(/[^\-\d.,]/g, '')).getNumber();
                    if (j == 1) {
                        var value = tempInput.val(this.innerHTML.replace(/[^\-\d.,]/g, "")).getNumber();
                    } else {
                        var value = this.innerHTML;
                    }
                    series[0].data[i][j] = value;
                });
            });
        } else {
            $("tr:not(tfoot tr)", table).each(function(i) {
                var tr = this;
                let tempInput = $('<input>');
                $("th, td", tr).each(function (j) {
                    if (j > 0) {
                        if (i == 0) {
                            series[j - 1] = {
                                name: $(this).text(),
                                data: [],
                                animation: false,
                                tooltipData: $(this).data("tooltip"),
                                tooltipdecimals: (typeof $(this).data("tooltipdecimals") !== 'undefined' ? $(this).data("tooltipdecimals") : 0)

                            };
                        } else {
                            //format input number to decimal
                            var value = tempInput.val(this.innerHTML.replace(/[^\-\d.,]/g, '')).getNumber();
                            if (!stacked || value > 0) {
                                series[j - 1].data.push(value);
                            }
                        }
                    }
                });
            });
        }
        if ($(table).hasClass("compare")){
            var colours = [presetColours.grey, presetColours.darkgrey];
            $(table).find("thead th").each(function(index, row) {
                if ($(row).hasClass("green")){
                    colours.splice(index-1, 0, presetColours.green);
                } else if ($(row).hasClass("red")){
                    colours.splice(index-1, 0, presetColours.red);
                }
            });
        } else if (colours.length == 0){
            var colours = [presetColours.darkblue, presetColours.maroon, presetColours.olive, presetColours.purple, presetColours.blue, presetColours.orange, presetColours.lightpurple, presetColours.lightgreen, presetColours.lightolive];
        }
        var renderTo = "renderTo" + graphCounter;
        if($(item).attr("graphHeight")) {
            graphHeight = $(item).attr("graphHeight");
        } else{
            graphHeight = $(item).parent().height();
        }
        if($(item).attr("graphWidth")) {
            graphWidth = $(item).attr("graphWidth");
        } else{
            graphWidth = null;
        }
        var marginLeft = 45;
        var marginBottom = 40;
        var marginTop = 50;
        var marginRight = 0;
        if($(item).attr("graphMarginBottom")) {
            marginBottom = $(item).attr("graphMarginBottom");
            if (marginBottom === "null") {
                marginBottom = null;
            }
        }
        if($(item).attr("graphMarginLeft")) {
            marginLeft = $(item).attr("graphMarginLeft");
            if (marginLeft === "null") {
                marginLeft = null;
            }
        }
        if($(item).attr("graphMarginTop")) {
            marginTop = $(item).attr("graphMarginTop");
            if (marginTop === "null") {
                marginTop = null;
            }
        }
        if($(item).attr("graphMarginRight")) {
            marginRight = $(item).attr("graphMarginRight");
            if (marginRight === "null") {
                marginRight = null;
            }
        }
        options = {
            chart: {
                defaultSeriesType: graphType,
                margin: [marginTop, marginRight, marginBottom, marginLeft],
                renderTo: renderTo,
                height:	graphHeight,
                width: graphWidth,
                animation: false
            },
            colors: colours,
            credits: {
                enabled: false
            },
            exporting: {
                filename: $(item).attr("filename") ? $(item).attr("filename") : "graph"
            },
            legend: {
                verticalAlign: legendLocation,
                enabled: legend,
                floating: false,
                useHTML: true,
                y: -13
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        color: '#040404',
                        connectorColor: '#000000',
                        formatter: function() {
                            //useHTML does not function correctly here.  replace is a better solution
                            this.point.name = this.point.name.replace("&amp;", "&");
                            if (this.point.name.length > 15) {
                                dataLabel = this.point.name.substr(0, 15) + '...';
                            } else {
                                dataLabel = this.point.name;
                            }
                            return '<strong>' + dataLabel + '</strong>:' + Highcharts.numberFormat(this.percentage, 2, simPRODefaults.data("number-format-decimal"), simPRODefaults.data("number-format-separator")) + ' %';
                        },
                        style: {
                            "fontSize": "12px",
                            "fontWeight": "normal",
                            "textShadow": ""
                        }
                    }
                },
                column: {
                    dataLabels: {
                        align: "left",
                        color: "#040404",
                        enabled: dataLabels,
                        formatter: function() {
                            var dataLabel = "";
                            if (graphType == "pie"){
                                dataLabel += "<strong>" + this.key + "</strong>: " + this.y + " (" + this.percentage.toFixed(2) + "%)";
                            } else {
                                if (this.x != ""){
                                    dataLabel += "<strong>" + this.x + "</strong>";
                                }
                                if (dataLabel != ""){
                                    dataLabel += "<br />";
                                }
                                dataLabel += this.series.name + ":<br />" + Highcharts.numberFormat(this.y, 2, simPRODefaults.data("number-format-decimal"), simPRODefaults.data("number-format-separator"));
                            }
                            return dataLabel;
                        },
                        style: {
                            font: "12px Arial, Helvetica, sans-serif",
                            color: "#404040"
                        },
                        useHTML: true,
                        x: columnWidth + 5
                    },
                    useHTML: true,
                    pointWidth: columnWidth,
                    stacking: stacked,
                    cursor: columnCursor,
                    groupPadding : 0,
                    pointPadding: 0.1
                },
                series: {
                    events: {
                        click: function(event) {
                            var href = $("thead th:eq(" + (this.index + 1) + ")", table).attr("href");
                            var page = $("#page");
                            page.css('height',page.css('height'));
                            if (href && href != ""){
                                $(item).html("").removeAttr("id").attr("href", href);
                                createGraph(item);
                            }
                            page.css('height', '');
                        }
                    },
                    point: {
                        events: {
                            click: function() {
                                var href = $("tbody tr:eq(" + (this.x) + ") td:first", table).attr("href");
                                var url = $("tbody tr:eq(" + (this.x) + ") td:last", table).attr("href");
                                var page = $("#page");
                                page.css('height',page.css('height'));
                                if (href && href != ""){
                                    $(item).html("").removeAttr("id").attr("href", href);
                                    createGraph(item);
                                }
                                page.css('height', '');
                                if (url && url!='') {
                                    location.href = url;
                                }
                            }
                        }
                    }
                }
            },
            series: series,
            title: {
                text: graphTitle,
                style: {"fontWeight":'bold', "color":'#4C4C4C', "fontSize":'14px', "fontFamily":'Roboto'}
            },
            tooltip: {
                formatter: function() {
                    var tooltip = "";
                    if (graphType == "pie") {
                        tooltip += "<strong>" + this.key + "</strong>: "
                            + Highcharts.numberFormat(this.y, this.series.options.tooltipdecimals, simPRODefaults.data("number-format-decimal"), simPRODefaults.data("number-format-separator"))
                            + " (" + Highcharts.numberFormat(this.percentage, 2, simPRODefaults.data("number-format-decimal"), simPRODefaults.data("number-format-separator")) + "%)";
                    } else {
                        if (this.x != "") {
                            tooltip += "<strong>" + this.x + "</strong>";
                        }
                        if (tooltip != "") {
                            tooltip += "<br />";
                        }
                        if (this.series.options.tooltipData !== undefined) {
                            let tooltipData = this.series.options.tooltipData;
                            if (tooltipData instanceof Object) {
                                for (let i = 0; i < Object.keys(tooltipData).length; i++) {
                                    let label = Object.keys(tooltipData)[i];
                                    tooltip += label + " : " + currencySign + tooltipData[label] + "<br/>";
                                }
                            }
                        } else {
                            tooltip += this.series.name + ": " + currencySign
                                + Highcharts.numberFormat(this.y, this.series.options.tooltipdecimals, simPRODefaults.data("number-format-decimal"), simPRODefaults.data("number-format-separator"));
                        }
                    }
                    return tooltip;
                },
                useHTML: true
            },
            xAxis: {
                categories: categories,
                labels: {
                    style: {
                        font: "12px Arial, Helvetica, sans-serif",
                        color: "#404040"
                    },
                    y: 20,
                    useHTML: true,
                    rotation : parseInt(xAxisRotation),
                    enabled: showXLabels
                }
            },
            yAxis: {
                labels: {
                    style: {
                        font: "12px Arial, Helvetica, sans-serif",
                        color: "#404040"
                    }
                },
                minorTickInterval: "auto",
                title: "",
                enabled: showYLabels
            }
        }
        $("#content").append($(item).children("table").hide());
        $(item).attr("id", renderTo);
        new Highcharts.Chart(options);
    }
}

// Returns selected tabs' selectedItem
function checkTabs(asArray){
    var params = {};
    $(".mainTab.current, .subTab.current").filter(":visible").each(function(index, item) {
        var name = $(this).closest("ul").attr("id") + "SelectedItem";
        params[name] = $(this).attr("data-container");
    });
    if (asArray){
        return params;
    } else if ($.param(params)) {
        return "&" + $.param(params);
    } else {
        return "";
    }
}

//remove mandatory fields
function removeMandatory(targetElement) {
    $(targetElement)
        .find(".mandatory:enabled, .invalidInput:enabled") // dont check disabled elements
        .each(
            function(index, item) {
                let $item = $(item);
                if ($item.hasClass('mandatory')){
                    $item.removeClass('mandatory');
                }
                if ($item.hasClass('error')){
                    $item.removeClass('error');
                }
            }
        );
}

// If mandatory field is empty, show red colour
function checkMandatory(targetElement, isForSession = false) {
    var
        // a list of all fields that are invalid
        // invalid fields are fields with class of mandatory & not complete
        invalidFields = [],
        invalidButtons = [],
        invalidListBoxes = [],
        // mandatory group items
        invalidFieldGroup = [],
        // mandatory group item message
        invalidFieldGroupIndex = [],
        // any mandatory group item valid
        isAnyMemberValid = false,
        message;
    $(targetElement)
        .find(".mandatory:enabled, .invalidInput:enabled") // dont check disabled elements
        .each(
            function(index, item) {
                /* if the input is valid / filled / completed this will be set true */
                var $item = $(item);
                var invalid = false;
                if ($item.hasClass("tinyMCEEditor")) {
                    tinymce.get($item.attr("id")).dom.removeClass(tinymce.get($item.attr("id")).dom.select('body'), "error");
                } else {
                    $(this).removeClass('error');
                }
                /* exclude dialog box inputs if they aren't showing */
                if(!$item.closest(".dialogBox:hidden").exists()) {
                    if($item.hasClass("invalidInput")){
                        invalid = true;
                    } else if ($item.is("input[type='radio']")){
                        // if it's a radio input, check all inputs with the same name
                        if ($item.attr('name') != ""){
                            invalid = $(targetElement).find("input[type='radio'][name='" + $item.attr('name') + "']:enabled:checked").length === 0;
                        } else {
                            invalid = !$(item).prop('checked');
                        }
                    } else if ($item.is("input[type='checkbox']")){
                        // if it's a radio input, check all inputs with the same name
                        if ($item.attr('name') != ""){
                            invalid = $(targetElement).find("input[type='checkbox'][name='" + $item.attr('name') + "']:enabled:checked").length === 0;
                        } else {
                            invalid = !$(item).prop('checked');
                        }
                    } else if($item.is("button") && $item.data("mandatory-message") && $item.is(":visible")){
                        invalid = true;
                    } else if($item.is("input") || $item.is('textarea')){
                        let $next = $item.next();
                        if ($item.hasClass("magicMultiTag")) {
                            if($next.is("input[type='hidden']") && $next.val() === "[]") {
                                invalid = true;
                            } else {
                                invalid = false;
                            }
                        } else if ($item.hasClass("suggestSelect") && !$item.hasClass('custom')) {
                            let nextFieldSet = typeof $item.data("mandatory-next-field") !== 'undefined';
                            if (
                                $item.val().trim() === ""
                                || !($next.is("input[type='hidden']")) // Fail; if next input is the Hidden
                                || !(
                                        nextFieldSet && $next.is("input[id='" + $item.data('mandatory-next-field') + "']")
                                        || (
                                            !nextFieldSet && (
                                                $next.is("input[id='" + $item.attr("id") + "CallbackCategory']")
                                                || $next.is("input[id='" + $item.attr("id") + "Callback']")
                                            )
                                        )
                                    ) // Fail; if next input is not one of these Inputs
                                || (
                                        $next.val() === ""
                                        || $next.val() === "0"
                                    ) // Fail; if it is one of the above Inputs but value is empty or 0
                            ) {
                                invalid = true;
                            } else {
                                invalid = false;
                            }
                        } else {
                            invalid = ($.trim($item.val()) === "");
                        }
                    } else if ($item.is("select")){
                        if ($item.is('[multiple]')){
                            invalid = ($(item).find("option:selected").length === 0);
                        } else {
                            invalid = ($(item).prop("selectedIndex") === 0);
                        }
                    }
                }

                // add mandatory items into array
                if ($item.hasClass('mandatoryGroup')) {
                    invalidFieldGroup.push($item);
                    // loop any group item has been valid
                    if (!isAnyMemberValid) {
                        isAnyMemberValid = !invalid
                    }
                }

                if (invalid){
                    // get the field title
                    // TODO this wont work for items that have additional wrapping.
                    if($item.is("button")){
                        invalidButtons.push($item.data("mandatory-message"));
                    } else {
                        $(this).addClass('error');
                        if ( typeof $item.data("mandatory-message") !== 'undefined'){
                            invalidFields.push($item.data("mandatory-message"));
                            // add group items message
                            if ($item.hasClass('mandatoryGroup')) {
                                invalidFieldGroupIndex.push($item.data("mandatory-message"));
                            }
                        } else {
                            if (typeof $item.data("mandatory-header-target") !== 'undefined') {
                                $invalidField = $($item.data("mandatory-header-target")).clone();
                            } else if ($(item).hasClass("magicMultiTag")) {
                                var $invalidField = $item.parent().parent().parent().find(".fieldHeader").clone();
                            } else if ($(item).hasClass("tinyMCEEditor")) {
                                var $invalidField = $item.parent().find(".fieldHeader").clone();
                            } else {
                                var $invalidField = $item.siblings(".fieldHeader").clone();
                            }
                            if($invalidField.length == 0) {
                                //must be table
                                $invalidField = $item.parent().prev().clone();
                            }
                            $invalidField.children().remove();
                            // push title onto list
                            invalidFields.push($invalidField.text().replace(/^\*\s+/,''));
                            // add group items message
                            if ($item.hasClass('mandatoryGroup')) {
                                invalidFieldGroupIndex.push($invalidField.text().replace(/^\*\s+/,''));
                            }
                        }
                        if(!$item.hasClass("mandatory")){ //might just be invalid data
                            $item.addClass('mandatoryFail');
                        }
                        if ($item.is("select")){
                            $item.next().addClass('mandatoryFail');
                            $item.next().addClass('error');
                            $item.suggestselect("refresh");
                        }
                    }
                    // if first -> show the tab that the input is on
                    if (invalidFields.length + invalidButtons.length === 1){
                        // Select tab based on tab container ignoring data case.
                        var tabContent = $item.closest(".tabsContent");
                        var tabId;
                        if (tabContent.parent(".tabsContent").attr("id")){
                            tabId = tabContent.parent(".tabsContent").attr("id").replace("Container", "");
                            $(".mainTab").filter(function() {return $(this).data('container').toLowerCase() == tabId.toLowerCase()}).click();
                        }
                        if (tabContent.attr("id")){
                            tabId = tabContent.attr("id").replace("Container", "");
                            $(".mainTab, .subTab").filter(function() {return $(this).data('container').toLowerCase() == tabId.toLowerCase()}).click();
                        }
                    }
                }
            }
        );

    // check the mandatory list div
    $(targetElement)
        .find(".listBox.mandatory-listBox")
        .each(
            function () {
                let $listBox = $(this);
                let $listItems = $listBox.find(".item");
                if ($listItems.length === 0) {
                    $listBox.addClass('error');
                    let $invalidField = $listBox.data("fieldHeader");
                    if ($invalidField) {
                        invalidFields.push($invalidField.replace(/^\*\s+/,''));
                    }

                    // if first -> show the tab that the input is on
                    if (invalidFields.length + invalidButtons.length === 1) {
                        // Select tab based on tab container ignoring data case.
                        var tabContent = $listBox.closest('.tabsContent');
                        var tabId;
                        if (tabContent.parent('.tabsContent').attr('id')) {
                            tabId = tabContent.parent('.tabsContent').attr('id').replace('Container', '');
                            $('.mainTab').filter(function () {return $(this).data('container').toLowerCase() == tabId.toLowerCase();}).click();
                        }
                        if (tabContent.attr('id')) {
                            tabId = tabContent.attr('id').replace('Container', '');
                            $('.mainTab, .subTab').filter(function () {return $(this).data('container').toLowerCase() == tabId.toLowerCase();}).click();
                        }
                    }
                }
            }
        );

    // check if date fields are within min/max
    $(targetElement)
        .find(".datePicker:enabled")
        .filter("[minDate], [maxDate]")
        .each(
            function (index, item) {
                let $item = $(item);
                let inputDate = $item.datepicker("getDate");
                let savedDate = $item.attr('savedDate')
                    ? getJSDate($item.attr('savedDate'))
                    : $item.datepicker("option", "savedDate")
                        ? getJSDate($item.datepicker("option", "savedDate"))
                        : null;
                let minDate = $item.attr('minDate')
                    ? getJSDate($item.attr('minDate'))
                    : $item.datepicker("option", "minDate")
                        ? getJSDate($item.datepicker("option", "minDate"))
                        : null;
                let maxDate = $item.attr('maxDate')
                    ? getJSDate($item.attr('maxDate'))
                    : $item.datepicker("option", "maxDate")
                        ? getJSDate($item.datepicker("option", "maxDate"))
                        : null;
                //if inputDate does not match already savedDate
                //and less than minDate or greater than maxDate
                if (
                    inputDate
                    && (
                        (minDate && inputDate < minDate)
                        || (maxDate && inputDate > maxDate)
                    )
                    && (savedDate == null || (inputDate.getTime() !== savedDate.getTime()))
                ) {
                    $(this).addClass('error');
                    let $invalidField = $item.parent().parent().find(".fieldHeader");
                    if ($invalidField.text()) {
                        invalidFields.push($invalidField.text().replace(/^\*\s+/,''));
                    }
                }
            }
        );

    // Ensure any email fields are filled out and valid
    $(targetElement)
        .find(".validateEmail-js")
        .each(
            function () {
                let $Input = $(this);
                //allow empty fields, because if it is mandatory it will be picked up by mandatory check if it is empty
                if (!validateEmail($Input.val(), true)) {
                    $Input.addClass('error');
                    let $invalidField = $Input.parent().find(".fieldHeader");
                    if ($invalidField.text()) {
                        invalidFields.push($invalidField.text().replace(/^\*\s+/,''));
                    }
                }
            }
        );

    // listboxes that must have at least one value assigned
    $(targetElement)
        .find('div.assignOptions.assigned.mandatory:visible')
        .each(
            function () {
                let $Listbox = $(this);
                // find all inputs inside the div
                let $assignedOptions = $Listbox.find('input[type="hidden"]');
                if ($assignedOptions.length == 0) {
                    $Listbox.addClass('error');
                    let $invalidField = $Listbox.parent().find('.fieldHeader strong');
                    if ($invalidField.text()) {
                        invalidListBoxes.push($invalidField.text().replace(/^\*\s+/, ''));
                    }
                } else {
                    $(this).removeClass('error');
                }
            }
        );

    invalidFields = $.grep(invalidFields,function(v,k){
        return $.inArray(v,invalidFields) === k;
    });

    // remove mandatory
    if (isAnyMemberValid) {
        invalidFieldGroup.forEach(function(e) {
            e.removeClass('error')
        })
        // remove any group items from invalidFields messages array
        if (invalidFields.length > 0) {
            invalidFields.forEach(function(e,i) {
                if (invalidFieldGroupIndex.includes(e)) {
                    invalidFields.splice(i, 1);
                }
            })
        }
    }

    // mark group items loop to limit once
    let escapeGroupItem = false
    if (invalidFields.length > 0){
        message = "<span class='icon-alert'></span> "+ ($(targetElement).data('mandatory-header-message') ? $(targetElement).data('mandatory-header-message') : gettext("Fill out the following required/invalid fields:")) + $.map(invalidFields,function(t){
            // output mandatoryGroup items message
            if (invalidFieldGroupIndex.includes(t)) {
                // only output once check
                if(escapeGroupItem || isAnyMemberValid) {
                    return null;
                }
                // mark mandatoryGroup items already been done
                escapeGroupItem = true;
                return "<br />" + $.map(invalidFieldGroupIndex, function (e) {
                    return "<span class='textRed'>" + e + "</span>" + (invalidFieldGroupIndex.indexOf(e) + 1 !== invalidFieldGroupIndex.length ? "<span class='textRed'> OR </span>" : "");
                }).join('');
            }
            return "<br /><span class='textRed'>" + t + "</span>";
        }).join('');
    } else if (invalidButtons.length > 0) {
        message = "<span class='icon-alert'></span> "+ ($(targetElement).data('mandatory-header-message') ? '' : gettext("Please save or cancel the following information:")) + $.map(invalidButtons,function(t){
            return "<br /><span class='textRed'>" + t + "</span>"
        }).join('');
    } else if (invalidListBoxes.length > 0) {
        message = "<span class='icon-alert'></span> "+ ($(targetElement).data('mandatory-header-message') ? '' : gettext("At least one value must be selected in the following fields:")) + $.map(invalidListBoxes, function(t) {
            return "<br /><span class='textRed'>" + t + "</span>"
        }).join('');
    } else {
        if (isForSession) {
            setMandatoryFieldsError(targetElement, '');
        }
        return true;
    }

    let dialogContent = "<div class='row dialogErrorMessage'><div class='span12'><div class='warning'>" + message + "</div></div></div>";
    let dialogTitle = gettext("Cannot Submit");
    if (isForSession) {
        setMandatoryFieldsError(targetElement, dialogContent);
    } else if (!$(targetElement).hasClass("noMandatoryMessage-js")) {
        //if in a dialog already, show inline (unless iframe)
        $VisibleDialog = $(".dialogBox:visible");
        if ($VisibleDialog.exists()){
            $VisibleDialog.find(".suggestSelect").suggestselect("close");
            $PreviousError = $VisibleDialog.find(".dialogErrorMessage");
            if($PreviousError.exists()){
                $PreviousError.remove();
            }
            $VisibleDialog.find(".content").prepend("<div class='row dialogErrorMessage' data-cy='Warning_Message'><div class='span12'><div class='warning'>"+ message +"</div></div></div>");
            return false;
        }
        createDialog("alert", dialogContent, dialogTitle);
    }
    return false;
}

function setMandatoryFieldsError(targetElement, error = '')
{
    if ($(targetElement).find('#mandatoryFieldsError').length == 0) {
        let element = null;
        element = document.createElement('input');
        element.type = 'hidden';
        element.id = 'mandatoryFieldsError';
        element.name = 'mandatoryFieldsError';
        element.value = error;
        $(targetElement).append(element);
    } else {
        $('#mandatoryFieldsError').val(error);
    }

    // Ensure to run the ajax call to update the session, even when user does not change any form elements
    quickLinkUpdate = true;
}

/**
 * Converts a date sting (separated by /) to JS Date
 * @param {string} date
 * @returns {Date}
 */
function getJSDate(date)
{
    if (date instanceof Date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
    let simPROFormat = simPRODefaults.data("date-format");
    let formatComponents = simPROFormat.split("/");
    let dateComponents = date.split('/');
    let formattedDate = [];
    for (let i = 0; i < 3; i++) {
        if (formatComponents[i] === 'd' || formatComponents[i] === 'dd') {
            formattedDate['d'] = parseInt(dateComponents[i]);
        } else if (formatComponents[i] === 'm' || formatComponents[i] === 'mm') {
            formattedDate['m'] = parseInt(dateComponents[i])-1;
        } else if (formatComponents[i] === 'y' || formatComponents[i] === 'yy') {
            let year = parseInt(dateComponents[i]);
            if (formatComponents[i] === 'y') {
                let Now = new Date();
                let currentYear = Now.getFullYear().toString();
                let century = parseInt(currentYear.substring(0, 2));
                year = parseInt(currentYear.substring(2, 4));
                let inputtedYear = parseInt(dateComponents[i]);
                if (inputtedYear - 10 <= year) {
                    // assume current century
                    year = parseInt(century + '' + inputtedYear);
                } else {
                    // assume last century
                    year = parseInt((century - 1) + '' + inputtedYear);
                }
            }
            formattedDate['y'] = year;
        }
    }
    return new Date(formattedDate['y'], formattedDate['m'], formattedDate['d']);
}

/**
 * Converts a js date object into a formatted date string as set in defaults or ISO standard.
 * @param {Date} dateObj
 * @param {boolean} ISOStandard
 * @returns {string}
 */
function getFormattedDate(dateObj, ISOStandard)
{
    if (dateObj === null) {
        return null;
    }

    if (typeof ISOStandard === 'undefined') {
        ISOStandard = false;
    }

    let reqFormat = ISOStandard ? "yy/mm/dd" : $('#simpro-defaults').data('dateFormat');

    let components = reqFormat.split("/");
    let dateFormat = [];

    for (let i = 0; i<3; i++) {
        switch (components[i]) {
            case ('d'):
                dateFormat.push(dateObj.getDate());
                break;
            case ('dd'):
                dateFormat.push(addLeadingZero(dateObj.getDate()));
                break;
            case ('m'): // we do not have option to do m, so we are doing like - Aug.
                dateFormat.push(dateObj.getMonth() + 1);
                break;
            case ('mm'):
                dateFormat.push(addLeadingZero(dateObj.getMonth() + 1));
                break;
            case ('y'):
                dateFormat.push(dateObj.getFullYear().toString().substring(2));
                break;
            case ('yy'):
                dateFormat.push(dateObj.getFullYear());
                break;
            default:
                break;
        }
    }
    return ISOStandard ? dateFormat.join("-") : dateFormat.join("/");
}

function addLeadingZero(num)
{
    num = num.toString();
    return num.length === 1 ? ("0" + num) : num;
}

function checkMandatoryMarker() {
    // Add a '*' onto the front of the fieldHeader label if it doesn't already exist.
    $(".mandatory:not(button)").each(function(index, item) {
        if ($(item).data("mandatory-header-target")) {
            var fieldHeader = $($(item).data("mandatory-header-target"));
        } else {
            var fieldHeader = $(item).siblings(".fieldHeader");
        }

        if (!fieldHeader.exists()) {
            if ($(item).hasClass("magicMultiTag")) {
                fieldHeader = $(item).parent().parent().parent().find(".fieldHeader");
            } else if ($(item).hasClass("tinyMCEEditor")) {
                fieldHeader = $(item).parent().find(".fieldHeader").first();
            }
            if (!fieldHeader.exists()) {
                fieldHeader = $(item).parent(".groupedInput").siblings(".fieldHeader");
            }
        }
        if (fieldHeader.exists() && $(fieldHeader).html().substr(0, 1) != "*") {
            $(fieldHeader).html("* " + $(fieldHeader).html());
        }
    });
}

function checkExists(element){
    if ($(element).val().trim() != ""){
        $(element).css("background", "");
        if ($(element).attr("href") && $(element).attr("href") != ""){
            var url = "../common/ajax/" + $(element).attr("href");
            if ($(element).hasClass('useHref-js')) {
                url = $(element).attr("href");
            }
            var data = $(element).attr("name") + "=" + encodeURIComponent($(element).val());
            if ($(element).attr('params') && $(element).attr('params') != ''){
                data += '&' + $(element).attr('params');
            }
            if ($(element).data("linked-fields")) {
                $($(element).data("linked-fields")).each(function(i, field) {
                    data += '&' + $(field).attr("name") + "=" + $(field).val();
                });
            }
        } else {
            var url = "../common/autoComplete.php";
            var data = "searchText=" + encodeURIComponent($(element).val()) + "&searchType=exact&maxRows=1&maxRowsType=0&displayMode=checkExists";
            // Add result types (customers, jobs etc.) if set. If none are set, all result types will show.
            var resultTypes = ["customers", "jobs", "quotes", "leads", "invoices", "contractor", "suppliers", "purchaseorders", "catalogue", "prebuilds", "kits", "sites", "assets", "plant", "tasks", "employees", "contractors", "contacts", "sitecontacts", "zones", "sectiondepartments", "activities", "commissions"];
            var classes = $(element)[0].className.split(/\s+/);
            for (var i = 0; i < classes.length; i++){
                var className = classes[i];
                if ($.inArray(className, resultTypes) != -1){
                    data += "&" + className + "=true";
                }
            }
        }
        // check if openHash exists
        if ($('#openHash').exists()) {
            data += "&openHash=" + $('#openHash').val();
        }
        // Add custom filters (customerID, siteID etc.) if set
        var attributes = $(element)[0].attributes;
        for (var i = 0; i < attributes.length; i++){
            attribute = attributes[i];
            if (attribute.nodeName.indexOf("filter-") != -1){
                var filterName = attribute.nodeName;
                var filterValue = $(element).attr(filterName).split("&");
                if (filterName == "filter-includeids" || filterName == "filter-excludeids" || filterName == "filter-searchcurrency"){
                    filterName += "[]";
                }
                $.each(filterValue, function(index, item) {
                    if (item.indexOf("#") != -1){
                        if ($(item).exists() && $(item).val() != "" && $(item).val() != 0){
                            data += "&" + filterName.replace("filter-", "") + "=" + $(item).val();
                        }
                    } else {
                        data += "&" + filterName.replace("filter-", "") + "=" + item;
                    }
                });
            }
        }

        if ($(element).hasClass('checkExists-forceText')) {
            data += "&forceText=1";
        }

        $.ajax({
            type: "POST", // needs to be POST in case the data is to large for GET
            data: data,
            dataType: "json",
            url: url,
            success: function (responseText) {
                var statusIcon = $(element).next();
                //Check if there's another potential button after the validation
                if (statusIcon.next().hasClass('btnImg')) {
                    statusIcon.addClass('hasSibling');
                } else {
                    statusIcon.removeClass('hasSibling');
                }

                if (!responseText.status){
                    // If matches are found, show red x and tooltip
                    if ($(element).hasClass("mandatory") && !$(element).hasClass("duplicateok")){
                        statusIcon.removeClass("valid hide").addClass("invalid");
                        $(element).addClass("error invalidInput");
                        $(element).focus();
                    }
                    if (responseText.message && responseText.message != ""){
                        $(element).attr("title", responseText.message);
                        tooltip = createToolTip($(element), true);
                        if ($(element).data('check-exists')) {
                            var data = $(element).data('check-exists');
                            if (data.duration) {
                                tooltipTimeout = 0;
                                tooltip.on("mouseover", function() {
                                    window.clearTimeout(tooltipTimeout);
                                }).on("mouseout initialised", function() {
                                    tooltipTimeout = window.setTimeout(function() {
                                        tooltip.remove();
                                    }, data.duration);
                                }).trigger('initialised');
                            }
                        }
                    }
                } else {
                    // If no matches are found, show green tick
                    if ($(element).hasClass("mandatory") && !$(element).hasClass("duplicateok")){
                        statusIcon.removeClass("invalid hide").addClass("valid");
                        $(element).removeClass("error invalidInput");
                    }
                }
                prepareDocument($(element).parent());
            }
        });
    } else {
        $(element).removeClass("error");
        $(element).next().removeClass('invalid valid').addClass('hide');
    }
}

function printPreview(){
    window.print();
}

/**
 * Options dropdown menu
 *
 * How to make menu items:
 *
 * Menu items must be anchor (<a>) tags.
 *
 * Standard URL link: <a href="somePage.php" target="_top">link text</a>
 * - Target is important!
 *   window = Popup window.
 *   _blank = New tab.
 *   _top = Replace the whole page, even if the option is selected from within an iframe or popup window.
 *   no target specified = Replace the current page. ie just the iframe / popup where the option is selected.
 *
 * JavaScript event: <a href="javascript: void(0);" class="ajaxClick">link text</a>
 * - For bound events to fire (eg for the ajaxClick event to be fired) the href MUST be blank or contain 'void(0)'
 *   OR the link must have one of these classes: dialogLink, exportCSV, showOnClick
 */
function openContextMenu(contextMenu, at, of){
    // Clone and append menu to body so it will always be on top
    var $contextMenu = $(contextMenu),
        $menuClone = $contextMenu.clone().appendTo("body").show()
            .position({
                my: "left top",
                at: at,
                of: of,
                collision: "flip"
            }),
        count = 0;
    $menuClone.find("li:not(.attachment-li)").each(function(index, item){
        var $item = $(item);
        if ($item.find("ul.contextMenu:first").exists()){
            $("<span class='linkImgFlyExpand right'></span>")
                .appendTo($item.find("a:first"));
        }
        $item.mouseover(function(){
            var $this = $(this);
            $this.siblings().find("ul.contextMenu").hide();
            $this.find("ul.contextMenu:first").show()
                .position({
                    my: "left top",
                    at: "right top",
                    of: $this,
                    collision: "flip"
                });
        });

        var $a = $item.find("a:first");
        var classes = "";
        if ($a.hasClass("saveBackLink")){
            classes += "saveBackLink";
        }
        $a
            .attr("href", "javascript: void(0);")
            .attr("title",null)
            .attr("class", classes)
            .removeAttr('onclick')
            .click(function(myIndex){
                return function(e){
                    var $option = $contextMenu.find("li:not(.attachment-li):eq(" + myIndex + ") a:first"),
                        href = $option.attr("href"),
                        target;

                    // Clicking an anchor tab href with JavaScript won't work, so we have to emulate that behaviour
                    if (href && href != "" && href.indexOf("void(0)") == -1 && !$option.hasClass("dialogLink") && !$option.hasClass("exportCSV") && !$option.hasClass("showOnClick")){
                        if ($option.hasClass("saveBackLink")){
                            $option.click();
                        }
                        target = $option.attr("target");
                        if (target == "window"){
                            window.open(href, "", "width=1175,height=740,left=100,top=100,screenX=100,screenY=100,resizable=no,scrollbars=yes");
                            e.preventDefault();
                        } else if (target == "_blank"){
                            window.open(href);
                            e.preventDefault();
                        } else if (target == "_top"){
                            window.top.location = href;
                        } else {
                            window.location = href;
                        }
                    } else {
                        $option.click();
                    }
                    if($contextMenu.hasClass("select")) {
                        var $menuContainer = $contextMenu.closest(".menuContainer");
                        $menuContainer.find(".options").text($(this).parent().attr("selectText"));
                        $contextMenu.find(".selected").removeClass("selected");
                        $option.parent().addClass("selected");
                    }
                    closeContextMenu();
                };
            }(count));
        count++;
    });
    $("body").delegate("#page", "mousedown.closeContextMenu", function(){
        closeContextMenu();
    });
    return $menuClone;
}

// Close context menus
function closeContextMenu(){
    $(".contextMenu").filter(":visible").remove();
    $("body").undelegate("#page", "mousedown.closeContextMenu");
}

//Give the element class "elementToolTip", if want to append it to the element instead of body
function createToolTip(element, temporary) {
    if($(element).is(":visible")){
        var $dialogBox = $(element).closest('.dialogBox');
        var dialogBoxClass = ($dialogBox.length>0) ? 'dialogBoxTooltip' : '';

        let div = $('<span>' + $(element).attr("title") + "</span>").find("script").remove().end().html();
        var tooltip = $("<div class='tooltip "+dialogBoxClass+"'><div class='innerScrollableDiv'>" + div + "</div></div>")
            .appendTo(element.hasClass("elementToolTip") ? element : "body")
            .height("auto")
            .position({
                my: "center bottom",
                at: "center top-10",
                of: $(element),
                collision: "fit flip",
                "using": function(target, tooltip) {
                    $(tooltip.element.element).css({
                        'top': target.top,
                        'left': target.left
                    }).addClass(tooltip.vertical + 'ToolTip');
                }
            });
        tooltip.data("element", element);

        // remove toolip if the element is removed from the dom
        $(element).on("remove", function(){
            tooltip.remove();
        });

        if(temporary) {
            $(element).attr("title", "");
            // if element value changes remove tooltip
            $(element).one("keydown", function(e){
                if ((e.keyCode ? e.keyCode : e.which) !== 9) {
                    $(tooltip).remove();
                }
            });
            // tooltip may cover up other elements so allow removing by clicking on it
            $(tooltip).one("click", function() {
                $(this).remove();
            });
        }
        return tooltip;
    }
}

// Create dialog
function createDialog(type, content, title, target, noClose, hiddenDialog, size, hideHeader, fixedButtons, draggable, footer) {
    // default behaviour is draggable and having a footer so when the attribute is not implemented we keep it as default
    if (undefined === draggable) draggable = true;
    if (undefined === footer) footer = true;

    // Only create dialog if there are no other visible dialogs
    if (type == "customSystem"){
        // Custom dialog created during prepare document
        type = "custom";
        customSystem = true;
    } else {
        // Custom dialog created manually
        customSystem = false;
    }
    var page = $("#page");
    if (type == "confirm"){
        if(title == null || title == "") {
            title = gettext("Confirm");
        }
    } else if (type == "alert"){
        if(title == null || title == "") {
            title = gettext("Alert");
        }
        noClose = true;
    } else if (title == null){
        title = "&nbsp";
    }
    if (noClose == null){
        noClose	= false;
    }

    if (hiddenDialog == null){
        hiddenDialog = false;
    }
    // Dialog container with dark background
    var dialogContainer = $("<div class='dialogBox' data-cy='Title_Dialog' ></div>").appendTo(page);
    if ($(".dialogBox").filter(":visible").exists()){
        $(dialogContainer).css("background-color", "rgba(0, 0, 0, 0)");
    }
    if (hiddenDialog){
        $(dialogContainer).attr("id", hiddenDialog).addClass("hiddenDialog-js");
    }
    var lightboxContainer = $("<div class='lightbox'></div>").appendTo(dialogContainer);
    // Header
    if (hideHeader !== true) {
        var headerContainer = $("<div class='header'></div>").appendTo(lightboxContainer);
        // Title in header
        var titleContainer = $("<span data-cy='Title_Dialog' class='left title'>" + title + "</span>").appendTo(headerContainer);
        if (!noClose) {
            // Close button in header
            var closeContainer = $("<span class='right close'><button type='button' class='close close-js'><span class='icon-close' data-cy='Icon_Close' /span></button></span>").appendTo(headerContainer);
        }
    }

    // Content container
    var contentContainer = $("<div class='content'></div>").appendTo(lightboxContainer);

    // Resize dialog
    if (size && size.width){
        var width = size.width;
    }
    if (size && size.height){
        var height = size.height;
    } else if (type == "link" || (typeof content == "object" && $(content).hasClass("iframe"))){
        var height = window.innerHeight-80;
    }
    if (width){
        $(contentContainer).css({
            "width": width
        });
    }
    if (window.location != window.parent.location) {
        $(contentContainer).addClass("multiLevel");
        height -= 80;
    }
    //if dialog is wider than window, resize to fit
    if ($(contentContainer).width() > window.innerWidth) {
        width = window.innerWidth-80;
        $(contentContainer).css({
            "width": width
        });
    }

    if (height){
        // If forceHeight is true the css-limited height of 800px will be overridden.
        if (size && size.forceHeight) {
            $(contentContainer).css({
                "height": height + 'px',
                "maxHeight": height + 'px'
            });
        } else {
            $(contentContainer).css({
                "maxHeight": height + 'px'
            });
        }
    }

    if (type == "iframe" || type == "link" || (typeof content == "object" && $(content).hasClass("iframe"))){
        $(contentContainer).addClass("iframe");
    }


    if (type == "custom" && $(content).hasClass("bigDialogBoxContent")) {
        $(contentContainer).addClass("bigDialogBox");
    }
    // If iframe, set src
    if (type == "link"){
        $(contentContainer).attr("src", content);
    }
    if (type == "custom" || type == "iframe"){
        $(contentContainer).html(content);
    } else if (type != "link"){
        $(contentContainer).html("<p>" + content + "</p>");
    }
    if (type == "alert" || type == "confirm"){
        // Confirm / close buttons
        if (fixedButtons) {
            var buttonsContainer = $("<div class='hRight buttonContainerFixed'></div>").appendTo(lightboxContainer);
        } else {
        var buttonsContainer = $("<div class='hCenter'></div>").appendTo(contentContainer);
        }
        if (type == "alert"){
            var button = $("<button data-cy='OK_Dialog' type='button' class='btnBlue dialogClose'>" + gettext("OK") + "</button>").appendTo(buttonsContainer);
        } else {
            var button = $("<button data-cy='OK_Dialog' type='button' class='btnBlue dialogContinue'>" + gettext("OK") + "</button>").appendTo(buttonsContainer);
            var button2 = $("<button data-cy='Cancel_Dialog' type='button' class='btnGrey dialogClose'>" + gettext("Cancel") + "</button>").appendTo(buttonsContainer);
        }
    }

    // Footer
    if (footer) $("<div class='footer'></div>").appendTo(lightboxContainer);

    // Show dialog
    $(dialogContainer).show();
    if (type == "alert" || (!hiddenDialog && type == "confirm")) {
        button.focus();
    }
    // Move dialog to centre of the page
    var width = $(lightboxContainer).innerWidth() / 2;
    var height = $(lightboxContainer).innerHeight() * 0.1;
    var marginTop = height * -1;
    var marginLeft = width * -1;
    $(lightboxContainer).css({
        marginTop: marginTop,
        marginLeft: marginLeft
    });

    if (type == "link" || (type == "custom" && !customSystem)){
        // Only run prepare document on link or manually created custom dialogs
        prepareDocument($(dialogContainer));
    }
    if (hiddenDialog) {
        // Hide dialog after moving it to the centre of the page
        $(dialogContainer).hide();
    }
    // Close dialog when close button is clicked
    $(dialogContainer).on("click",".dialogClose, .close-js", function(e){
        var cleanSessionData = "";
        if ($(this).hasClass("closeQuickLinkValidator")) {
            var closedQuickLinkUrl = $(this).data('url');
            openLink(closedQuickLinkUrl, e);
        } else if ($(this).hasClass("close-js")) {
            if (!$(dialogContainer).hasClass('noDialogCloseCallback')) {
                var dialogCloseCallback = $(".dialogCloseCallback").filter(":visible");
                if (dialogCloseCallback.length > 0) {
                    for (i = 0; i < dialogCloseCallback.length; i++) {
                        dialogCloseCallback[i].click();
                    }
                }
            }
            var iframe = $(dialogContainer).find("iframe");
            if (iframe.exists()) {
                try {
                    var cleanSessionHash = $("#openHash[data-session]", iframe.contents());
                    if (cleanSessionHash.exists()) {
                        cleanSessionData += "&cleanSession=" + cleanSessionHash.data("session") + "&cleanHash=" + cleanSessionHash.val();
                    }
                } catch(e) {
                    // most likely iframe where src is not part of the domain
                }
            }
        } else if ($(this).hasClass("cleanSession")) {
            cleanSessionData += "&cleanSession=" + $(this).val();
            if (typeof($(this).attr('openHash')) !== 'undefined') {
                cleanSessionData += "&cleanHash=" + $(this).attr('openHash');
            }

        }
        if (cleanSessionData != "") {
            $.ajax({
                type: "POST",
                data: cleanSessionData,
                url: "../common/ajax/cleanSession.php"
            })
        }

        // Close any open dropdowns
        $(dialogContainer).find(".suggestSelect").suggestselect("close");

        if (hiddenDialog){
            //remove any inline error messages
            $(dialogContainer).find(".dialogErrorMessage").remove();
            $(dialogContainer).hide();
        } else {
            $(dialogContainer).remove();
        }
        $(".tooltip").hide();
    });
    // Close dialog when esc key is pressed
    $(document).off('keydown.dialogue').on('keydown.dialogue', function(e) {
        let keyCode = (e.keyCode ? e.keyCode : e.which);
        if ((keyCode === 27 || keyCode === 13)) {
            let keyDialogueBox = $('.dialogBox').filter(':visible');
            if (keyDialogueBox.exists()) {
                let fired = false;
                if (keyCode === 27 && !keyDialogueBox.hasClass('noClose')) {
                    let closeButton = keyDialogueBox.find('.dialogClose:not(.noESC)')
                    if (!closeButton.exists()) {
                        closeButton = keyDialogueBox.find('.close-js')
                    }
                    if (closeButton.exists()) {
                        e.preventDefault();
                        fired = true;
                        closeButton.click();
                    }
                } else if (keyCode === 13) {
                    if (!$(document.activeElement).is(":input")) {
                        let continueButton = keyDialogueBox.find('.dialogContinue');
                        if (!continueButton.exists()) {
                            let continueButtons = keyDialogueBox.find('.dialogClose').siblings('button:not(.noEnter,.dialogClose):visible');
                            if (continueButtons.length === 1) {
                                continueButton = continueButtons.first();
                            }
                        }
                        if (continueButton.exists()) {
                            e.preventDefault();
                            continueButton.click();
                            fired = true;
                        }
                    }
                }
                if (fired) {
                    if (hiddenDialog) {
                        $(dialogContainer).hide();
                    } else {
                        $(dialogContainer).remove();
                    }
                }


            }
        }
    });

    var $draggableItem = $(lightboxContainer);

    if (!$draggableItem.is('.ui-draggable') && draggable) {
        var $window = $(window);
        // Have to use $(this).width/height here as there are often multiple modals on page.
        // Additionally containment is based off page position, not window position, so needs to be calculated with window scroll position to correctly place modal on page
        $draggableItem.draggable({
            handle: ".header",
            iframeFix: true,
            containment: [0-($(this).width() * 0.3), $window.scrollTop(), $window.width()+($(this).width() * 0.4),  $window.scrollTop()+$window.height()-($(this).height() * 0.05)],
            scroll: false,
            stop: function() {
                var $draggableItem = $(this);

                if (parseInt($draggableItem.css('top'), 10) < ($draggableItem.height() * 0.2)/2) {
                    $draggableItem.css('top', (($draggableItem.height() * 0.2)/2+1)+'px');
                }
            },
            start: function() {
                //Additional functionality to handle cases where window automatically scrolls during interaction with modal.
                var $draggableItem = $(this);

                $draggableItem.draggable("option","containment",[0-($draggableItem.width() * 0.3), $window.scrollTop(), $window.width()+($draggableItem.width() * 0.4),  $window.scrollTop()+$window.height()-($draggableItem.height() * 0.05)]);
                $draggableItem.data('uiDraggable')._setContainment();
            }
        });
    }
    return $(dialogContainer);
}

// Show content with animation
function showOnClick(href, options){
    if (options != null && options.context != null){
        var context = options.context;
    } else {
        var context = $(document);
    }
    var element = $(href, context);

    if (options != null && options.duration != null){
        var duration = options.duration;
    } else {
        var duration = 300;
    }

    if (options != null && options.showHide == "show"){
        $(element).slideDown(duration);
    } else if (options != null && options.showHide == "hide"){
        $(element).slideUp(duration);
    } else {
        $(element).slideToggle(duration);
    }
    if (options != null && options.button != null){
        if (options.text != null){
            $(options.button).find("span:first").html(options.text);
        }
        if (options.showClass != null && options.hideClass != null){
            $(options.button).find(":last").removeClass(options.hideClass).addClass(options.showClass);
        }
    }
    prepareDocument(element);
    autoFocus(element);
}

var loadingImageCaller;

// Show loading image
function showLoadingImage(backgroundColor = null) {
    $("body").css("cursor", "wait");
    let loadingImage = $("#loadingImage");
    if (backgroundColor !== null) {
        loadingImage.css('background-color', backgroundColor);
    } else {
        loadingImage.css('background-color', '');
    }
    loadingImage.show();
}

// Hide loading image
function hideLoadingImage() {
    $("body").css("cursor", "default");
    $("#loadingImage").hide();
}

// Add a loading image to an element
function addLoadingImage(element) {
    if(typeof element.data("has-loading-img") == 'undefined' || element.data("has-loading-img") === 0){
        var spinnerHtml = '<div class="spinner">' +
            '	<div class="doubleBounce1"></div>'+
            '	<div class="doubleBounce2"></div>'+
            '</div>';
        element.append(spinnerHtml);
        element.attr("data-has-loading-img", 1);
    }
}

function showImagesOnScreen() {
    let i = 0;
    $("img[data-src]")
        .each(function () {
            $this = $(this);
            if ($this.isOnScreen() && !$this.hasClass("image-loaded")) {
                let imageSrc = $this.data('src');
                setTimeout($this.attr.bind($this, 'src', imageSrc), 500*i);
                $this.addClass("image-loaded");
                i++;
            }
        });
}

// Remove the loading image of an element
function removeLoadingImage(element){
    element.find(".spinner").remove();
    element.attr("data-has-loading-img", 0);
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function ajaxComplete(xhr, textStatus, loadingImage, loadingElement){

    if (xhr.status === 500 && xhr.responseText.length !== ""){
        if (console){
            console.log({
                "xhr":xhr,
                "textStatus":textStatus,
                "xhr.status":xhr.status,
                "xhr.statusText":xhr.statusText
            });
        }
        showResponse(xhr.responseText, null, loadingImage, null, xhr.status);
    } else if (textStatus != 'success' && textStatus != 'notmodified' && textStatus != 'abort'){
        if (console){
            console.log({
                "xhr":xhr,
                "textStatus":textStatus,
                "xhr.status":xhr.status,
                "xhr.statusText":xhr.statusText
            });
        }
        createDialog('alert', gettext('There was a problem communicating with the Simpro server. The last request may have not been received by Simpro.'), gettext('Communication Error'));
        hideLoadingImage();
    }
}
// Updates content when ajax responds
function showResponse(responseText, callback, loadingImage, loadingElement, responseCode) {
    var redirectCookie = readCookie("ajaxRedirect");
    if (redirectCookie != null) {
        window.location.href = decodeURIComponent(redirectCookie);
    } else if (responseText == 'ValidationError') {
        //Getting a validation error i.e. CSRF validation
        createSecurityDialog();
        if (loadingImage) {
            hideLoadingImage();
        }
    } else if (callback && callback == "showFinishState")  {
        if ($(responseText).find("#main").length) {
            $("#main").replaceWith($(responseText).find("#main"));
            prepareDocument();
            $(".defaultlink-js").focus();
            hideLoadingImage();
        } else {
            location.reload();
        }
    } else if (responseCode == 500) {
        if (responseText == '') {
            responseText = gettext('An error occurred while performing your last request. Please try again later and if the problem persists, please contact support.');
        }
        createDialog(
            'alert',
            responseText,
            gettext('Error')
        );
        if (loadingImage) {
            hideLoadingImage();
        }
    } else {
        //ajax response successful
        if (callback && (callback == "closeWindow" || callback == 'viewForm' || callback == 'viewFormDocx') || callback == 'emailForm') {
            window.setTimeout(function (c, i) {
                return function () {
                    if (c) {
                        if (typeof c === "function") {
                            c();
                        } else {
                            window[c]();
                        }
                    }
                    if (i) {
                        hideLoadingImage();
                    }
                }
            }(callback, loadingImage), 10);

        } else {
            ajaxSubmitResponse = responseText; // needs to be global for callback function
            var ajaxUpdate = $(".ajaxUpdate", responseText).filter(function () {
                return !$(this).parents().hasClass("ajaxUpdate");
            });
            $(".htmlEditor-js", ajaxUpdate).each(function () {
                tinymce.execCommand('mceRemoveEditor', false, $(this).attr("id"));
            });
            elements = "";
            $.each(ajaxUpdate, function (index, item) {
                if (elements != "") {
                    elements += ",";
                }

                if (!item.id) {
                    if (console)
                        console.log('showResponse::ajaxUpdate item missing id');
                    return;
                }
                elements += "#" + item.id;
                //if in item there is any .hiddenDialog-js with an ID. search the main document for class dialogBox with the same id, and remove from main document
                dialogID = $(item).find("div.hiddenDialog-js[id]");
                if (dialogID.exists()) {
                    dialogID.each(function () {
                        var $this = $(this);
                        $("#" + $this.attr('id') + ".dialogBox").remove();
                    });
                }
                var container = $("#" + item.id);
                container.replaceWith(item);
            });
            $('.tabsContent').hide();
            showTabs(document);
            prepareDocument($(elements));
            // Fix for cursor issues on ajax calls in ie 11.
            // Cursor shows large and blinking on lead page when choosing customer as well as on jobard page when saving.
            if (getBrowser('msie')) {
                var textarea = $("<input type='text' style='position:absolute; top:-500px;'>");
                $("body").append(textarea);
                textarea.focus().blur().remove();
            }
            /* can listen for particular panels / divisions being reloaded to call their initialisation code */
            $(elements).trigger('ajaxload');
            // If element has a callback, run that function
            window.setTimeout(function (c, i) {
                return function () {
                    if (c) {
                        if (typeof c === "function") {
                            c(responseText);
                        } else if (typeof window[c] === 'function') {
                            window[c](responseText);
                        }
                    }
                    if (i) {
                        hideLoadingImage();
                    }
                }
            }(callback, loadingImage), 10);
        }
        if ($(".supportsAutosave-js").length > 0 && !autoSaveTriggered) {
            autoSaveTrigger();
        }
    }
}

function closeWindow(){
    try {
        var dialogCloseCallback = window.opener.$(".dialogCloseCallback").filter(":visible");
        window.close();
    } catch(e) {
        var dialogCloseCallback = window.parent.$(".dialogCloseCallback").filter(":visible");
        window.parent.$(".dialogBox").filter(":visible").remove();
    }
    if (dialogCloseCallback.length > 0){
        for(i=0; i< dialogCloseCallback.length; i++) {
            dialogCloseCallback[i].click();
        }
    }
}

// Update saved searches list
function updateSavedSearches(){
    $.ajax({
        type: "GET",
        url: "/common/ajax/getSavedSearches.php",
        success: function (responseText) {
            $("#savedSearchesMenu").replaceWith(responseText);
            configureHotKeys();
        }
    });
}

function isBuildTestMode() {
    return (document.URL.indexOf('/testing/') != -1) ? true : false;
}

function getMapJobs() {
    return "/map_jobs";
}

function getMapJobsToolsPath() {
    return "/tools/map_jobs";
}

// Map Addresses
function mapAddress(data, page) {
    var src = "";
    if (typeof page !== "undefined") {
        src = page;
    }
    if (data.addresses.length > 0 || data.employee.length > 0) {
        var iframe = $("<iframe name='mapDialog' id='mapDialog' class='iframe' src='" + src + "' sandbox='allow-same-origin allow-scripts allow-forms allow-top-navigation allow-popups allow-popups-to-escape-sandbox allow-modals'>&nbsp;</iframe>");
        var mapHeight;
        if (window.location != window.parent.location) {
            //adding 80px offset for multi layer showing case (e.g. show maps in job card)
            mapHeight = 667;
        } else {
            mapHeight = 587;
        }
        createDialog("custom", iframe, "", "", false, false, {height: mapHeight});
        var url = getMapJobs() + "/mapJobs.php";
        var mapForm = $("<form method='post' id='mapForm' target='mapDialog' action='" + url + "'></form>").appendTo("#content");
        $.each(data.addresses, function() {
            $.each(this, function (key, value) {
                $('<input type="hidden" name="' + key + '[]" value="' + value + '" />').appendTo(mapForm);
            })
        })
        if(data.employee) {
            $.each(data.employee, function() {
                $.each(this, function (key, value) {
                    $('<input type="hidden" name="' + key + '[]" value="' + value + '" />').appendTo(mapForm);
                })
            })
        }
        if (data.referer) {
            $('<input type="hidden" name="referer" value="' + data.referer + '" />').appendTo(mapForm);
        }
        $('<input type="hidden" name="timezone" value="' + simPRODefaults.data('timezone') + '" />').appendTo(mapForm);
        $(mapForm).submit().remove();
    } else {
        createDialog('alert', gettext('Please select at least one item to map') , gettext('Selection Error'));
        return false;
    }
}

function searchPhoneBook(country, companyName, suburb, state, postcode){
    if (state == -1){
        state = "";
    }
    if (postcode == 0){
        postcode = "";
    }
    if (country == "United Kingdom"){
        url = "http://www.yell.com/ucs/UcsSearchAction.do?keywords=&companyName=" + companyName + "&location=" + state + " " + suburb + " " + postcode;
    } else if (country == "New Zealand"){
        // For companyName replace space with '-', so when being directed to the website, it revert back to space when diaplaying in the search filed.
        url = "http://www.yellow.co.nz/"+ suburb.replace(" ", "-").toLowerCase() + "/" + companyName.replace(" ", "-").toLowerCase();
    } else if (country == "United States") {
        url = "https://www.yellowpages.com/search?search_terms=" + companyName.replace(" ", "+");
        if (state !== '' || suburb !== '') {
            url += "&geo_location_terms=" + suburb.replace(" ", "+") + " " + state;
        }
    } else {
        url = "http://www.yellowpages.com.au/search/listings?clue=" + companyName.replace(" ", "+") + "&locationClue=" + state + " " + suburb + " " + postcode.replace(/^[\s]+/, "").replace(/[\s]+$/, "").replace(" ", "+");
    }
    window.open(url, "phoneBook", "width=900,height=600,left=100,top=100,screenX=100,screenY=100,resizable=no,scrollbars=yes");
}

function searchTaxNumber(country, companyName){
    if ( companyName != "") {
        var url = getValidVatLookupURL(country, companyName);
        if (url) {
            window.open(url, 'taxNumber', 'width=900,height=600,left=100,top=100,screenX=100,screenY=100,resizable=no,scrollbars=yes');
        } else {
            createDialog('alert', gettext('Could not perform this search.'));
        }
    } else {
        createDialog("alert", gettext("Enter a company name or registration number."));
    }
}

function searchCompanyNumber(country, searchText, searchType){
    if (searchText != ""){
        var url = "";
        switch(country) {
            case "United Kingdom":
                url = "https://beta.companieshouse.gov.uk/search?q=" + searchText;
                break;
        }
        if (url != "") {
            window.open(url, "taxNumber", "width=900,height=600,left=100,top=100,screenX=100,screenY=100,resizable=no,scrollbars=yes");
        } else {
            createDialog("alert", gettext("Could not perform this search."));
        }
    } else {
        createDialog("alert", gettext("Enter a company name or number."));
    }
}

function openURL(url){
    url = url.trim();
    if (url != "") {
        if (url.indexOf("http") != 0) {
            url = "http://" + url;
        }
        try {
            new URL(url);
            window.open(url);
        } catch (err) {
            createDialog("alert", gettext("Enter a valid website address."));
        }

    } else {
        createDialog("alert", gettext("Enter a website address."));
    }
}

function alternateRows(table){
    $(table).find("tbody:not(.noAltRow) > tr").filter(":visible:not(.noHighlight):odd").css("background-color", "#e9eef5");
    $(table).find("tbody:not(.noAltRow) > tr").filter(":visible:not(.noHighlight):even").css("background-color", "#ffffff");
}

function popstate(event) {
    if(event.state != null) {
        showResponse(event.state);
    }
}
function showTabs(context) {
    $(".mainTab, .subTab", $(context)).each(function() {
        var container = $("#" + $(this).data('container') + "Container");
        if ($(this).hasClass("current")){
            $(container).show();
        } else {
            $(container).hide();
        }
    });
}

window.onpopstate = function(event){
    popstate(event);

};
/* DOCUMENT READY */
var simPRODefaults;
var graphCounter = 0;

$(document).ready(function(){
    var doc = document.documentElement;
    doc.setAttribute('data-useragent', navigator.userAgent);
    simPRODefaults = $("#simpro-defaults");

    // Set up default functionality
    showTabs(document);
    prepareDocument();
    prepareEvents();

    // Show loading image until page fully loads
    $("#loadingImage").hide();

    autoFocus();
    // save original function to call in our new one
    var _gotoToday = $.datepicker._gotoToday;

    // make a new _gotoToday function that does what the old one
    // did, but adds some extra feature
    $.datepicker._gotoToday = function(id) {
        _gotoToday.call( this, id );
        var target = $(id),
            inst = this._getInst(target[0]);

        // return the value when "Today" button is selected
        this._selectDate(id, this._formatDate(inst,
            inst.selectedDay, inst.drawMonth, inst.drawYear));
    }
    if (simPRODefaults.data("scrollbar") !== '') {
        $(window).scrollTop(simPRODefaults.data("scrollbar"));
    }
    if (document.URL.indexOf('/staff/') != -1 && !$('body').hasClass("iframe-body") && !$('#loginPage', document).length) {
        loadAlertsAnnouncements();
    }

    configureTinyMCE();

    if (document.URL.indexOf('revalidate=1') != -1) {
        let formElement = $("#quicklinks-js");
        let inForm = formElement.closest("form");
        if (inForm.length > 0) {
            checkMandatory(inForm, true);
        }
    }

    if ($(".supportsAutosave-js").length > 0) {
        autoSaveTrigger();
    }
});

function configureTinyMCE() {

    if (window.tinymce && $.isEmptyObject(tinymce.settings)) {
        let pdfPageWidth = simPRODefaults.data('buildCountry')==='United States' ? 732 : 710;
        var plugins = '_simproburger _simproalign textcolor lists paste print table image _simprolink _simprotableoptions _simpropagewidth';

        // https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols
        var toolbar = 'bold italic underline strikethrough fontsizeselect forecolor backcolor | simproalign | bullist numlist indent outdent | simproinserttable | simproburger';

        var validElements = "@[id],"; // Allow all elements to have IDs because some plugins use IDs when navigating the DOM.

        validElements += "br,strong/b,em/i,p[style],span[style],img[src|alt|width|height|style]";

        //Add list support
        validElements += ",ul,ol,li";

        //Add table support
        validElements += ",table[style],tbody[style],thead[style],tfoot[style],tr[style],th[style],td[style]";

        // Add link support
        validElements += ",a[name|href|target|style]";

        // Make pagewidth the last button
        toolbar += ' pagewidth';

        // Styles to keep when pasting from external programs
        var retainedStyles = "font-size,text-decoration,text-align,color,background,text-indent";

        // Enable paste as text
        var pasteAsTextEnabled = false;
        var pasteCookie = readCookie("pasteAsTextTinyMCE");
        if (pasteCookie == 'true') {
            pasteAsTextEnabled = true;
        }

        tinymce.baseURL = "/versions/"+$('#simpro-defaults').data('buildVersion')+"/public/js/jQuery/tinymce4";
        tinymce.init({
            // https://www.tinymce.com/docs/configure/integration-and-setup/
            // selector: '.htmlEditor-js',
            // content_css: content_css, //TODO: Set font css file here
            plugins: plugins,
            menu: {}, // Remove the top menu bar. See https://www.tinymce.com/docs/configure/editor-appearance/#menu
            // statusbar: false, // Disabling this disables editor resizing.
            //TODO css: .mce-path { padding: 2px } to minimise size of status bar.
            toolbar: toolbar,

            // https://www.tinymce.com/docs/configure/editor-appearance/
            branding: false,
            elementpath: false,
            toolbar_items_size: 'small',

            // https://www.tinymce.com/docs/configure/content-filtering/
            allow_conditional_comments: false,
            forced_root_block: 'p',
            forced_root_block_attrs: {
                'style': 'font-size: 10pt;'
            },
            valid_elements: validElements,

            // https://www.tinymce.com/docs/configure/content-formatting/
            fontsize_formats: '8pt 10pt 11pt 12pt 14pt 16pt 18pt 22pt',

            // https://www.tinymce.com/docs/configure/spelling/
            browser_spellcheck: true,

            // https://www.tinymce.com/docs/configure/url-handling/
            relative_urls: false,
            remove_script_host: false,

            // https://www.tinymce.com/docs/plugins/paste/
            paste_postprocess: function (pl, o) {
                var html = o.node.innerHTML;
                html = html
                    .replace(/<div((?:>| [^>]*>)[\s\S]*?<\/)div>/gm, "<p$1p>") // Replace div tags with paragraphs because that's what tinymce expects.
                ;
                var replace = /border: 0px;|position: absolute;|position: relative|position: fixed;/g;
                html = html.replace(replace, ''); // strip borders set to 0px, 0% or 0
                o.node.innerHTML = html;
            },
            paste_webkit_styles: retainedStyles,
            paste_retain_style_properties: retainedStyles,
            paste_remove_styles_if_webkit: false,
            paste_as_text: pasteAsTextEnabled,

            // https://www.tinymce.com/docs/plugins/table/
            table_appearance_options: false,
            table_advtab: false,
            table_cell_advtab: false,
            table_row_advtab: false,
            table_default_styles: {
                'border-collapse': 'collapse',
                'width': '100%'
            },
            table_toolbar: "simprotableoptions tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",

            // https://www.tinymce.com/docs/plugins/link/#default_link_target
            default_link_target: '_blank',

            // All indents should be expressed with margins. Without this some indents use padding, others use margin.
            indent_use_margin: true,

            setup: function (editor) {
                var $editor = $(editor.getElement());
                $editor.removeClass('htmlEditor-js').addClass('tinyMCEEditor');
                let defaultMinHeight = 0;
                editor.on('focus', function() {
                    $(".suggestSelect").suggestselect("close");
                }).on('focus wheel keyup', function(e) {
                    if (editor.id != 'mcePagewidthTextarea') {
                        const iframeElement = $(editor.iframeElement);
                        // resize the editor to fit the content of the contents if not in pagewidth mode
                        const minHeight = iframeElement.height();
                        // +33 to avoid new line causing text to temporarily move up before iframe height matches body height
                        const contentHeight = $(editor.getDoc()).find("body").height() + 33;
                        if (contentHeight > minHeight) {
                            iframeElement.css("height", contentHeight);
                        }
                    }
                }).on('change', function() {
                    // Check and resize tables to fit within a standard page
                    var dom = editor.dom;
                    var tables = editor.$('table');
                    $(tables).each(function() {
                        if ($(this).width()>pdfPageWidth) {
                            dom.setStyle(this, 'width', '100%');
                        }
                    });

                    // Ensure table heights have not been manually set because tcpdf and docx can't handle it.
                    tables.css('height', 'auto');
                    // This is related to common.js#openLink() but I'm not sure why we set it here.
                    quickLinkUpdate = true;

                }).on('blur', function() {
                    const iframeElement = $(editor.iframeElement);
                    // Resize textbox when clicking anywhere else on the page
                    window.setTimeout(function() {
                        iframeElement.css("height", defaultMinHeight);
                    }, 300);
                    var existing = $editor.val();
                    var current = editor.getContent();
                    editor.save();
                    if (existing != current) {
                        // This custom callback is only used in application/staff/forms/projectDetail/js/projectDetail.js
                        // TODO: Have projectDetail.js properly bind to the event so we can remove this.
                        var id = $editor.attr('id');
                        var functionName = id + '_tinyMCEOnChangeCallback';
                        if (typeof window[functionName] === 'function') {
                            window[functionName](current);
                        }
                    }
                }).on('click', function() {
                    clickTextField = $editor.attr('id');
                    if ($editor.attr('id') == 'formDescription') {
                        //check cc and bcc added any emails if not hide them
                        let $FormsFormContainer = $("#FormsFormContainer");
                        let $ccVal = $FormsFormContainer.find('input[name=cc]');
                        let $bccVal = $FormsFormContainer.find('input[name=bcc]');
                        if (typeof $ccVal !== "undefined" && $.parseJSON($ccVal.val()).toString() === '') {
                            $('#ccDiv').addClass('hide');
                            $(".showCc-js").removeClass('hide');
                        };
                        if (typeof $bccVal !== "undefined" && $.parseJSON($bccVal.val()).toString() === '') {
                            $('#bccDiv').addClass('hide');
                            $(".showBcc-js").removeClass('hide')
                        }
                        checkFormPopup($editor);
                    }
                }).on('keydown', function(e) {
                    tinymce_timestamp(e);
                }).on('BeforeSetContent', function (e) {
                // tinymce renders rows of empty table cells as one line-height high. Chrome and Word render these as zero height.
                // To get around this we add a blank space to empty cells as the html is exported from tinymce and we remove it when the html is read into tinymce.
                    // Text is coming from the server, into the editor.
                    // Make changes so text renders correctly in the editor.
                    if (e.content !== '') {
                        // Replace <div>&nbsp;</div></td> with <div></div>
                        e.content = e.content.replace(/(<div[^>]*?>)&nbsp;(<\/div>)/gm, '$1$2');

                        // tinymce expects indent styles to be margin-left:...
                        e.content = e.content.replace(/(style="[^"]*)text-indent:([^"]*")/g, '$1margin-left:$2');

                        // tinymce expects p tags
                        e.content = e.content.replace(/<(\/?)div([^>]*?)>/g, '<$1p$2>');

                        // make sure p tags have font-size:10pt expects p tags
                        e.content = e.content.replace(/<p>/g, '<p style="font-size:10pt;">');

                        // tinymce doesn't do anything with the nobr attribute.
                        e.content = e.content.replace(/<tr nobr="true" ?/g, '<tr ');
                    }
                }).on('PostProcess', function (e) {
                    // Text is going from the editor to the server.
                    // Make changes so text is stored correctly on the server.
                    // if editor is empty just store as ''.
                    if (e.content !== '<p style="font-size: 10pt;"></p>') {
                        // Set nobr attribute so tcpdf doesn't split table rows over page breaks.
                        e.content = e.content.replace(/<tr ?/g, '<tr nobr="true" ');

                        // tcpdf expects div tags
                        e.content = e.content.replace(/<(\/?)p([^>]*?)>/g, '<$1div$2>');

                        // Remove new line characters because they're actually printed in DocX and we don't want them.
                        e.content = e.content.replace(/[\r\n]/g, '');

                        // Remove form tags
                        e.content = e.content.replace(/(<form[^>]*?>)/g, '');
                        e.content = e.content.replace(/(<\/form>)/g, '');

                        // Replace <div></div> with <div>&nbsp;</div> so tcpdf and docs render blank lines correctly.
                        e.content = e.content.replace(/(<div[^>]*?>)(<\/div>)/gm, '$1&nbsp;$2');
                        // Add default font size to tag <li> so onlyoffice can render <li> correctly
                        e.content = e.content.replace(/<li>/g, '<li style="font-size:10pt;">');
                        // tcpdf expects indent styles to be text-indent:...
                        e.content = e.content.replace(/(style="[^"]*)margin-left:([^"]*")/g, '$1text-indent:$2');

                        // Change div Tag to span Tag if the div Tag sits immediately after the li Tag
                       e.content = e.content.replace(/<li style="(.*?)"><div style="(.*?)">(.*?)<\/div>/g, '<li style="$1"><span style="$2">$3</span>');
                        e.content = e.content.replace(/(?:transform): [^;]*;/gi,"");
                    }
                }).on('load', function (e) {
                    // Set default height to resize to on blur
                    defaultMinHeight = $(editor.iframeElement).height();
                });
            },

            init_instance_callback: function(editor) {
                // Set mode must be called after init for the 'mce-disabled' classes and 'aria-disabled' attributes to be set correctly.
                var $editor = $(editor.getElement());
                if ($editor.prop('readonly')) {
                    editor.setMode("readonly");
                } else {
                    editor.setMode("design");
                }

                // Set cookie after toggle paste as text button
                editor.on('PastePlainTextToggle', function (e) {
                    document.cookie = 'pasteAsTextTinyMCE=' + e.state + (document.location.protocol == 'https:' ? '; secure' : '');
                });

            }
        });
    }
}

/**
 * For both tinymce and basic textareas, pressing ctrl-d will print the date and the name of the current user.
 * eg: 18/10/2017 Julian Mallett
 * TODO: Does anyone in userland know about this feature or use it?
 */
function tinymce_timestamp(e) {
    if(e.ctrlKey && (e.keyCode ? e.keyCode : e.which) === 68) {
        $.ajax({
            type: "GET",
            data: 'getTimestamp=1',
            dataType: "json",
            url: "../common/ajax/common.php",
            success: function (responseText) {
                var newContent = "<p><strong>" + responseText.timestamp + "</strong></p><p><br id='caret_pos_holder' data-mce-bogus='1'></p><p><br data-mce-bogus='1'></p>";

                var editor = tinymce.activeEditor;
                var $iframeDoc = $(editor.getDoc());
                var $container = $iframeDoc.find('#mcePagewidthTextareaInner');
                if (!$container.length) {
                    $container = $iframeDoc.find('body');
                }

                $container.prepend(newContent);
                editor.selection.select($iframeDoc.find('#caret_pos_holder').removeAttr('id')[0]);
            }
        });
        e.preventDefault();
    }
}
function textarea_timestamp(element, e) {
    if(e.ctrlKey && (e.keyCode ? e.keyCode : e.which) === 68) {
        $.ajax({
            type: "GET",
            data: 'getTimestamp=1',
            dataType: "json",
            url: "../common/ajax/common.php",
            success: function (responseText) {
                var content = element.val();
                if(content != "") {
                    content = "\r\n\r\n" + content;
                }
                element.val(responseText.timestamp + "\r\n" + content);
                var caret = responseText.timestamp.length+1;
                element.caret({
                    start:caret,
                    end:caret
                });
            }
        })
        e.preventDefault();
    }
}

function openLink(href, event) {
    let isJsLink = href.indexOf("javascript:") >= 0;
    if (isJsLink) {
        let isJsVoid = href.indexOf('void(0)') >= 0;
        if (!isJsVoid) {
            window.location.href = href;
        }
    } else {
        // Quicklinks: Save Mandatory Field Errors to the Session
        let formElement = $("#quicklinks-js");
        let inForm = formElement.closest("form");
        if (inForm.length > 0) {
            checkMandatory(inForm, true);
        }

        let quickLinkUpdateDone = false;
        if (quickLinkUpdate) {
            let $quickLinkButton = $("#quicklinks-js");
            if ($quickLinkButton.exists()) {
                $quickLinkButton.attr("params", "quickLink=" + encodeURIComponent(href));
                $quickLinkButton.trigger("click");
                quickLinkUpdateDone = true;
            }
        }

        if (!quickLinkUpdateDone) {
            // Add the path prefix if we have one. Not done above because php handles this automatically.
            let pathPrefix = simPRODefaults.data('urlPrefix');
            if (pathPrefix !== "") {
                if (href.substring(0, 1) === '/') {
                    href = href.substring(1);
                }
                href = "/" + pathPrefix + href;
            }

            if (typeof (event) !== "undefined" && event.ctrlKey) {
                window.open(href);
            } else {
                window.location.href = href;
            }
        }
    }
}

function autoFocus(context) {

    if(context == null || typeof(context) != 'object') {
        context = $(document);
        let dialogBox = $('.dialogBox').filter(":visible");
        if (dialogBox.exists()) {
            context = dialogBox;
        }
    }
    // Auto focus on page load
    $(context).find("input[autofocus], textarea[autofocus], .autofocus").filter(":visible").focus().select();
}

function viewFormDocx() {
    viewForm('docx');
}

/*
* @param string formType: null/pdf, docx
 */
function viewForm(formType) {
    var form = $("#formID");
    var formURL = form.val();
    var formSelected = form.find("option:selected");
    if (formType == 'docx') {
        formURL = formSelected.data('docx');
    } else {
        formURL = form.val();
        var formName = formSelected.data("name");
        if (formName) {
            var pos = formURL.indexOf('.php')+4;
            if (pos == -1) {
                pos = formURL.length;
            }

            // We encode the form name to remove special characters so that the url matches our special lighttpd rewrite rule for forms
            // We encode it twice because browsers will decode the url when the html form (below) is POSTed
            formURL = formURL.substring(0, pos) + "/" + encodeURIComponent(encodeURIComponent(formName)) + formURL.substring(pos);
        }
    }

    var formContainer = $("#FormsFormContainer");
    var inForm = formContainer.closest("form");
    if(inForm.length > 0) {
        formContainer = inForm;
    }
    // trigger save not working unless serialized
    var params = formContainer.find("textarea, select, input:not(:checkbox,:radio), input:checked");
    var string = "";
    if (params.length > 0){
        $.each(params, function(index, item) {
            var name = $(item).attr("name");
            var value = String($(item).val()); // decode in case already encoded by serialize
            string += "<input type='hidden' name='" + name + "' value='" + value.htmlEscape() + "' />";
        });
    }
    if ($('#openHash').exists()) {
        string += "<input type='hidden' name='openHash' value='" + $('#openHash').val() + "' />";
    }

    $('<form method="post" action="' + formURL + '" target="' + formWindow.name + '"></form>').append($(string)).appendTo(document.body).submit().remove();
    formWindow.focus();
    hideLoadingImage();
}

function emailForm() {
    showLoadingImage();

    var $formContainer = $("#FormsFormContainer");
    var $form = $formContainer;
    var $selected;
    var params = '';
    let formURL = '';
    if ($('#formSelection').is(':visible')) {
        $selected = $('#editForm');
        params += '&formTmpName=' + $selected.data('tmpname') + '&emailSavedForm=true';
    } else {
        var $formID = $("#formID");
        $selected = $formID.find("option:selected");
    }

    var $to = $formContainer.find("[name='to']");
    var $cc = $formContainer.find("[name='cc']");
    var $bcc = $formContainer.find("[name='bcc']");
    if ($formContainer.hasClass("new-js")) {
        var to = JSON.parse($to.val()).toString();
        var cc = JSON.parse($cc.val()).toString();
        var bcc = JSON.parse($bcc.val()).toString();
        if ($formContainer.attr("target")) {
            var $form = $($formContainer.attr("target"));
        }

    } else {
        var to = $to.val();
        var cc = $cc.val();
        var bcc = $bcc.val();
        var $inForm = $formContainer.closest("form");
        if ($inForm.exists()) {
            $form = $inForm;
        }

    }
    var $attachFormEmail = $('#attachFormEmail');
    if ($selected.data("type") === "document" || $selected.data("type") === "savedform" || $attachFormEmail.length > 0 && $attachFormEmail.val() == '0') {
        formURL = handlerFromUrl($selected, $("#ajaxSubmitURL").val());
    } else {
        formURL = $formID.val();
    }
    params += '&attachFormEmail=' + $attachFormEmail.val();
    let openHash = $('#openHash');
    if (openHash.exists()) {
        params += "&openHash=" + openHash.val();
    }
    var data = $form.find("textarea:not([name='to'], [name='cc'], [name='bcc']), select, " +
        "input:not(:checkbox, :radio, [name='to'], [name='cc'], [name='bcc']), " +
        "input:checked").serialize() +
        "&to=" + encodeURIComponent(to) +
        "&cc=" + encodeURIComponent(cc) +
        "&bcc=" + encodeURIComponent(bcc) +
        "&sessionName=" + $("#formAttachSessionName").val() +
        "&emailForm=true" + params;
    $.ajax({
        type: "POST",
        url: formURL,
        data: data,
        dataType: "json",
        success: function (data) {
            var txtMessage;
            if (data.success === false) {
                txtMessage = '<strong>' + gettext('There was an error sending this email.') + ' </strong><br />' + data.message;
            } else if (typeof data.emailsTo !== 'undefined') {
                txtMessage = gettext('Form has been emailed:') + '<br />';
                txtMessage += '<br />' + gettext('To:') + '<br />';
                //append to emails
                $.each(data.emailsTo, function(index, value) {
                    if ((String(index)).match(/^\d+$/)) {
                        txtMessage += '- ' + value + '<br />';
                    } else {
                        txtMessage += '- ' + value + ' (' + index + ')<br />';
                    }
                });
                //append cc emails
                if (typeof data.emailsCc !== 'undefined') {
                    txtMessage += gettext('Cc:') + '<br />';
                    $.each(data.emailsCc, function(index, value) {
                        if ((String(index)).match(/^\d+$/)) {
                            txtMessage += '- ' + value + '<br />';
                        } else {
                            txtMessage += '- ' + value + ' (' + index + ')<br />';
                        }
                    });
                }
                //append bcc emails
                if (typeof data.emailsBcc !== 'undefined') {
                    txtMessage += gettext('Bcc:') + '<br />';
                    $.each(data.emailsBcc, function(index, value) {
                        if ((String(index)).match(/^\d+$/)) {
                            txtMessage += '- ' + value + '<br />';
                        } else {
                            txtMessage += '- ' + value + ' (' + index + ')<br />';
                        }
                    });
                }
                if ($formContainer.find(".emailForm").hasClass("emailAjaxSubmit")) {
                    ajaxSubmit($form, "emailedForm=true", null, false);
                }
            } else if (data.success === true) {
                txtMessage = data.message;
                if ($formContainer.find(".emailForm").hasClass("emailAjaxSubmit")) {
                    ajaxSubmit($form, "emailedForm=true", null, false);
                }
            } else {
                // An error outputing to screen in development mode may be interfering with JSON. Check profileBrowser or console.log data.
                txtMessage = gettext('Error sending email.');
            }

            createDialog("alert", txtMessage, gettext("Email Form"));
            hideLoadingImage();
        },
        error: function (data) {
            // An error outputing to screen in development mode may be interfering with JSON. Check profileBrowser or console.log data.
            var txtMessage;
            txtMessage = gettext('Error sending email.');
            createDialog("alert", txtMessage, gettext("Email Form"));
            hideLoadingImage();
        }
    });
}

function checkFormPopup(target) {
    var selected = $("#formID option:selected");
    //this checks if the "Send without Form" switch is turned off(in the new forms page)
    var emailOnly = $("#attachFormEmail").prop("checked") == true ? true : false;
    if (selected.data("popup") && !emailOnly) {
        $(".suggestSelect").suggestselect("close");
        iframeLoaded = function(body) {
            if (target.attr("id") == 'formDescription') {
                var iframeTinyMCE = body.contentWindow.tinymce;
                var ed = iframeTinyMCE.activeEditor;
                iframeTinyMCE.get('formDescription').focus();
                ed.selection.select(ed.getBody(), true);
                ed.selection.collapse(false);
            } else {
                $(body).contents().find("#" + target.attr("id")).focus();
            }
        }
        openFormPopup(selected);
    }
}
let popupCallbackForm = null;
function openFormPopup(form) {
    let quickLinkUpdateDone = false;
    if (quickLinkUpdate) {
        popupCallbackForm = form;
        let $quickLinkButton = $("#quicklinks-js");
        if ($quickLinkButton.exists()) {
            ajaxSubmit(form, null, 'openFormPopupCallback');
            quickLinkUpdateDone = true;
        }
    }
    if (!quickLinkUpdateDone) {
        openFormPopupDialog(form);
    }
}
function openFormPopupCallback() {
    if (popupCallbackForm) {
        openFormPopupDialog(popupCallbackForm);
        popupCallbackForm = null;
    }
}

function openFormPopupDialog(form) {
    let openHash = ($('#openHash').exists() ? (form.val().indexOf('?') === -1 ? '?' : '&') + 'openHash=' + $('#openHash').val() : '');
    createDialog("link", form.val() + openHash, form.text(), null, form.data("popup") == 1);
}

function storeBackButton(){
    try {
        history.pushState(ajaxSubmitResponse, "", window.location.href);
    } catch(e) {
    }
}
function validNumber(val) {
    var character = val.charAt(val.length-1);
    if(character == ")") {
        character = val.charAt(val.length-2);
    }
    if(!isNaN(character)) {
        return true;
    } else {
        return false;
    }
}

function numberStep(target, step, direction) {
    // if already change timeout cancel
    if(typeof(numberTimeoutID) != "undefined") {
        window.clearTimeout(numberTimeoutID);
    }
    // add change event timeout
    numberTimeoutID = window.setTimeout(function() {
        $(target).trigger('change');
    },400);

    if(direction == "up") {
        var val = parseFloat(target.getNumber()+step);
    } else {
        var val = parseFloat(target.getNumber()-step);
    }
    val = Math.round(val*100)/100
    if(target.attr("max") !== undefined && val > parseFloat(target.attr("max"))) {
        val = parseFloat(target.attr("max"));
    }
    if(target.attr("min") !== undefined && val < parseFloat(target.attr("min"))) {
        val = parseFloat(target.attr("min"));
    }
    target.val(val).numberFormat();
}

function getItemSearchAttributesValue(item) {
    var attributes = [];
    attributes['searchType'] = $(item).attr("searchType") != null ? $(item).attr("searchType") : "partial"; // Search type - exact match or partial match
    attributes['maxRows'] = $(item).attr("maxResults") != null ? $(item).attr("maxResults") : 25; // Maximum number of results to show
    attributes['maxRowsType'] = $(item).attr("maxResultsType") != null ? $(item).attr("maxResultsType") : 0; // If set to 1, the maximum number of results will show for every result type
    attributes['displayMode'] = $(item).attr("displayMode") != null ? $(item).attr("displayMode") : "advanced"; // If set to advanced, second description line will show
    attributes['noResults'] = $(item).attr("noResults") != null ? $(item).attr("noResults") : "1"; // Show no results line
    attributes['params'] = $(item).attr('params') != null ? '&' + $(item).attr('params') : '';
    return attributes;
}

function selectUKAddress(element, details) {
    address = '';
    newline=false;
    if(typeof(details.Department) == "string") {
        address += details.Department;
        newline = true;
    }
    if(typeof(details.Building) == "string") {
        if(newline) {
            address += '\r\n';
        }
        address += details.Building;
        newline = true;
    }
    if(typeof(details.POBox) == "string") {
        if(newline) {
            address += '\r\n';
        }
        address += details.POBox;
        newline = true;
    }
    if(typeof(details.SubBuilding) == "string") {
        if(newline) {
            address += '\r\n';
        }
        address += details.SubBuilding;
        newline = true;
    }
    if(typeof(details.BuildingNo) == "string" && details.BuildingNo != '0') {
        if(newline) {
            address += '\r\n';
        }
        address += details.BuildingNo + ' ';
        newline = false;
    }
    if(typeof(details.Thoroughfare) == "string") {
        if(newline) {
            address += '\r\n';
        }
        address += details.Thoroughfare;
        newline = true;
    }
    if(typeof(details.Street) == "string") {
        if(newline) {
            address += '\r\n';
        }
        address += details.Street;
        newline = true;
    }
    if(typeof(details.DoubleDependant) == "string") {
        if(newline) {
            address += '\r\n';
        }
        address += details.DoubleDependant;
        newline = true;
    }
    if(typeof(details.Dependant) == "string") {
        if(newline) {
            address += '\r\n';
        }
        address += details.Dependant;
        newline = true;
    }

    var addressInput = $("#" + $(element).attr("address"));
    if(addressInput.val() == '') {
        addressInput.val(address);
    }
    var suburbInput = $("#" + $(element).attr("suburb"));
    if(suburbInput.val() == '' && typeof(details.PostTown) == "string") {
        suburbInput.val(details.PostTown);
    }
    if(typeof($(element).attr("company")) != "undefined") {
        var companyInput = $("#" + $(element).attr("company"));
        if(companyInput.val() == '' && typeof(details.Organisation) == "string") {
            companyInput.val(details.Organisation);
        }
    }
}
var lastChecked = null;
$(document).on('click', '.chkbox', function () {
    var chkboxes = $('.chkbox');
    chkboxes.click(function(e) {
        if(!lastChecked) {
            lastChecked = this;
            return;
        }
        if(e.shiftKey) {
            var start = chkboxes.index(this);
            var end = chkboxes.index(lastChecked);
            chkboxes.slice(Math.min(start,end), Math.max(start,end)+ 1).attr('checked', lastChecked.checked);
        }
        lastChecked = this;
    });
}).delegate('.passwordEdit', 'focus keyup change paste', function () {
    passwordTooltip($(this));
}).delegate('.passwordEdit', 'blur', function () {
    $this = $(this);
    if($this.val() != "") {
        if(!passwordScore){
            createToolTip($this.parent().find('span'),true);
            $this.focus();
            return;
        }
    } else if($this.parent().hasClass("validGroupedInput")){
        $this.parent().find("span").remove();
        $this.removeClass("invalidInput");
    }
    $('.tooltip').remove();
    passwordScore = 0;
});

var passwordRestrictionsTxt = gettext("Your password needs to be at least 8 characters <br /> with 1 number, 1 lowercase letter, 1 capital letter <br /> and 1 special character.");
var passwordScore = 0;

function passwordTooltip(passwordField) {
    var passwordStrength = checkPassStrength(passwordField.val());
    var strengthColour = 'textRed';
    var iconClass = 'icon-close';
    passwordField.addClass("invalidInput");
    if (passwordStrength == gettext("Good")) {
        strengthColour = 'textYellow';
        iconClass = 'icon-check-alt';
        passwordField.removeClass("invalidInput");
    }
    if (passwordStrength == gettext("Strong")) {
        strengthColour = 'textGreen';
        iconClass = 'icon-check-alt';
        passwordField.removeClass("invalidInput");
    }
    var currentStrengthTxt = gettext("Current password strength: <span class='" + strengthColour + "'>" + passwordStrength + "</span>.");
    var tooltipHTML = "<span id='passwordTooltip'><span class='icon-exclamation'></span> " + passwordRestrictionsTxt + "</span><br />" + currentStrengthTxt;

    var $passwordParent = passwordField.parent();
    if(!$passwordParent.hasClass("validGroupedInput")){
        passwordField.wrap("<div class='validGroupedInput'></div>").after("<span class='" + strengthColour + " " + iconClass + "'></span>").focus();
        $passwordParent = passwordField.parent();
    } else {
        if(!$passwordParent.find('span').exists()){
            $passwordParent.append("<span class='" + strengthColour + " " + iconClass + "'></span>");
        } else {
            $passwordParent.find('span').removeAttr("class").addClass(''+iconClass+' '+strengthColour+'');
        }
    }
    $passwordParent.find('span').attr("title", tooltipHTML);
    if($("#passwordTooltip").is(":visible")){
        $('.tooltip').remove();
        createToolTip($passwordParent.find('span'), true);
    }
}

function scorePassword(pass) {
    var score = 0;
    const specialCharactersRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\\/\-=|'"` ]/;

    // check minimum requirements
    if (!pass) {
        return score;
    }
    // if less than 8 characters return 0
    if( pass.length < 8 ) {
        return score;
    }
    // if no digits return 0
    if( /\d/.test(pass) < 1 ) {
        return score;
    }
    // if no lower case return 0
    if( /[a-z]/.test(pass) < 1 ) {
        return score;
    }
    // if no upper case return 0
    if( /[A-Z]/.test(pass) < 1 ) {
        return score;
    }
    // if no special characters return 0
    if( specialCharactersRegex.test(pass) < 1 ) {
        return score;
    }
    // password has met minimum requirements

    // award every unique letter until 5 repetitions
    var letters = {};
    for (var i=0; i<pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 6.0 / letters[pass[i]];
    }

    // bonus points for mixing it up
    var variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: specialCharactersRegex.test(pass),
    }

    variationCount = 0;
    for (var check in variations) {
        variationCount += (variations[check] == true) ? 1 : 0;
    }
    score += (variationCount - 1) * 10;

    return parseInt(score);
}

function checkPassStrength(pass) {
    passwordScore = scorePassword(pass);
    if (passwordScore > 80) {
        return gettext("Strong");
    }
    if (passwordScore > 1) {
        return gettext("Good"); // if password meets minumum requirements then it is OK
    }
    return gettext("Weak"); // password does not meet minimum requirements
}

function passwordOK(passwordField) {
    if(passwordField.hasClass("mandatory") || passwordField.val() != '') {
        var passwordStrength = checkPassStrength(passwordField.val());
        if (passwordStrength == "Weak") {
            return false;
        }
    }
    return true;
}

function createDialogConfirm(element, ajaxCall) {
    var $this = element,
        href = $this.attr("href"),
        target = "",
        confirmationMessage = "",
        confirmationTitle = "";

    if (typeof $this.data("href") !== "undefined") {
        href = $this.data("href");
    }
    if (typeof $this.attr("target") !== "undefined") {
        target = $this.attr("target");
    }

    if (typeof $this.data('confirmtitle') !== "undefined") {
        confirmationTitle = $this.data('confirmtitle');
    } else if (typeof $this.attr('title') !== "undefined") {
        confirmationTitle = $this.attr("title");
    }

    if (typeof $this.data('confirmmessage') !== "undefined") {
        confirmationMessage = $this.data('confirmmessage');
    } else if (typeof $this.attr('value') !== "undefined") {
        confirmationMessage = $this.attr("value");
    }

    var confirmationSize = false;
    if (typeof $this.data('confirmsize') !== "undefined") {
        confirmationSize = $this.data('confirmsize');
    }

    var confirmationDialog = createDialog("confirm", confirmationMessage, confirmationTitle, href, null, null, confirmationSize);
    var suggestSelectData = $this.data('suggestselect');
    var suggestSelect = typeof(suggestSelectData) !== "undefined";
    if (suggestSelect) {
        confirmationDialog.on("click", ".dialogClose", function () {
            $this.suggestselect("setValue", $this.data('suggestselect').initialValue);
        });
    }
    confirmationDialog.delegate(".dialogContinue", "click", function () {
        // If OK button is clicked, run the original functionality
        showLoadingImage();
        $this.removeClass("dialogConfirm");
        if (ajaxCall) {
            $this.addClass("ajaxClick");
        }

        if (href && (href.indexOf(".php") != -1 || href.indexOf("http") != -1 || (href.indexOf("javascript:") != -1 && href.indexOf("void(0)") == -1))) {
            if ($this.closest(".iframe").exists()) {
                href += "&iframe=true";
            }
            if (target == "window") {
                window.open(href, "", "width=1175,height=740,left=100,top=100,screenX=100,screenY=100,resizable=no,scrollbars=yes");
            } else if (target == "_blank") {
                window.open(href);
            } else {
                window.location = href;
            }
            return false;
        } else {
            if (suggestSelect) {
                $this.change();
            } else {
                $this.click();
            }
        }
        $this.addClass("dialogConfirm");
        confirmationDialog.remove();
        if (!element.hasClass("loadingImage-js") && !element.hasClass("ajaxClick") && !element.hasClass("ajaxChange")) {
            hideLoadingImage();
        }
    });
    return confirmationDialog;
}

/**
 * Create a custom confirmation dialogue.
 *
 * @param {string} title - Title of the dialog.
 * @param {string} bodyContent - HTML content for the body of the dialog.
 * @param {Array<Object>} buttons - Array of buttons with their properties.
 * @param wrapperClasses
 * @param target
 * @param noClose
 * @param hiddenDialogue
 * @param {Object} size - Size of the dialog.
 * @param {string} size.width - The width of the dialog (e.g., '599px').
 * @param {boolean} size.forceHeight - Whether to force the height of the dialog.
 * @param {string} size.height - The height of the dialog (e.g., '209px').
 * @param {boolean} [hideHeader=false] - Flag to hide the header.
 * @param fixedButtons
 * @param draggable
 * @param footer
 * @returns {void}
 */
function createConfirmationDialogue(
    title,
    bodyContent,
    buttons = [],
    wrapperClasses = [],
    target = null,
    noClose = false,
    hiddenDialogue = false,
    size = {},
    hideHeader = false,
    fixedButtons = false,
    draggable = false,
    footer = ''
) {
    // Generate the content for the custom dialog
    const content = `
        ${bodyContent}
        <div class="row">
          <div class="${wrapperClasses.join(' ')}">
            ${buttons.map(({ text, ...buttonClasses }) => {
        const classList = Object.values(buttonClasses).join(' ');
        return `<button type="button" class="${classList}">${text}</button>`;
    }).join('')}
            </div>
        </div>
    `;
    createDialog(
        'custom',
        content,
        title,
        target,
        noClose,
        hiddenDialogue,
        size,
        hideHeader,
        fixedButtons,
        draggable,
        footer
    );
}

function filesizeFormat(bytes) {
    if(bytes === 0) {
        return "0 Bytes";
    }
    var sizeNames = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
    var sizeNameIndex = Math.floor(Math.log(bytes)/Math.log(1024));
    return Math.round((bytes/Math.pow(1024, Math.floor(sizeNameIndex)))*100)/100 + " " + sizeNames[sizeNameIndex];
}

/**
 * @param {string} key	String to be translated
 * @returns {string}	Translation according to the user language preference.
 *						If dictionary is not present returns key in the default
 *						language.
 */
function gettext(key) {
    return (typeof translations !== 'undefined' && key in translations) ? translations[key] : key;
}

function expandJS(target) {
    var data = $(target).data();
    $collapsed = $(data.collapse);
    $expand = $(data.expand);
    if (typeof(data.disableToggle) !== "undefined") {
        if( ! $collapsed.is(":visible") ){
            $expand.hide();
            $collapsed.show();
        } else {
            $collapsed.hide();
            $expand.show();
        }
    } else {
        $collapsed.hide();
        $expand.show();
    }
    if (typeof(data.toggleClass) !== "undefined") {
        if (typeof(data.restrictTo) !== "undefined") {
            var targetClass = $(target).attr("class");
            $(target).closest(data.restrictTo).find("." + targetClass).removeClass(data.toggleClass);
        }
        $(target).toggleClass(data.toggleClass);
    }
}
function prepareAttachments(context) {
    /* Needs to run this function when in Grid View, otherwise the thumbnails aren't visible */
    var attachmentContainers = $('.attachmentContainer',context).filter(":visible");
    if (attachmentContainers.exists()) {
        $(".attachmentDraggable",context).draggable({
            revert: "invalid",
            containment: $('.draggingArea').parent().parent(),
            scroll: true,
            helper: "clone",
            opacity: 0.9,
            cursorAt: {left: -5, top: 10},
            start: function(event, ui){
                if($(this).hasClass('dragFolder')) {
                    $(this).addClass('noHighlight');
                }

                $('.attachmentViewBreadcrumb').addClass('hover');
                draggedAttachmentItem = $(this);
            },
            stop: function(event, ui) {
                $(this).removeClass('noHighlight');
                $('.attachmentViewBreadcrumb').removeClass('hover');
                draggedAttachmentItem = $(this);
            }
        });

        $(".attachmentFolderDroppable",context).droppable({
            hoverClass: "highlightDrag",
            tolerance: "pointer",
            drop: function(Event, ui){
                moveAttachmentItem($(this),draggedAttachmentItem);
            }
        });

        attachmentContainers.filter(":not(:has(div.uploadifive-button))").each(function(index, item) {
            if (!$(item).data('hasupload') || $(item).data('hasupload') !== 'true') {
                $(item)
                    .data('hasupload', 'true');
                let browse_button = $(item)
                    .find('.attachmentBrowse')
                    .attr('id');
                let attachDrop = $(item)
                    .find('.attachmentDrop');
                let drop_element = attachDrop.attr('id');
                let parentFolderID = attachDrop.data('folder-id');
                let form = $(item)
                    .closest('form');
            let url = form.attr('action');
                let imagePlaceholder = $(this)
                    .data('image-placeholder');

            let dropArea,
                dnd;

            if (drop_element === undefined) {
                dropArea = false;
                dnd = false;
            } else {
                dropArea = '#' + drop_element;
                dnd = true;
            }

            attachDrop.on('drop', function() {
                //Note: Had to use this as in Edge, when dropping a folder, none of the standard plupload events which can be hooked are fired, this avoids editing the library.
            $(this)
                .removeClass('highlightDrag');
            });

            if (typeof browse_button == 'undefined') {
                browse_button = '';
                }
if(imagePlaceholder) {
                //updateType is used for updating the image display in prebuild
                url += "&action=addDefaultImage&updateType=1";
            } else {
                url += "&action=addAttachment";
            }

            url += "&ajaxCall=true&targetFolderID=" + parentFolderID;
            let containerWrap = $(item).closest('.attachmentContainerWrapper');

            if (!containerWrap.exists()) {
                containerWrap = $(item).closest('.attachmentContainer');
            }

            let paramsInput = containerWrap.find('.attachmentDropParams');
            let queDisabled = ($(containerWrap).data('attachment-queue') !== undefined &&
                $(containerWrap).data('attachment-queue') === 'disabled');

            if(typeof paramsInput.val() != 'undefined'){
                url += (paramsInput.val().trim() != '') ? '&' + paramsInput.val().trim(): '';
            }

            let singleFile = $(this).data("single-file") === true ? true : false;
            let fileName;

            if(typeof($(this).data("filename")) !== "undefined") {
                fileName = $(this).data("filename");
            } else {
                fileName = 'file';
            }

            let browseButtonArray = ['attachmentBrowse_image', 'newUpload_manual_attachmentBrowse', 'newUpload_brochure_attachmentBrowse', 'newUpload_other_attachmentBrowse'];
            let allowMultipleSelect = $.inArray(browse_button, browseButtonArray) === -1 ? true : false;

            let response = '';
            let uploaded = false;
            let showError = false;
            $(function() {
                $('#' + browse_button).uploadifive({
                    'auto'             : true,
                    'fileType'         : false,
                    'dnd'             : dnd,
                    'fileObjName'     : fileName,
                    'uploadScript'     : url,
                    'queueID'         : 'fakeCue_'+browse_button,
                    'fileSizeLimit'   : 81920, // = 83886080/1024
                    'multi'           : allowMultipleSelect,
                    'buttonText'   : '',
                    'width'             : '100%',
                    'simUploadLimit' : 4,
                    'dropTarget'      : dropArea,
                    'onUpload' : function() {
                        var i = {};
                        var params = {};
                        params[csrfParamName()] = csrfParamValue();
                        $(item).data('hasupload',false);
                        disableElements(form);
                        $('.draggingArea').removeClass('activeDrag');
                        $.each(form.find("input,textarea, select").serializeArray(), function(index,value) {
                            if(typeof params[value.name] !== "undefined") {
                                params[value.name] += "," + value.value;
                            } else {
                                if(value.name.match(/^.*\[\]$/) !== null) {
                                    var name = value.name.substr(0,value.name.length - 2);
                                    if(typeof i[name] === "undefined") {
                                        i[name] = 0;
                                    }
                                    params[value.name.substr(0,value.name.length - 2)+'['+i[name]+']'] = value.value;
                                    i[name]++;
                                } else {
                                    params[value.name] = value.value;
                                }
                            }
                        });
                        enableElements(form);
                        showLoadingImage();
                        let $BrowseButton = $('#' + browse_button);
                        $BrowseButton.data('uploadifive').settings.uploadScript = $BrowseButton.data('uploadifive').settings.uploadScript + checkTabs();
                        $BrowseButton.data('uploadifive').settings.formData = params;
                    },
                    'onAddQueueItem' : function(file) {
                        file.id = file.queueItem[0].id;
                        var filesize = gettext("Uploading...");
                        if (typeof file.size != "undefined") {
                            filesize = filesizeFormat(file.size);
                        }
                        if (file.name.indexOf('.') == -1 && file.size % 4096 == 0) {
                            createDialog("alert",gettext("To upload the contents of a folder, enter the local folder and select all of the files at once. They can then be dragged & dropped into the upload screen as a set."),gettext("Folders can't be uploaded"));
                            this.data('uploadifive').removeQueueItem(file, 0, 10);
                            showResponse(response,null, true);
                            return false;
                        } else {
                            $attachmentQueue = $("#fileUploadContainer");
                            if (!$attachmentQueue.exists()) {
                                $attachmentQueue = $(containerWrap).find(".attachmentQueue");
                            }
                            //Emulates the function CommonUtil->formatFilesize

                            if (singleFile) {
                                $attachmentQueue.empty();
                            } else {
                                $attachmentQueue.find(".tblplaceholder").remove();
                            }
                            if (file.size < 83886080) {
                                $attachmentQueue.slideDown();
                                $attachmentQueue.prepend("<tr>" +
                                    "<td><span class='fileName'>" + file.name + "</span></td>" +
                                    "<td>" + filesize + "</td>" +
                                    "<td><div class='left' id='" + file.id + "Percent'></div><span id='" + file.id + "Complete' class='hide attachmentSuccess' style='margin-left: 5px;'>&nbsp;</span></td>" +
                                    "</tr>");
                            }
                        }
                    },
                    'onError' : function(error, fileType, data) {
                        showError = true;
                        response = data;
                        console.log('Error:', error)
                        if (error === 'FILE_SIZE_LIMIT_EXCEEDED'){
                            $attachmentQueue.slideDown();
                            $attachmentQueue.prepend("<tr>" +
                                '<td colspan="4" style="color:#ff0000;">' + sprintf(gettext("Error: %s exceeds the file size limit of 80MB"), fileType.name) + '</td>' +
                                '</tr>');
                        } else {
                            $attachmentQueue.slideDown();
                            $attachmentQueue.prepend("<tr>" +
                                "<td colspan='4'>" + gettext('Error: Unknown error occurred') + "</td>" +
                                "</tr>");
                            }
                    },
                    'onProgress'  : function(file, event) {
                        var percentage = (event.loaded / file.size) * 100;
                        file.id = file.queueItem[0].id;
                    $("#" + file.id + "Percent").progressbar({
                            value: percentage
                    }).css({
                        "width" : "50%",
                        "height" : "10px"
                        })
                    },
                    'onUploadComplete' : function(file, data) {
                        file.id = file.queueItem[0].id;
                        $("#" + file.id + "Complete").show();
                        $("#" + file.id + "Percent").hide();
                        response = data;
                        uploaded = true;
                    },
                    'onQueueComplete' : function(data) {
                        let delay = 0;
                        if (showError) {
                            delay = 2000;
                        }
                        setTimeout( function () {
                            let $fileUploadContainer = $('#fileUploadContainer');
                            $fileUploadContainer.find('tbody')
                                .empty();
                            $fileUploadContainer.hide();
                            hideLoadingImage();
                            showError = false;
                            if (uploaded) {
                                showResponse(response, null, true);
                            }
                            if ((queDisabled || !uploaded) && ($(item).find('input').length > 2)) {
                                $("#" + browse_button)
                                    .next('input')
                                    .remove();
                            }
                            prepareAttachments('#content');
                            uploaded = false;
                        }, delay);

                    },
                    'onClearQueue'     : function(queue) {
                        showResponse(response, null, true);
                    },
                });
                });
            }
        });
    }
    if ($('.attachmentView-js').val() == 0) {
        setTimeout(function(){
            loadOnscreenItems();
        }, 300);
    }
}

function downloadZip() {
    window.open($('.downloadZip-js').data('link'),'downloadZipFrame');
}

function moveAttachmentItem(folderItem, attachmentItem) {
    let parentFolderID = $('#parentFolderID').val();
    let tmpName = attachmentItem.data('tmpname');
    let projectDetail = (attachmentItem.data('projectdetail') !== undefined ? $(attachmentItem).data('projectdetail') : null);
    let editType = attachmentItem.data('edit-type');
    let ownFolderID = attachmentItem.data('folder-id');
    let targetFolderID = folderItem.data('folder-id');

    if (ownFolderID !== targetFolderID) {
        let params = "action=move&tmpName=" + tmpName + "&editType=" + editType + "&projectDetail=" + projectDetail + "&parentFolderID=" + parentFolderID + "&targetFolderID=" + targetFolderID + "&ownFolderID=" + ownFolderID;
        ajaxSubmit(folderItem, params);
    }
}

const queuedOffscreenItems = [];
const maxConcurrentThumbnailLoad = 6;
let activeThumbnailLoad = 0;
function loadOnscreenItems() {
    const loadNextItem = function() {
        if (queuedOffscreenItems.length > 0) {
            loadOffScreenItem(queuedOffscreenItems.shift());
        } else {
            activeThumbnailLoad--;
        }
    };

    const loadOffScreenItem = function (offscreenItem) {
        const thumbImgKey = `thumbImg${offscreenItem.index}`;
        const $attachmentThumbnail = $(`#attachmentThumbnail${offscreenItem.index}`);
        const elementId = $attachmentThumbnail.data('elementid');
        const tmpName = $attachmentThumbnail.data('tmpname');
        const filename = $attachmentThumbnail.data('filename');
        const extension = $attachmentThumbnail.data('extension');
        const link = $attachmentThumbnail.data('link');
        const isImage = $attachmentThumbnail.data('is-image');

        const attributes = `
            data-tmpname="${tmpName}"
            data-elementid="${elementId}"
            data-filename="${filename}"
            data-link="${link}"`;

        // we generate preview thumbnail for tiff and pdf
        if (isImage || ['pdf', 'tiff'].includes(extension)) {
            //show thumbnail preview for pdf and tiff, however load in different window than modal
            let element = !isImage ? `href="${link}" target="_blank"` : `class="showImageBox-js"`;
            $attachmentThumbnail.hide()
              .html(`
                <a ${attributes} ${element}>
                  <img src="${offscreenItem.src}" alt="" id="${thumbImgKey}" />
                </a>`)
              .slideDown(500);
            $(`#${thumbImgKey}`).on("load error", loadNextItem);
        } else {
            $attachmentThumbnail.html(`
              '<a ${attributes} href="${link}" target="_blank" >
                <span class="icon-file"></span>
                <span class="extension">${extension}</span>
              </a>`);
            loadNextItem();
        }
    };

    $('.unprocessedThumbnail').each(function() {
        var currentItem = [];
        if($(this).isOnScreen() && $(this).parent().find('.unprocessedThumbnailPlaceholder').is(':visible')) {
            currentItem['index'] = $(this).data('index');
            currentItem['hasThumbnail'] = $(this).data('hasThumbnail');
            currentItem['contentType'] = $(this).data('contentType');
            currentItem['link'] = $(this).data('link');
            currentItem['src'] = $(this).data('src');
            $(this).removeClass("unprocessedThumbnail");
            if (activeThumbnailLoad === maxConcurrentThumbnailLoad) {
                queuedOffscreenItems.push(currentItem);
            } else {
                activeThumbnailLoad++;
                loadOffScreenItem(currentItem);
            }
        }
    });
}

function loadAlertsAnnouncements() {
    var param;
    var gadgetAlerts = $("#gadgetAlerts");
    var staffAlerts = $("#alertsBox");
    var dashboard = gadgetAlerts.exists();
    var alertParam = staffAlerts.exists() ? '&alertCacheEnabled=false' : '';
    if (dashboard) {
        var gadgetAnnouncements = $("#gadgetAnnouncements");
        addLoadingImage(gadgetAlerts);
        addLoadingImage(gadgetAnnouncements);
        param = "&detailed=true";
    } else {
        param = "&detailed=false";
    }
    let href = '/staff/gadgets/ajax/alerts.php?gadget=true&ajaxCall=true';
    let pathPrefix = simPRODefaults.data('urlPrefix');
    if (typeof pathPrefix !== "undefined" && pathPrefix !== "") {
        if (href.substring(0, 1) === '/') {
            href = href.substring(1);
        }
        href = "/" + pathPrefix + href;
    }
    href = href + param + alertParam;
    $.ajax({
        type: 'GET',
        url: href,
        dataType: "json",
        data: "format=json",
        success: function(response) {
            if(response){
                var alertsResponse = response.alerts;
                if (alertsResponse) {
                    var alertsContainer = $("#headerAlerts");
                    if(alertsContainer.exists()){
                        if(alertsResponse.total > 0) {
                            alertsContainer.find("a").html(alertsResponse.total > 99 ? '99+' : alertsResponse.total);
                            alertsContainer.css("visibility", "visible");
                        } else {
                            alertsContainer.hide();
                        }
                    }
                    if (dashboard) {
                        let alertsShown = 0;
                        var dashboardAlerts = $(".dashboardAlert");
                        //Checking if dashboard need to be updated
                        var values = [];
                        for (var i in alertsResponse) {
                            if (i != 'total') {
                                values.push (alertsResponse[i]);
                            }
                        }
                        dashboardAlerts.css("display", "none");
                        dashboardAlerts.each(function(){
                            var key = $(this).data("key");
                            var value = 0;
                            if(alertsResponse[key]){
                                value = alertsResponse[key];
                            }

                            var minBlockSize = 17;
                            var maxBlockSize = 70;
                            var maxOfArray = Math.max.apply(Math, values);
                            var multiplier = (maxBlockSize-minBlockSize)/maxOfArray;

                            $(this).find(".dashboardAlertValue").css("width", minBlockSize + (value*multiplier) + "px").html(value);

                            if(alertsResponse[key]){
                                alertsShown++
                                $(this).show();
                                $(this).css("visibility", "visible");
                            }
                        });
                        if (!alertsShown) {
                            $("#dashboardAlertNotFound-js").css({"display": "inline", "visibility": "visible" });
                        } else {
                            if (alertsShown > 6) {
                                $(".dashboardShaded").addClass("maxHeight");
                            }
                        }
                    }
                }
                var announcementsResponse = response.announcements;
                if (announcementsResponse) {
                    var announcementContainer = $("#headerAnnouncements");
                    if (announcementContainer.exists() && announcementsResponse.total > 0) {
                        announcementContainer.css("visibility", "visible");
                        announcementContainer.find("a").html(announcementsResponse.total);
                    }
                    if (dashboard) {
                        var list = gadgetAnnouncements.find($(".dashboardSlider-js ul"));
                        list.empty();
                        if (announcementsResponse.total > 0) {
                            $.each(announcementsResponse, function(id, details) {
                                if (id != 'total') {
                                    var listItem = "<li class='announcement'><span class='fieldHeader'><a href='announcements.php#notification_" + details.id + "'>" + details.title + "</a></span><p>" + details.shortContent + "<p></li>";
                                    list.append(listItem);
                                }
                            });
                            carouselPagination(gadgetAnnouncements, 1, false, true, 1, "circular");
                        } else {
                            list.append("<li class='marginTop'>" + gadgetAnnouncements.data("message") + "</li>");
                        }
                    }
                }
                //Update the popup notification count total
                setNotificationTotal(response.pushNotifications.total);
            }
        },
        complete: function (){
            if (dashboard) {
                removeLoadingImage(gadgetAnnouncements);
                removeLoadingImage(gadgetAlerts);
            }
        }
    });
}

/**
 * To show progress on screen
 * @param {string} processingName
 * @param {int} companyID
 * @param {mixed} targetElement
 * @param {string} redirect
 * @param {array} showColumns
 * @param {int} timeout
 * in milliseconds
 * @returns array|bool
 */
function showProcessProgress(processingName, companyID, targetElement, redirect, showColumns, timeout) {
    if (typeof(timeout) === 'undefined') {
        timeout = 2000;
    }
    var data = {processingName: processingName, companyID: companyID};
    if (typeof showColumns !== 'undefined') {
        data.showColumns = showColumns;
    }
    $.ajax({
        type: "GET",
        url: "/common/ajax/showProcessProgress.php",
        async: false,
        data: data
    }).success(function(returndata) {
        var data = $.parseJSON(returndata);
        if (data.status !== undefined && data.status === 1) { // in progress
            $(targetElement).html(data.display);
            setTimeout(function(){
                showProcessProgress(processingName, companyID, targetElement, redirect, showColumns, timeout);
            }, timeout);
        } else {
            window.location.href = redirect;
        }
        if (data.error !== undefined) {
            hideLoadingImage();
            var dialog = createDialog("alert", data.error, gettext("Initial Import Error"));
            dialog.delegate('.dialogClose', 'click', function() {
                dialog.remove();
            });
        }
    });
}

/**
 * Returns match on browser type
 * @param string msie, webkit, opera, edge
 */
function getBrowser(type) {
    var navigator = window.navigator.userAgent.toLowerCase();
    switch(type) {
        case 'mozilla':
            return /mozilla/.test(navigator) && !/webkit/.test(navigator);
        case 'webkit':
            return /webkit/.test(navigator);
        case 'opera':
            return /opera/.test(navigator);
        case 'msie':
            return /(msie|rv:11)/.test(navigator);
        case 'edge':
            return /edge/.test(navigator);
        default:
            return false;
    }
}
/**
 * Determines whether to show the tinymce toolbar as two lines or one.
 */
function configureToolbar(editor) {
    if (editor) {
        var width = editor.contentAreaContainer.clientWidth;
        if (width > 0) {
            var $editor = $('#'+editor.id+'_tbl');
            if (width < 515) {
                $editor.addClass('toolbarDoubleRow');
            } else {
                $editor.removeClass('toolbarDoubleRow');
            }
        }
    }
}

function createSecurityDialog() {
    createDialog('alert', gettext('Your current session in this tab has expired, most likely because you have logged in to Simpro in another window or tab. Your session has been refreshed, but your most recent action has not been completed.'), gettext('Session expired'));
}
function map(mapData, page) {
    if ($.type(mapData)  === 'string') {
        mapData += '&ajaxCall=1';
    } else if ($.type(mapData)  === 'object') {
        mapData.ajaxCall=1;
    }
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: '/common/ajax/mapping.php',
        data: mapData
    }).success(function(data){
        mapAddress(data, page);
    }).error(function (jqXHR) {
        if (jqXHR.responseText == 'ValidationError') {
            createSecurityDialog();
        }
    });
}
/* test wether or not a string is a valid email */
function isEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function openTemplateForm($selected, $this) {
    var backlinkURL = getBackLinkURL(false);
    tinymce.triggerSave();
    var editTemplate = false;
    if ($this.hasClass("dialogConfirm")) {
        // handle with dialog
    } else {
        var container = $("#FormsFormContainer");
        var $openHash = $('#openHash');
        if ($selected.data("type") == "document") {
            var params = "editTemplate=true&";
            editTemplate = true;
        } else if ($selected.data("type") == "savedform") {
            var params = "editForm=true&formTmpName=" + $selected.data('tmpname') + "&";
            editTemplate = true;
        } else {
            if ($selected.data("popup")) {
                openFormPopup($selected);
            }
            else {
                var params = "formLoad=1";
                if(container.prop("target")) {
                    if($(container).closest(container.prop("target")).length == 0) {// forms container not within form
                        params += "&" + container.find("input, textarea, select").serialize();
                    }
                }
                formWindow = window.open('/staff/formLoad.php','formPage' + Date.now());
                window.top.focus();
                if ($selected.data('type') == 'csv') {
                    viewForm();
                } else if ($this.hasClass("viewForm")  || ($this.hasClass("openTemplate")) && !$selected.data("docx")) {
                    if(container.attr("target")) {
                        showLoadingImage();
                        ajaxSubmit($(container.attr("target")), params,'viewForm',false);
                    } else {
                        if (formWindow.addEventListener) {
                            formWindow.addEventListener( "load", function() { viewForm(); }, false );
                        } else if (formWindow.attachEvent) {
                            formWindow.attachEvent( "onload", function() { viewForm(); } );
                        } else if ( formWindow.onLoad ) {
                            formWindow.onload = function() { viewForm(); };
                        }
                    }
                } else if ($this.hasClass("viewFormDocx") || ($this.hasClass('openTemplate')) && $selected.data("docx")) {
                    if(container.attr("target")) {
                        showLoadingImage();
                        ajaxSubmit($(container.attr("target")), params,'viewFormDocx',false);
                    } else {
                        if (formWindow.addEventListener) {
                            formWindow.addEventListener( "load", function() { viewForm('docx'); }, false );
                        } else if (formWindow.attachEvent) {
                            formWindow.attachEvent( "onload", function() { viewForm('docx'); } );
                        } else if ( formWindow.onLoad ) {
                            formWindow.onload = function() { viewForm('docx'); };
                        }
                    }
                }
            }
        }
        if (editTemplate) {
            if(container.attr("target")) {
                var form = $(container.attr("target"));
            } else {
                var form = container;
            }
            var replaceString = 'formContent[]=';
            var replace = new RegExp(replaceString, 'g');

            // store toggle email form button status
            backlinkURL += "&attachFormEmail=" + $("#attachFormEmail").val();
            params += "cancelBackLink=" +
                encodeURIComponent(backlinkURL.replace(/formContent\[\]\=/g, "")) +
                "&" +
                form.find("input, textarea, select").serialize();
            let url = handlerFromUrl($selected, $("#ajaxSubmitURL").val());

            var $openHash = $('#openHash');
            if ($openHash.length) {
                params += "&openHash=" + $openHash.val();
            }
            showLoadingImage();
            $.ajax ({
                type:"POST",
                data: params,
                url: url,
                dataType: "json",
                success: function (response, statusText, xhr, $form) {
                    hideLoadingImage();
                    if (response.success) {
                        var documentForm = $("<form method='post' id='documentForm' action='onlyOfficeEdit.php'>");
                        $("<input type='hidden' name='configData'>").val(JSON.stringify(response)).appendTo(documentForm);
                        $("<input type='hidden' name='postData'>").val(form.find("input[name='to'], input[name='cc'], input[name='bcc'], #formSubject, #formDescription, #formContact, #selectedFormCustomer, #attachFormEmail").serialize()).appendTo(documentForm);
                        $("<input type='hidden' name='filterData'>").val(form.find(".formFilterData-js").serialize()).appendTo(documentForm);
                        $("<input type='hidden' name='readOnly' value='true'>").appendTo(documentForm);
                        $("<input type='hidden' name='userAction' value='editTemplate'>").appendTo(documentForm);
                        $("<input type='hidden' name='outdated'>").val($selected.data('outdated')).appendTo(documentForm);
                        if (form.find("input[name='iframe']").val()) {
                            $("<input type='hidden' name='iframe' value='true'>").appendTo(documentForm);
                        }
                        documentForm.appendTo("#content");
                        documentForm.submit().remove();
                    } else {
                        if (response.message) {
                            createDialog('alert', response.message, gettext('Loading Error'));
                            return false;
                        }
                    }
                }
            });
        }
    }
}

function attachForm(container, selected, params) {
    tinymce.triggerSave();
    var formURL;
    var data = "";
    if (selected.data("type") == "document") {
        formURL = handlerFromUrl(selected, $("#ajaxSubmitURL").val());
    } else if (selected.data("type") == "savedform") {
        formURL = handlerFromUrl(selected, $("#ajaxSubmitURL").val());
        data += '&formTmpName=' + selected.data("tmpname");
    } else {
        formURL = $("#formID").val();
    }
    if(typeof(container.attr("target")) !== 'undefined') {
        if(container.closest(container.attr("target")).length == 0) {// forms container not within form
            data += "&" + container.find("input, textarea, select").serialize();
        }
        data += "&" + $(container.attr("target")).find("input, textarea, select").serialize();
    } else {
        data += "&" + container.find("input, textarea, select").serialize();
    }

    if ($('#openHash').exists()) {
        data += "&openHash=" + $('#openHash').val();
    }
    data += params;
    showLoadingImage();
    $.ajax({
        type: "POST",
        url: formURL,
        data:  "attachForm=true&sessionName=" + $("#formAttachSessionName").val() + data,
        dataType: "json",
        success: function (response) {
            var txtMessage;
            if (response.success == false) {
                txtMessage = gettext('Error attaching form:') + '<br />' + response.message;
            } else {
                if (typeof response.message != 'undefined') {
                    txtMessage =  response.message;
                } else {
                    txtMessage = gettext('This form cannot be attached.');
                }
            }
            createDialog("alert", txtMessage, gettext("Attach Form"));
            hideLoadingImage();
            if (response.success) {
                ajaxSubmit(container, "attachForm=true&loadAttContainer=true" + data, null, false);
            } else {
                return false;
            }
        }
    });
}

function configureHotKeys() {
    $(".hotkey").each(function (index, item) {
        $(document).bind("keydown", item.id, function (e) {
            hotkeyTriggered = true
            e.stopPropagation();
            e.preventDefault();
            if ($(item).hasClass("dialogLink")) {
                item.click();
            } else if (item.target == "_blank") {
                window.open(item.href, item.text, "width=1175,height=740,left=100,top=100,screenX=100,screenY=100,resizable=no,scrollbars=yes");
            } else {
                openLink($(item).attr("href"));
            }
            return false;
        });
    });
}

function disableAutoFill(context) {
    $("input[type=text], input[type=search]", context).filter(":not([autocomplete])").attr("autocomplete","off");
}

function destroyDatePickers(input) {
    input.each(function(index, item) {
        $("#" + item.id + "DatePicker").remove();
        $(item).data("initialised", false).datepicker("destroy");
    });
}

function setupMultiSelect($this) {
    var data = $.parseJSON($this.attr('options'));
    var classes = $this.attr('class');
    classes = classes.replace("multiTag", "magicMultiTag");
    var allowFreeEntries = ($this.attr('data-allowFreeEntries') ? true : false);
    var validation = $this.data('validation');
    var hideTrigger = $this.data('hide-trigger') ? true : false;
    var placeholder = $this.attr('placeholder');
    var onSelectionChangeHandler = $this.attr('onselectionchange');

    if(typeof($this.attr("data")) != 'undefined') {
        var attributesValue = getItemSearchAttributesValue($this);
        var ms = $this.magicSuggest({
            callOnLoad:false,
            displayField: 'label',
            valueField: 'value',
            method: 'GET',
            toggleOnClick: true,
            allowFreeEntries:allowFreeEntries,
            maxSelection: $this.attr("maxSelectionLimit") !== undefined ? $this.attr("maxSelectionLimit") : 10,
            validation:validation,
            noSuggestionText:'',
            preselectSingleSuggestion: false,
            emptyText: placeholder !== undefined ? placeholder : '',
            hideTrigger: hideTrigger,
            renderer: function(v) {
                if(v.label === undefined) {
                    var label = '';
                } else {
                    var label = v.label;
                }
                return '<span class="label">'+label+'<br /><span style="display:block;color:#AAAAAA">'+v.description+'</span></span>'
            }
        });
        $(ms).on('beforeload', function(){
            if(this._dataSet === undefined){
                // we get here the first time the combo has loaded and gone through
                // the first if case in tag-autocomplete-service.php: the combo has been
                // populated with the default values only.
                this._dataSet = true;
                if (typeof ms.getDataUrlParams().searchType !== 'undefined') {
                    attributesValue['searchType'] = ms.getDataUrlParams().searchType;
                }
                ms.setDataUrlParams({
                    noResults:attributesValue['noResults'],
                    displayMode:attributesValue['displayMode'],
                    maxRowsType:attributesValue['maxRowsType'],
                    maxRows:attributesValue['maxRows'],
                    searchType:attributesValue['searchType'],
                    searchText: function() {
                        return ms.getRawValue();
                    }
                });
            }
        });
        ms.addToSelection(data);
    } else {
        var maxSel = 200;
        if ($this.attr("maxSelectionLimit") !== undefined) {
            maxSel = $this.attr("maxSelectionLimit");
        }
        if (data === '[]') {
            maxSel = -1;
            data = gettext('No results found.');
        }
        var ms = $this.magicSuggest({
            toggleOnClick: true,
            allowFreeEntries:allowFreeEntries,
            validation:validation,
            noSuggestionText:'',
            preselectSingleSuggestion: false,
            maxSelection:maxSel,
            emptyText: placeholder !== undefined ? placeholder : '',
            hideTrigger: hideTrigger,
            data:data
        });
    }
    if (classes.search("ajaxSubmit") != -1) {
        var params = $this.attr('params');
        ms.input.data('params', params);
        $(ms).on('selectionchange', function(e,m){
            ajaxSubmit(this.input, this.input.data('params'))
        });
        classes = classes.replace("ajaxSubmit", "");
    }

    if (onSelectionChangeHandler) {
        $(ms).on('selectionchange', function(e,m){
            eval(onSelectionChangeHandler);
        });
    }

    ms.input.addClass(classes);
    ms.input.data("magicSuggest", ms);
    ms.input.attr("data-cy",ms.getName().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('_'));
}

// always round .5 up
function toFixed ( number, precision ) {
    if (number.toString().indexOf(simPRODefaults.data('number-format-decimal')) !== -1) {
        var multiplier = Math.pow(10, precision + 1),
            wholeNumber = Math.floor(number * multiplier);
        return Math.round(wholeNumber / 10) * 10 / multiplier;
    } else {
        return number;
    }
}

function displayToastMessage(displayMessage, timeout, fadeIn, fadeOut) {
    if (typeof timeout == "undefined") {
        timeout = 1;
    }
    if (typeof fadeIn == "undefined") {
        fadeIn = 2000;
    }
    if (typeof fadeOut == "undefined") {
        fadeOut = 300;
    }
    window.setTimeout(function () {
        $("<div id='loadingItems' style='display:none'><div class='lightBox'><span class='icon-tick'></span> " + displayMessage + "</div></div>").appendTo("body").fadeIn(fadeIn, function () {
            $(this).fadeOut(fadeOut, function () {
                $(this).remove();
            });
        });
    }, timeout);
}

function handlerFromUrl($selected, formURL) {
    let returnUrl = formURL;
    let handlerFromUrl = returnUrl.split("/")[returnUrl.split("/").length - 1];
    if ($selected.data('ajax-submit-url') && handlerFromUrl) {
        returnUrl = returnUrl.replace(handlerFromUrl, $selected.data('ajax-submit-url'));
    }
    return returnUrl;
}

function closeQuicklink(openHashToClose, tabUrlToClose, save) {
    var context = $("li[class^='quickLinkItem'] span[openhash='" + openHashToClose + "']");

    $('#closeQuicklinkErrorBtn').attr('target', tabUrlToClose);

    var errorMsg = '';
    var title = '';
    $.ajax({
        type: "POST",
        data: {
            openHash: openHashToClose,
            isSave: save
        },
        url: "/common/ajax/closeQuicklinkTab.php",
        dataType: "json",
        async: false,
        success: function(responseBody) {
            if (responseBody.success === false) {
                title = responseBody.title;
                if (typeof responseBody.alertContent != 'undefined') {
                    errorMsg = responseBody.alertContent;
                } else {
                    errorMsg = '<p>' + (responseBody.hasOwnProperty('error')
                        ? responseBody.error
                        : gettext('Unexpected Error')) + '</p>';
                }
            } else {
                let message;
                if (save) {
                    message = gettext('Successfully saved and closed');
                } else {
                    message = gettext('Successfully closed');
                }
                window.setTimeout(function () {
                    $("<div id='loadingItems' style='display:none'><div class='lightBox'><span class='icon-tick'></span> " + message + "</div></div>").appendTo("body").fadeIn("2000", function () {
                        $(this).fadeOut("600", function () {
                            $(this).remove();
                        });
                    });
                }, 1);
                context.parent("li#quickLink_" + openHashToClose).remove();
            }
        },
        error: function() {
            errorMsg = '<p>' + (responseBody.hasOwnProperty('error')
                ? responseBody.error
                :  gettext('Please try again or close it directly.')) + '</p>';
        }
    });

    if (errorMsg !== '') {
        let redirect = tabUrlToClose + '&revalidate=1';
        errorMsg = ''
            + errorMsg
            + '<div class="textCenter">'
            + '<button data-cy="OK_Dialog" type="button" class="btnBlue dialogClose closeQuickLinkValidator" data-url="' + redirect + '">' + sprintf(gettext('Open %s'), title) + '</button>'
            + '</div>';
        createDialog('custom', errorMsg, sprintf(gettext("Unable to Close %s"), title));
    }
}

function autoSaveTrigger() {
    autoSaveTriggered = true;
    let debug = simPRODefaults.data('debug');
    let timeoutMs = debug
        ? 150000    // 2.5 mins
        : 300000;   // 5 mins
    let autoSaveTimer;
    resetTimer();
    if ($('#autosaveToggle').exists()) {
        setInterval(updateTimeAgo, 15000);
    }
    $(document).on("keypress mousemove scroll", function(e) {
        resetTimer();
    });

    function resetTimer() {
        if (debug) {
            console.log("Resetting Autosave Timer.");
        }
        clearTimeout(autoSaveTimer);
        autoSaveTimer = setTimeout(performAutoSave, timeoutMs);
    }

    function updateTimeAgo() {
        let timeAgo = $('#autosaveToggle').data('autosave-time-ago');
        if (timeAgo) {
            $('#timeAgoText').html(timeSince(new Date(timeAgo)));
        }

    }
    function timeSince(date) {

        const seconds = Math.floor((new Date() - date) / 1000);

        let interval = seconds / 31536000;
        let floorInterval = Math.floor(interval);
        if (interval > 1) {
            return floorInterval === 1 ? gettext('1 year ago') : sprintf(gettext('%s years ago'), floorInterval);
        }
        interval = seconds / 2592000;
        floorInterval = Math.floor(interval);
        if (interval > 1) {
            return floorInterval === 1 ? gettext('1 month ago') : sprintf(gettext('%s months ago'), floorInterval);
        }
        interval = seconds / 86400;
        floorInterval = Math.floor(interval);
        if (interval > 1) {
            return floorInterval === 1 ? gettext('1 day ago') : sprintf(gettext('%s days ago'), floorInterval);
        }
        interval = seconds / 3600;
        floorInterval = Math.floor(interval);
        if (interval > 1) {
            return floorInterval === 1 ? gettext('1 hour ago') : sprintf(gettext('%s hours ago'), floorInterval);
        }
        interval = seconds / 60;
        floorInterval = Math.floor(interval);
        if (interval > 1) {
            return floorInterval === 1 ? gettext('1 minute ago') : sprintf(gettext('%s minutes ago'), floorInterval);
        }
        floorInterval = Math.floor(seconds);
        return floorInterval === 1 ? gettext('1 second ago') : sprintf(gettext('%s seconds ago'), floorInterval);
    }

    function performAutoSave() {
        if (debug) {
            console.log("Autosaving...");
        }
        let autosaveToggle = $('#autosaveToggle');
        let autosave = $('#autosave');
        if ((autosaveToggle.exists() && autosaveToggle.is(":checked"))
            || (autosave.exists() && autosave.val() > 0)) {
            autoSave();
        } else {
            $.ajax({
                type: "POST",
                url: "../common/ajax/autosaveInactiveQuicklink.php",
                dataType: "json"
            });
        }
    }
}

/**
 * Adds handlers for the step nav vertical wizard
 * @param $context
 */
function setupVerticalWizard($context) {
    if (typeof $context === "undefined") {
        $context = $("#page");
    }

    $($context)
        // Prev step button handler
        .on('click', '.stepNavVert .backWizardPageBtn-js', function () {

            let pageNumber = $(this).data('page');
            // A page specific (optional) navigation callback
            let wizardNavCallback = $(this).data('wizard-nav-callback');

            // Change the visible page (no validation when going backwards)
            $(this)
                .closest('.stepNavVert')
                .addClass('hide')
                .siblings('.stepNavVert' + (pageNumber - 1))
                .removeClass('hide');

            // Allow callback on nav complete
            if (wizardNavCallback) {
                let $wizardWrap = $(this).closest('.stepNavVertWrap-js');
                window[wizardNavCallback]($wizardWrap, pageNumber - 1);
            }
        })
        // Next step button handler
        .on('click', '.stepNavVert .nextWizardPageBtn-js', function () {

            let pageNumber = $(this).data('page');
            let $thisStep = $(this).closest('.stepNavVert');
            let $wizardWrap = $(this).closest('.stepNavVertWrap-js');
            // Shared validation function, defaults to 'checkMandatory', can disable by setting to falsy value
            let wizardValidation = $wizardWrap.data('wizard-validation') ? $wizardWrap.data('wizard-validation') : 'checkMandatory';
            // A page specific (optional) navigation callback
            let wizardNavCallback = $(this).data('wizard-nav-callback');

            // Check if validation attribute non-falsy, if yes then run it first
            if (wizardValidation && !window[wizardValidation]($thisStep)) {
                return false;
            }

            // Show the next page (unless finish button, in which case its handled by callback)
            if ($(this).is('.finishWizardBtn-js') == false) {
                $thisStep
                    .addClass('hide')
                    .siblings('.stepNavVert' + (pageNumber + 1))
                    .removeClass('hide');
            }

            // Allow callback on nav complete
            if (wizardNavCallback) {
                window[wizardNavCallback]($wizardWrap, pageNumber + 1);
            }
        });
}

function updateAvailableFormFilters(onlineAcceptance)
{
    let formFilterBits = $('#formID').find(':selected').data('filter-bits');
    let filtersContainer = $('#filtersContainer');
    formFilterBits > 0 ? filtersContainer.show() : filtersContainer.hide();
    let filtersAvailable = filtersContainer.data('filters-available');
    $('.formFilter-js').each(function() {
        let filterBit = $(this).data('filter-bits');
        formFilterBits & filterBit & filtersAvailable ? $(this).show() : $(this).hide();
    });
    let filtersHeight = $(".formFilter-js:visible").length > 0 ? 145 : 100;
    let addWarningHeight = (onlineAcceptance == "1") ? 45 : 0;
    let formTemplateRowHeight = filtersHeight + addWarningHeight;
    $(".formTemplateRow").css({'min-height': formTemplateRowHeight + 'px'});
}

/**
 * Execute a function given a delay time
 * @param {type} func
 * @param {type} wait
 * @param {type} immediate
 * @returns {Function}
 */
function debounce(func, wait, immediate) {
    let timeout;
    return function () {
        let context = this, args = arguments;
        let later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

/**
 * Calculate whether to use black or white font
 */
function getReadableColorRGBJs(inputColor)
{
    let rInput = parseInt(inputColor.substr(1, 2), 16);
    let gInput = parseInt(inputColor.substr(3, 2), 16);
    let bInput = parseInt(inputColor.substr(5, 2), 16);

    let blackColor = "#000000";
    let rBlackColor = parseInt(blackColor.substr(1, 2), 16);
    let gBlackColor = parseInt(blackColor.substr(3, 2), 16);
    let bBlackColor = parseInt(blackColor.substr(5, 2), 16);

    // Calc contrast ratio
    let L1 = 0.2126 * Math.pow(rInput / 255, 2.2) +
        0.7152 * Math.pow(gInput / 255, 2.2) +
        0.0722 * Math.pow(bInput / 255, 2.2);

    let L2 = 0.2126 * Math.pow(rBlackColor / 255, 2.2) +
        0.7152 * Math.pow(gBlackColor / 255, 2.2) +
        0.0722 * Math.pow(bBlackColor / 255, 2.2);

    let contrastRatio = 0;
    if (L1 > L2) {
        contrastRatio = parseInt((L1 + 0.05) / (L2 + 0.05));
    } else {
        contrastRatio = parseInt((L2 + 0.05) / (L1 + 0.05));
    }
    if (contrastRatio > 5) {
        return '#232A2F';
    } else {
        return '#FFFFFF';
    }
}


/**
 * Updates modal component visibility and value
 *
 * @param bool isReadOnly
 * @param string elementName
 * @param Object modalContext
 * @param string contents
 * @param bool isSetVal
 * @param bool isHideByGroup
 * @param bool isMandatory
 */
function updateAccrualEditorComponent(
    isReadOnly,
    elementName,
    modalContext,
    contents,
    isSetVal = true,
    isHideByGroup = true,
    isMandatory = true
) {
    let editElement = modalContext.find('#' + elementName);
    let readOnlyElement = modalContext.find('#' + elementName + 'ReadOnly');
    let labelElement = modalContext.find('label[for="' + elementName + '"]');
    let labelText = labelElement.text();
    let isCurrentMandatory = labelText.charAt(0) === '*';
    if (isReadOnly) {
        readOnlyElement.show();
        readOnlyElement.text(contents);
        if (isSetVal) {
            editElement.val('');
        }
        if (isHideByGroup) {
            modalContext.find('#' + elementName + 'Group').hide();
        } else {
            editElement.hide();
        }
        if (isMandatory && isCurrentMandatory) {
            labelElement.text(labelText.substring(1));
            editElement.removeClass('mandatory');
        }
        labelElement.addClass('defaultCursor');
    } else {
        readOnlyElement.text('');
        readOnlyElement.hide();
        if (isHideByGroup) {
            editGroupComponent = modalContext.find('#' + elementName + 'Group').show();
        } else {
            editElement.show();
        }
        if (isSetVal) {
            editElement.val(contents);
        }
        if (isMandatory && !isCurrentMandatory) {
            labelElement.text('*' + labelText);
            editElement.addClass('mandatory');
        }
        labelElement.removeClass('defaultCursor');
    }
}

/**
 * Open the deferral editor modal to edit an existing deferral
 *
 * @param int journalNo
 * @param int invoiceID
 * @param int invoiceNo
 * @param string invoiceDate
 * @param string description
 * @param float value
 * @param float maxValue
 * @param string dateOfDeferral
 * @param string dateOfReversal
 * @param string departmentName
 * @param int depSecID
 * @param int incomeAccountID
 * @param int deferralAccountID
 * @param string incomeAccountName
 * @param string deferralAccountName
 * @param int accountingCategory
 * @param bool isDeferralExported
 * @param bool isReversalExported
 * @param float deferredPercentage
 * @param float deferralTotal
 * @param float totalValue
 */
function openDeferralEditorModal(
    journalNo,
    invoiceID,
    invoiceNo,
    invoiceDate,
    description,
    value,
    maxValue,
    dateOfDeferral,
    dateOfReversal,
    departmentName,
    depSecID,
    incomeAccountID,
    deferralAccountID,
    incomeAccountName,
    deferralAccountName,
    accountingCategory,
    isDeferralExported = false,
    isReversalExported = false,
    deferredPercentage,
    deferralTotal,
    totalValue
) {
    let editor = $('#deferralEditorModal');
    let isEitherExported = isDeferralExported || isReversalExported;
    let isReadOnly = $('#isReadOnly').val() == '1';
    let isExportedOrReadOnly = isEitherExported || isReadOnly;
    let modalNotice = $('#modalNoticeDeferral');
    let partialUpdateNotice = $('#partialUpdateNoticeDeferral');
    let deferralDateElement = editor.find('#deferralDateOfDeferral');
    let reversalDateElement = editor.find('#deferralDateOfReversal');
    let deferralValue = editor.find('#deferralValue');
    let closeBtn = editor.find('#deferralModalClose-js');
    let updateButton = editor.find('#updateDeferral-js');
    let selectAccountingCategory = editor.find('select[name="accountingCategory"]');

    // refresh Income tab
    modifiedProjected = true;
    /** Reset **/
    modalNotice.hide();
    updateButton.show();
    closeBtn.text(gettext('Cancel'))
        .removeClass('btnBlue')
        .addClass('btnGrey');
    editor.find('input:text, .mandatoryFail').removeClass('error');
    // Reset dialog error messages
    editor.find('.dialogErrorMessage').remove();
    editor.show();
    autoFocus(editor);
    $('#deferralAccountDefaultGroup').show();
    $('.hideOnLoad-js').hide();

    // Reset Accounting Category
    let hasAccountingCategory = selectAccountingCategory.length > 0;
    if (hasAccountingCategory) {
        editor.find('#accountingCategory').addClass('mandatory');
        selectAccountingCategory.find('option[value=-1]').prop('selected', true);
        selectAccountingCategory.suggestselect('refresh');
    }

    // Reset Dates
    if (getJSDate(invoiceDate) > getJSDate(dateOfDeferral)) {
        invoiceDate = dateOfDeferral;
    }
    deferralDateElement.datepicker('option', 'minDate', invoiceDate);
    deferralDateElement.datepicker('option', 'maxDate', null);
    reversalDateElement.datepicker('option', 'minDate', null);

    /** Apply Exported / Readonly **/
    if (isReadOnly || (isDeferralExported && isReversalExported)) {
        closeBtn.text(gettext('Close'))
            .removeClass('btnGrey')
            .addClass('btnBlue');
        updateButton.hide();
    }
    if (!isReadOnly) {
        if (isDeferralExported && isReversalExported) {
            partialUpdateNotice.text(gettext('This Deferral has been transferred to an accounting package and can no longer be edited'));
            modalNotice.show();
        } else if (isEitherExported) {
            partialUpdateNotice.text(gettext('This Deferral has been transferred to an accounting package, some fields can no longer be edited'));
            modalNotice.show();
        }
    }
    /** Set form fields **/
    // Journal ID
    editor.find('#deferralJournalNo').val(journalNo);
    // Invoice ID
    editor.find('#invoiceID').val(invoiceID);
    // deferred Percentage
    editor.find('#deferredPercentage').val(deferredPercentage);
    // deferral total
    editor.find('#deferralTotal').val(deferralTotal);
    // total value
    editor.find('#totalValue').val(totalValue);
    // current deferral value
    editor.find('#currentDeferralValue').val(value);
    // Invoice No
    updateAccrualEditorComponent(
        true, 'invoiceNo', editor, invoiceNo, false, false, false
    );
    // Description
    updateAccrualEditorComponent(
        isExportedOrReadOnly, 'deferralDescription', editor, description, true, false, false
    );
    // Value
    deferralValue.attr("maxValue", maxValue);
    updateAccrualEditorComponent(
        isExportedOrReadOnly, 'deferralValue', editor, value
    );
    if (isExportedOrReadOnly) {
        let valueReadOnly = editor.find('#deferralValueReadOnly');
        $(valueReadOnly).currencyFormat();
    } else {
        let valueEdit = editor.find('#deferralValue');
        $(valueEdit).numberFormat();
    }
    // Date of Deferral
    updateAccrualEditorComponent(
        isReadOnly || isDeferralExported, 'deferralDateOfDeferral', editor, dateOfDeferral
    );
    if (isReversalExported) {
        let reversalDate = dateOfReversal;
        if (dateOfDeferral != dateOfReversal) {
            let reversalDateObj = getJSDate(dateOfReversal);
            reversalDateObj.setDate(reversalDateObj.getDate() - 1);
            reversalDate = getFormattedDate(reversalDateObj)
        }
        deferralDateElement.datepicker('option', 'maxDate', reversalDate);
    }
    // Date of Reversal
    updateAccrualEditorComponent(
        isReadOnly || isReversalExported, 'deferralDateOfReversal', editor, dateOfReversal
    );
    if (!isReversalExported) {
        reversalDateElement.datepicker('option', 'minDate', dateOfDeferral);
    }
    // Cost Centre Name
    updateAccrualEditorComponent(
        true, 'costCentreName', editor, departmentName, false, false, false
    );
    $('#depSecIDDeferral').val(depSecID);
    // Income Account
    updateAccrualEditorComponent(
        true, 'deferralRevenueAccountID', editor, incomeAccountName, false, false, false
    );
    // Deferral Account
    let selectDeferralAccount = editor.find('select[name="deferralAccountOptions"]');
    let findSelectDeferralAccount = selectDeferralAccount.find('option[value=' + deferralAccountID + ']');
    if (findSelectDeferralAccount.length === 0) {
        selectDeferralAccount.removeClass('mandatory');
    } else {
        findSelectDeferralAccount.prop('selected', true);
    }
    editor.find('input[name="deferralDeferralAccountID"]').val(deferralAccountID);
    if (deferralAccountName === null) {
        deferralAccountName = selectDeferralAccount.find('option[value=' + deferralAccountID + ']').text();
    }
    editor.find('#deferralAccountLabel').text(deferralAccountName);
    selectDeferralAccount.suggestselect('refresh');
    let selectedDeferralLabel = selectDeferralAccount.find('option[value=' + deferralAccountID + ']').text();
    if (selectedDeferralLabel.length === 0) {
        selectedDeferralLabel = deferralAccountName;
    }
    updateAccrualEditorComponent(
        isExportedOrReadOnly, 'deferralDeferralAccountID', editor, selectedDeferralLabel, false
    );
    // Accounting Category
    if (hasAccountingCategory) {
        if (Number(accountingCategory) <= 0) {
            accountingCategory = -1;
        }
        selectAccountingCategory.find('option[value=' + accountingCategory + ']').prop('selected', true);
        selectAccountingCategory.suggestselect('refresh');
        let selectedAccountCategoryLabel = selectAccountingCategory.find('option[value=' + accountingCategory + ']').text();
        if ((isExportedOrReadOnly && accountingCategory == -1) || (selectAccountingCategory.find('option:not(.hide)').length <= 1 && accountingCategory == -1))  {
            editor.find('#accountingCategoryRow').hide();
            editor.find('#accountingCategory').removeClass('mandatory');
        } else {
            editor.find('#accountingCategoryRow').show();
            updateAccrualEditorComponent(
                isExportedOrReadOnly, 'accountingCategory', editor, selectedAccountCategoryLabel, false
            );
        }
    }
}
window.openDeferralEditorModal = openDeferralEditorModal;
window.updateAccrualEditorComponent = updateAccrualEditorComponent;
